import { solicitarBienvenida } from './lib/correosBienvenida';
import { destinoBienvenida } from './lib/bienvenida';
import { prepararRetornoPlanes, consumirRetornoPlanes, CLAVE_RETORNO_PLANES } from './lib/retornoPlanes';
import { useState, useEffect, useRef, useCallback, useMemo, lazy, Suspense } from "react";
import { getOrCreateSessionId, clearSession } from "./utils/session";
import { setTrackingContext, trackEvent, setMundoTracking } from "./lib/eventTracking";
import { MODULOS } from "./lib/modulos";
import { miTurnoEsCapaTens, esTens } from "./lib/tens";
import { useStepTimer } from "./hooks/useStepTimer";
import { useNudges } from "./hooks/useNudges";
import { nudgesDelPerfil } from "./lib/nudges";
import { StepHome } from "./components/Home";
import PremiumPaywall from "./components/PremiumPaywall";
import PlusBadge from "./components/PlusBadge";
import { nombreMembresia, PRODUCTOS_PLUS } from "./lib/productosPlus";
import AvisoTrial from "./components/AvisoTrial";
import AvisoLanzamientoPlus from "./components/AvisoLanzamientoPlus";
import { isNative, platform } from "./lib/platform";
import { App as CapApp } from "@capacitor/app";
import { cargarConfigRemota } from "./lib/configRemota";
import { debePedirActualizar } from "./lib/versionApp";
import { campanaVigente } from "./lib/notificacionesLanzamiento";
import { pruebaPara } from "./lib/invitacionMembresias";
import ActualizaMiPAE from "./components/ActualizaMiPAE";
import { useTheme } from "./contexts/ThemeContext";
import { cargarApariencia, guardarApariencia, aparienciaIgual } from "./lib/apariencia";
import { debeOfrecerInstalacion, debeMostrarInstruccionesSafari } from "./lib/instalarPwa";
import { enTransicionEstudiante, verificarMiPago, obtenerUsoMes, obtenerUsoPautaMes, puedeAccederIA, tieneAccesoPlus, esMipaePlus, esPremium, trialDisponible, accesoPlusAbierto } from "./lib/plan";
import { nombreServicio } from "./constants/rotaciones";
import { puedeAbrir } from "./lib/accessGate";
import { Droplets } from "lucide-react";
import { recordarModelo, esModeloValoracion } from "./lib/paeModelos";
import { esCapaEjercicio, esElegibleTurno, veMisPaes, veJefatura, veDialisis, veEnTurnoEstudiante } from "./lib/perfil";
import { preparaDelMenu, veMomentoEstudiante } from "./lib/homeExplora";
import { segundaPestana, recordarSegundaPestana, segundaPestanaRecordada } from "./lib/navegacionMundo";
import { capaDelPerfil } from "./lib/capaHeader";
import { perfilParaMundo, estaDeVisita, casaDe, puedeEstarEn, nombreMundo, mundosHabilitados } from "./lib/mundos";
import { tieneEnciclopediaCompleta } from './lib/accesoEnciclopedia';
import BandaMundo from "./components/BandaMundo";
import { perfilParaReanudar } from "./lib/onboardingAgente";
import { pingGeo } from "./lib/geoPing";
import { capturarAtribucion, atribucionParaPayload } from "./lib/landingTracking";
import { intencionDesdeUrl, nombreIntencion } from "./lib/intencionMembresia";
import { registrarEmbudo } from "./lib/embudoMembresias";
import SelloAnimado from "./components/SelloAnimado";
import LockupHeader from "./components/LockupHeader";
import PresenciaBenito from "./components/PresenciaBenito";
import { useToast } from "./components/foundational/Toast";
import { registrarEvento, listarPAEs, cargarPAE } from "./lib/pae";
import { normalizarValoresPae } from "./lib/paeNormalizar";
import {
  borradorParaGuardar, borradorTieneDatos, detalladoTieneDatos, rapidoTieneDatos, esSesionDetallado, haceCuanto,
  modoDelBorrador, nombreDelBorrador, PREFIJO_SESION_DETALLADO,
} from "./components/pae-detallado/borradorPae";
import { supabase } from "./lib/supabase";
import { clearLocalMipaeKeys, clearNativeMipaeKeys, PREFERENCIAS_DISPOSITIVO } from "./lib/account";
import { signInWithGoogle, signInWithApple, initDeepLinkAuth, APPLE_LOGIN_DISPONIBLE, GOOGLE_LOGIN_DISPONIBLE } from "./lib/nativeAuth";
import { initLocalNotifications, programarRecordatoriosTurno, programarTips, fijarContextoLanzamiento, escucharToqueNotificacion } from "./lib/notifications";
import { initPush } from "./lib/push";
import { initNativeUI } from "./lib/nativeUI";
import { getSessionConTimeout, safeInit, safeInvoke } from "./lib/startup";
import { registrarMetrica } from "./lib/metrics";
import { getAutoFocoTurno, cargarRegistros, camaActivaTurno, guardarRegistros, borrarRemoto, flushEscriturasTurno } from "./lib/registroTurnoStore";
import { hayActividadDeTurno, novedadesVigentes } from "./lib/queCambio";
import { resolverNovedadesVistas } from "./lib/novedadesCuenta";
import NovedadesDetalle from "./components/NovedadesDetalle";
import { carrilDe, superficieDe, tourPendiente, marcarTourVisto } from "./lib/onboardingRol";
import { sanitizarCama, purgarExpirados, borrarMarcasLocales } from "./lib/registroTurno";
import { purgarTensVencido, tensConTurnoAbierto } from "./lib/tensRegistro";
import { paePrefillDesdeTurno } from "./lib/turnoPaeBridge";
import { registrarPaeGuardado, encuestaMomentoHabilitada } from "./lib/microEncuestas";
import EncuestaRamo from "./components/EncuestaRamo";
import { publicarWidget } from "./lib/widgetBridge";
import { EVENTO_BENITO_PREGUNTA } from "./lib/benitoBus";
import { SHELL_ESCRITORIO_ENABLED } from "./lib/shellEscritorio";
import { resolverArranque, formDataAlIniciarRapido } from "./lib/paeArranque";
import { calcularTurnoDelDia, overrideDelDia, addDays, toDateKey } from "./utils/calendario";
import Button from "./components/foundational/Button";
import Heading from "./components/foundational/Heading";
import IconButton from "./components/foundational/IconButton";
import Modal from "./components/foundational/Modal";
import Banner from "./components/foundational/Banner";
import MenuItem from "./components/foundational/MenuItem";
import BottomTabBar from "./components/foundational/BottomTabBar";
import useTecladoAbierto from "./hooks/useTecladoAbierto";
import Card from "./components/foundational/Card";
import Badge from "./components/foundational/Badge";
import RevisaFab from "./components/RevisaFab";
import WhatsAppFlotante from "./components/presentacion/WhatsAppFlotante";
import {
  Menu, X, Zap, ChevronLeft, ChevronDown, Sparkles, PenLine, BookOpen,
  Lightbulb, LogOut, Lock, Clock, ClipboardList, House, UserCircle,
  RefreshCw, Download, WifiOff, ArrowUpFromLine, Calendar, Activity, Plus, Check, Moon, Sun, BarChart2, TrendingUp, Search, Wind, Pill, GraduationCap, ShieldCheck,
  FlaskConical, Syringe, ShieldAlert, Sigma, ListChecks, ClipboardCheck, Heart, Mic, Layers, Bandage, FileText, ChevronRight, Settings2,
  BookMarked, HeartHandshake, Library, ArrowLeftRight, Building2, MessageCircle, Tag,
} from "lucide-react";
import CommandPalette from "./components/CommandPalette";
import { itemBuscadorPaliativos, itemBuscadorAccesos } from "./lib/borradores";
import TemaSelector from "./components/TemaSelector";
import useSpotlightData from "./components/useSpotlightData";
import { getRecientes, addReciente, addVistaGes } from "./lib/recientes";
import { CALCULADORAS_SLUGS } from "./components/laboratorio/calculadoras";
import { ESCALAS } from "./components/escalas/catalogo";

// Lazy-loaded — solo se descargan cuando el usuario navega a esa sección
const QueEsMiPAE          = lazy(() => import("./components/QueEsMiPAE"));
const Contacto            = lazy(() => import("./components/presentacion/Contacto"));
const ParaInstituciones   = lazy(() => import("./components/presentacion/ParaInstituciones"));
const PaeDetallado        = lazy(() => import("./components/pae-detallado"));
const Estudio             = lazy(() => import("./components/estudio/Estudio"));
const AdminMetrics        = lazy(() => import("./pages/AdminMetrics"));
const MiProgreso          = lazy(() => import("./pages/MiProgreso"));
const LegalPages          = lazy(() => import("./components/LegalPages"));
const PreparaInternado    = lazy(() => import("./components/PreparaInternado"));
const PreparaPractica     = lazy(() => import("./components/PreparaPractica"));
const PreparaExamen       = lazy(() => import("./components/PreparaExamen"));
const Perfil              = lazy(() => import("./components/Perfil"));
const OnboardingAgente    = lazy(() => import("./components/OnboardingAgente"));
const CompaneroGlobal     = lazy(() => import("./components/CompaneroGlobal"));

// Contenido de estudio (tutor de fichas, quiz GES, explica lab, Estudio):
// GRATIS para todos desde MiPAE extendido (D1, 2026-09-14). Los props
// `isMipaePlus`/`onRequierePlus` de esos módulos NO se desmontan: quedan
// fijos en true/no-op desde acá, y son la palanca para el día en que esas
// capas se cobren (basta volver a pasar el estado real).
const CONTENIDO_ESTUDIO_ABIERTO = true;
const requierePlusNoop = () => {};
// Las hojas de límite que son del PAE (Rápido, Detallado y con tu pauta).
const FEATURES_PAE = Object.freeze(['pae', 'detallado', 'pauta']);
const PanelUsuario        = lazy(() => import("./components/PanelUsuario"));
const MisPaes             = lazy(() => import("./components/MisPaes"));
const TuPae               = lazy(() => import("./components/TuPae"));
const Ajustes             = lazy(() => import("./components/Ajustes"));
const TuOpinion           = lazy(() => import("./components/TuOpinion"));
const HomeTens            = lazy(() => import("./components/tens/HomeTens"));
const Planes              = lazy(() => import("./components/Planes"));
const LoNuevoMiPAE        = lazy(() => import("./components/membresias/LoNuevoMiPAE"));
// Una sola referencia vacía: los avisos del 25 no se reprograman por un [] nuevo.
const SIN_OVERRIDES = [];
const Revisa              = lazy(() => import("./components/revisa/Revisa"));
const LaboratorioInteractivo = lazy(() => import("./components/laboratorio/LaboratorioInteractivo"));
const OnboardingVideo     = lazy(() => import("./components/onboarding/OnboardingVideo"));
const CalendarioConfig    = lazy(() => import("./components/calendario/CalendarioConfig"));
const CalendarioVista     = lazy(() => import("./components/calendario/CalendarioVista"));
const Escalas             = lazy(() => import("./components/escalas/Escalas"));
const PreparaTurno        = lazy(() => import("./components/preparaTurno/PreparaTurno"));
const PreparaTurnoGuia    = lazy(() => import("./components/preparaTurno/PreparaTurnoGuia"));
const EnTurnoEstudiante   = lazy(() => import("./components/preparaTurno/EnTurnoEstudiante"));
const DemoPublica = lazy(() => import("./components/DemoPublica"));
const EntregaTurno        = lazy(() => import("./components/preparaTurno/EntregaTurno"));
const EvolucionSistema    = lazy(() => import("./components/preparaTurno/EvolucionSistema"));
const RegistroTurno       = lazy(() => import("./components/preparaTurno/RegistroTurno"));
const Bitacora            = lazy(() => import("./components/bitacora/Bitacora"));
const RetoDelDia          = lazy(() => import("./components/RetoDelDia"));
const Respira             = lazy(() => import("./components/Respira"));
const BienestarHome       = lazy(() => import("./components/bienestar/BienestarHome"));
const PracticaGuiada      = lazy(() => import("./components/bienestar/PracticaGuiada"));
const Fichas              = lazy(() => import("./components/fichas/Fichas"));
const Ges                 = lazy(() => import("./components/ges/Ges"));
const ReferenciaRapida    = lazy(() => import("./components/referencia/ReferenciaRapida"));
const CuentaEliminada     = lazy(() => import("./components/CuentaEliminada"));
const VoiceDocLab         = lazy(() => import("./components/labs/VoiceDocLab"));
const TableroJefatura     = lazy(() => import("./pages/TableroJefatura"));
const Dialisis            = lazy(() => import("./pages/Dialisis"));
const ConfirmacionEdad    = lazy(() => import("./components/ConfirmacionEdad"));
const DisclaimerPAE       = lazy(() => import("./components/DisclaimerPAE"));
const FooterRecordatorio  = lazy(() => import("./components/FooterRecordatorio"));

const FAB_DISMISSED_KEY = "mipae:revisaFab:dismissed";

// Módulo Bienestar (plan docs/plan-bienestar-modulo.md, 2026-09-23): la
// pestaña Bienestar abre un home propio (Respira, pausas guiadas, Bitácora)
// en vez del popover de dos filas. Kill-switch REAL, ON por defecto: con
// 'false' vuelve el popover de siempre, intacto (bienestarOpen, el onClick de
// la pestaña y el botón del shell de escritorio siguen vivos detrás de este
// flag). Lección de REACT_APP_NAV_V2: un flag que al apagarse deja la app
// apuntando a algo que no existe no es una salida de emergencia.
const BIENESTAR_MODULO_ENABLED = process.env.REACT_APP_BIENESTAR_MODULO_ENABLED !== 'false';

// Navegación pública (2026-10-30, pedido de Sebastián): quien entra a la web
// sin sesión veía la barra de pestañas y el menú entero de la app (PAE, turno,
// Bitácora, con candados), y eso confundía. Para el visitante de la web la
// navegación es la de un sitio: ¿Qué es MiPAE?, Para instituciones, Planes,
// Contacto, entrar o crear cuenta, más las herramientas que se abren sin cuenta.
// Con sesión no cambia nada. Ocultar opciones no es un control de acceso: cada
// pantalla con cuenta sigue con su propia guarda (abrirOLogin, irAModulo,
// session && …). La app instalada conserva su navegación de siempre (ahí el
// visitante solo está de paso hacia el acceso). Kill-switch ON por defecto.
const NAV_PUBLICA_ENABLED = process.env.REACT_APP_NAV_PUBLICA_ENABLED !== 'false';

// Las páginas públicas del sitio, con ruta propia. /instituciones solo en la
// web (en la app instalada no se ofrece nada que suene a venta).
const RUTAS_PUBLICAS = { '/contacto': 'contacto', ...(isNative ? {} : { '/instituciones': 'instituciones' }) };

// Dónde aparece el WhatsApp flotante de la web pública y cuál es el bloque de
// esa página que ya trae los canales (el botón se aparta cuando está a la
// vista).
const PIE_FLOTANTE = { home: 'pie-mipae', 'que-es-mipae': 'que-es-datos', instituciones: 'instituciones-escribenos' };

// Única fuente de verdad para el routing post-auth.
// Llamada desde getSession() y desde el handler SIGNED_IN por igual.
// Lo que la app dice al volver de Flow (?pago=). Catálogo cerrado; un valor
// desconocido no muestra nada.
const MENSAJES_PAGO = {
  prueba: { tono: 'info', texto: 'Estamos comprobando el registro de tu tarjeta y la activación de tu prueba.' },
  ok:        { tono: 'info', texto: 'Estamos verificando el pago. Tu plan se activa cuando recibimos la confirmación.' },
  pendiente: { tono: 'info', texto: 'Estamos verificando el pago. Tu plan se activa cuando recibimos la confirmación.' },
  tarjeta:   { tono: 'error',   texto: 'No se pudo registrar la tarjeta. No se cobró nada; puedes intentarlo de nuevo desde Planes.' },
  error:     { tono: 'error',   texto: 'No pudimos completar el pago. Si te cobraron, escríbeme a contacto@mipae.cl y lo resolvemos.' },
};

// La única unidad del PAE Detallado (P3, 2026-10-04): la pantalla "Elige tu
// unidad" se retiró porque las otras dos eran "Próximamente". El Detallado
// está pensado para el paciente crítico.
const UNIDAD_DETALLADO = "uci";

// Tiempo en segundo plano que cuenta como "abrir la app de nuevo" para volver
// a la casa (tres mundos, M5).
const VUELTA_A_CASA_MS = 30 * 60 * 1000;

function resolveAuthState(profile, pathname, hash = (typeof window !== "undefined" ? window.location.hash : "")) {
  if (pathname === '/admin/metrics' && ['admin', 'owner'].includes(profile?.role)) return "admin";
  if (!profile?.edad_confirmada_18) return "confirmacion-edad";
  if (!profile?.perfil_completado)  return "perfil";
  // POC MiPAE Voice: solo admin (además de la entrada en el menú Admin).
  if (pathname === '/labs/voz' && ['admin', 'owner'].includes(profile?.role)) return "labs-voz";
  // Preview del video del tour (#onboarding): herramienta interna, solo admin,
  // igual que /labs/voz (E14). Antes lo abría cualquiera, con o sin cuenta.
  if (hash === '#onboarding' && ['admin', 'owner'].includes(profile?.role)) return "onboarding-preview";
  // Panel de gestión (antes "tablero de la jefatura", 2026-09-10): página propia. Admin/owner y quien
  // tenga el permiso acotado `ve_jefatura` (una jefatura real sin ser admin).
  if (pathname === '/jefatura' && veJefatura(profile)) return "jefatura";
  // Diálisis (2026-09-21): pantalla propia, APARTE del turno. El team de
  // terapias extracorpóreas no tiene turno abierto ni camas propias.
  if (pathname === '/dialisis' && veDialisis(profile)) return "dialisis";
  return "home";
}

// getSessionConTimeout / leerSesionPersistida viven en lib/startup.js (movidos
// para poder testear la resiliencia de arranque en aislamiento).

// PAERapido usa named exports — apuntan al mismo archivo → webpack los agrupa en un chunk
const RapidoStep1      = lazy(() => import("./components/PAERapido").then(m => ({ default: m.RapidoStep1 })));
const RapidoStep2Libre = lazy(() => import("./components/PAERapido").then(m => ({ default: m.RapidoStep2Libre })));
const RapidoStep3      = lazy(() => import("./components/PAERapido").then(m => ({ default: m.RapidoStep3 })));
const RapidoResumen    = lazy(() => import("./components/PAERapido").then(m => ({ default: m.RapidoResumen })));


const GoogleIcon = () => (
  <svg width="18" height="18" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path d="M22.56 12.25c0-.78-.07-1.53-.2-2.25H12v4.26h5.92c-.26 1.37-1.04 2.53-2.21 3.31v2.77h3.57c2.08-1.92 3.28-4.74 3.28-8.09z" fill="#4285F4"/>
    <path d="M12 23c2.97 0 5.46-.98 7.28-2.66l-3.57-2.77c-.98.66-2.23 1.06-3.71 1.06-2.86 0-5.29-1.93-6.16-4.53H2.18v2.84C3.99 20.53 7.7 23 12 23z" fill="#34A853"/>
    <path d="M5.84 14.09c-.22-.66-.35-1.36-.35-2.09s.13-1.43.35-2.09V7.07H2.18C1.43 8.55 1 10.22 1 12s.43 3.45 1.18 4.93l2.85-2.22.81-.62z" fill="#FBBC05"/>
    <path d="M12 5.38c1.62 0 3.06.56 4.21 1.64l3.15-3.15C17.45 2.09 14.97 1 12 1 7.7 1 3.99 3.47 2.18 7.07l3.66 2.84c.87-2.6 3.3-4.53 6.16-4.53z" fill="#EA4335"/>
  </svg>
);

export default function MiPAE() {

  const [session, setSession]       = useState(undefined);
  const [appState, setAppState]     = useState("home");
  // Onboarding: si el usuario prefiere el formulario clásico al agente conversacional.
  const [perfilModoForm, setPerfilModoForm] = useState(false);
  const [respiraContexto, setRespiraContexto] = useState("generico");
  // Técnica (y duración) con que se abre Respira desde el home de Bienestar:
  // salta la pantalla de elegir técnica. null = el flujo de siempre.
  const [respiraTecnica, setRespiraTecnica] = useState(null);
  const [respiraDuracion, setRespiraDuracion] = useState(null);
  // ¿Respira se abrió DESDE el home de Bienestar (o una pausa)? Solo entonces su
  // Volver dice "Bienestar" y regresa ahí. Se decide en abrirRespira con el
  // estado de origen, no con el flag global: con el flag ON, Respira también se
  // abre desde MiPAE en turno, el PAE, la Bitácora y el buscador, y a esa persona
  // un botón "Bienestar" que la devuelve a MiPAE en turno le miente (revisión 2026-09-23).
  const [respiraDesdeBienestar, setRespiraDesdeBienestar] = useState(false);
  // Pausa guiada abierta (appState "practica").
  const [practicaId, setPracticaId] = useState(null);
  // Días cambiados a mano del calendario (ayer y hoy), para que el momento
  // del home de Bienestar no afirme un turno que la persona ya cambió. Solo
  // se piden al entrar al módulo.
  const [overridesBienestar, setOverridesBienestar] = useState([]);
  const [calendarioDiaInicial, setCalendarioDiaInicial] = useState(null);
  const [etapaDemo, setEtapaDemo] = useState("estudiante");
  const [step, setStep]             = useState(0);
  const [, setUnit]                 = useState(null);
  const [formData, setFormData]     = useState({});
  const [selected, setSelected]     = useState([]);
  const [esNuevoPAE, setEsNuevoPAE] = useState(false);
  const [paeIdActual, setPaeIdActual] = useState(null);
  // Puente MiPAE en turno → PAE: señala en el paso 1 de dónde vino el prefill
  // ({ cama } | null). Se limpia en cualquier salida/inicio de un PAE que no
  // venga del turno, para no arrastrar el banner a un PAE nuevo o distinto.
  const [origenTurno, setOrigenTurno] = useState(null);
  const [anamnesisIA, setAnamnesisIA] = useState(null);
  const [borradorPendiente, setBorradorPendiente] = useState(null);
  const [paeGuardadoFinal, setPaeGuardadoFinal]   = useState(false);
  // Qué del PAE Rápido quedó en la cuenta ({ paeId, huella }): el resumen se
  // desmonta al volver al plan y esta memoria le dice, al volver, si su fila
  // ya existe y si cambió (mismo patrón que `registroGuardado` del Detallado).
  const registroRapidoRef = useRef(null);
  // Salir del PAE Detallado desde su primer paso con algo escrito pregunta
  // antes (auditoría 4-oct-2026): salir limpia lo escrito.
  const [confirmarSalirPae, setConfirmarSalirPae] = useState(false);
  // Micro encuesta del 3er PAE (ítem 10 del BACKLOG): qué módulo la pinta bajo
  // su resumen ('pae_rapido' | 'pae_detallado') o null. La decide el contador
  // local de guardados NUEVOS (lib/microEncuestas.js); jamás al reabrir.
  const [encuestaRamoModulo, setEncuestaRamoModulo] = useState(null);
  const sessionIdRef = useRef(null);

  // ── Profile ──────────────────────────────────────────────────────────────────
  const [profile, setProfile] = useState(null);

  // ── Tres mundos (docs/plan-tres-mundos.md) ───────────────────────────────────
  // MiPAE Estudiante, MiPAE Enfermero y MiPAE TENS en una sola app. La casa es
  // el rol; desde Mi perfil se puede pasar a otro mundo. El mundo vive SOLO
  // aquí, en memoria: al abrir la app siempre se vuelve a la casa (M5).
  // `perfilMundo` decide lo que se PINTA (inicio, menú, firma, buscador,
  // Benito, cuotas de IA: lo pagado vale solo en casa, M3); `profile` sigue
  // mandando en datos, guardado, edición, identidad y permisos (admin,
  // jefatura). En casa `perfilMundo` ES `profile` (misma referencia).
  const [mundo, setMundo] = useState(null);
  // De dónde se llegó a "Lo nuevo de MiPAE" (aviso, correo, menú), solo para medir.
  const [loNuevoOrigen, setLoNuevoOrigen] = useState("aviso");
  // Lo que la app instalada sabe del servidor (lib/configRemota.js): el
  // interruptor del 25 y la versión mínima. `pedirActualizar` es el candado.
  const [configRemota, setConfigRemota] = useState(null);
  const [versionInstalada, setVersionInstalada] = useState(null);
  const [pedirActualizar, setPedirActualizar] = useState(null);
  const perfilMundo = useMemo(() => perfilParaMundo(profile, mundo), [profile, mundo]);
  const enciclopediaCompleta = tieneEnciclopediaCompleta(profile);
  const deVisita = estaDeVisita(profile, mundo);
  // La capa del header (lib/capaHeader.js): su símbolo va dentro del botón que
  // vuelve al inicio, y los hijos de un botón no se leen, así que la capa
  // llega al lector de pantalla por el nombre del botón.
  const capaHeader = session && profile?.perfil_completado ? capaDelPerfil(perfilMundo) : null;
  const espacioHeaderRef = useRef(null);
  // MiPAE en turno abre la capa TENS si la persona ES TENS (perfil real: la
  // frontera del rol no se cruza cambiando de mundo) o si está de visita en
  // MiPAE TENS.
  const turnoEsCapaTens = miTurnoEsCapaTens(profile) || miTurnoEsCapaTens(perfilMundo);
  // El PAE vive en MiPAE Estudiante (decisión del fundador 2026-10-16): ni
  // MiPAE Enfermero ni MiPAE TENS lo ofrecen en el menú, el buscador, el
  // inicio, Modelos ni Benito. Se mira el MUNDO, así que una enfermera que
  // pasa a MiPAE Estudiante sí lo ve y lo usa. Nada se borra: los PAEs
  // guardados siguen en la cuenta y se abren desde MiPAE Estudiante.
  // Con los mundos apagados (interruptor de emergencia) no hay a dónde pasar,
  // así que el PAE y Tus PAEs vuelven a estar en la casa de todos: los
  // Términos prometen que nadie pierde el acceso a lo que ya creó.
  const mundosOn = mundosHabilitados();
  const paeEnEsteMundo = !mundosOn || (!esCapaEjercicio(perfilMundo) && !esTens(perfilMundo));
  const veTusPaes = !mundosOn || veMisPaes(perfilMundo);
  const puedePasarAEstudiante = puedeEstarEn(profile, "estudiante");
  // El cupo del PAE sigue a la CASA cuando la casa no tiene PAE. El paso 1 de
  // la interfaz por experiencia no cambia el acceso de nadie: una enfermera o
  // un TENS que ahora arma su PAE pasando a MiPAE Estudiante tiene el mismo
  // cupo que tenía en su casa (y su hoja de límite, sin venta), no el del
  // estudiante. Es lo mismo que ya mide el servidor, que lee el perfil real.
  // Qué cupo corresponde a cada experiencia se decide en el paso 3.
  // Vale SOLO mientras dure el acceso abierto: desde el 25 de octubre los
  // Términos dicen que MiPAE Estudiante tiene 1 PAE al mes para todas las
  // cuentas, y el fundador definió el 16-oct que lo pagado depende de la
  // membresía y de la experiencia, no de la profesión.
  const cupoPaeDeCasa = deVisita && (esCapaEjercicio(profile) || esTens(profile)) && accesoPlusAbierto();
  const perfilCupoPae = cupoPaeDeCasa ? profile : perfilMundo;

  const cargarProfile = async (userId) => {
    const { data } = await supabase
      .from("profiles")
      // universidad/servicio: sin leerlos, editar el perfil los escribía en
      // null (Perfil.jsx nace de perfilInicial); created_at: el NPS espera a
      // que el usuario lleve una semana antes de preguntar.
      .select("user_id, nombre, rol, role, institucion, etapa_internado, anio_carrera, universidad, servicio, perfil_completado, cohort_id, canal_denuncias_universidad, edad_confirmada_18, disclaimer_pae_rapido_aceptado, disclaimer_pae_detallado_aceptado, plan, premium_until, premium_product, trial_started_at, trial_ends_at, trial_product, trial_con_tarjeta, created_at, ve_jefatura, onboarding_visto_at")
      .eq("user_id", userId)
      .maybeSingle();
    return data;
  };

  const refetchPerfil = async () => {
    if (!session?.user?.id) return;
    const p = await cargarProfile(session.user.id);
    setProfile(p);
  };

  // ── Rotación activa ───────────────────────────────────────────────────────────
  const [rotacion, setRotacion] = useState(null);

  const cargarRotacion = async (userId) => {
    const { data } = await supabase
      .from('rotaciones')
      .select('*')
      .eq('user_id', userId)
      .eq('activa', true)
      .maybeSingle();
    return data;
  };


  // ── Event tracking — PAE Rápido pasos ────────────────────────────────────────
  const rapidoTimer   = useStepTimer();
  const rapidoPrevRef = useRef(null);

  const RAPIDO_PASO = { 1: 'modelo', 2: 'anamnesis_libre', 3: 'valoracion', 4: 'resumen' };

  useEffect(() => {
    if (appState !== 'rapido') { rapidoPrevRef.current = null; return; }
    const pasoKey = RAPIDO_PASO[step];
    if (!pasoKey) return;

    rapidoTimer.startStep(pasoKey);
    if (!rapidoPrevRef.current) {
      trackEvent('paso_iniciado', { modulo: 'pae_rapido', paso: pasoKey, payload: { paso_index: step } });
    } else if (rapidoPrevRef.current < step) {
      const prev = RAPIDO_PASO[rapidoPrevRef.current];
      const dur  = rapidoTimer.getDuration(prev);
      trackEvent('paso_completado', { modulo: 'pae_rapido', paso: prev, ...dur, payload: { paso_index: rapidoPrevRef.current, ...(dur.duracion_descartada ? { duracion_descartada: true } : {}) } });
      trackEvent('paso_iniciado',   { modulo: 'pae_rapido', paso: pasoKey, payload: { paso_index: step } });
    }
    rapidoPrevRef.current = step;
  }, [step, appState]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Event tracking — módulos open/close ──────────────────────────────────────
  const prevAppStateRef = useRef(null);

  useEffect(() => {
    const prev = prevAppStateRef.current;
    prevAppStateRef.current = appState;

    // Solo los módulos que NO emiten su propio modulo_abierto/cerrado dependen
    // del router para el par apertura/cierre. Los que sí lo hacen en su propio
    // componente (pae_detallado, calendario, perfil, prepara_internado,
    // prepara_practica) se excluyen aquí para no duplicar el conteo — era la
    // causa del doble registro de aperturas que inflaba "tiempo por módulo".
    //
    // Bienestar y Respira entraron el 2026-09-23: antes la pestaña era un
    // popover sin evento y "abrir Respira sin iniciar" no dejaba rastro, así
    // que nadie sabía cuántas personas llegaban (plan-bienestar-modulo §1).
    // La pausa guiada ("practica") vive DENTRO de Bienestar: cuenta como el
    // mismo módulo (sus eventos practica_* los emite el reproductor).
    const MODULO_MAP = {
      rapido:           'pae_rapido',
      'prepara-examen': 'prepara_examen',
      'prepara-turno':  'prepara_turno',
      bitacora:         'bitacora',
      escalas:          'escalas',
      ges:              'ges',
      bienestar:        MODULOS.BIENESTAR,
      practica:         MODULOS.BIENESTAR,
      respira:          MODULOS.RESPIRA,
    };
    // Se compara el MÓDULO y no solo si hay mapeo: con Bienestar → Respira →
    // Bitácora se pasa de un módulo mapeado a otro sin tocar uno sin mapear,
    // y la regla vieja (solo emitir al cruzar a/desde un estado sin mapeo) se
    // tragaba esas aperturas. Dentro del mismo módulo no se emite nada.
    if (prev && MODULO_MAP[prev] && MODULO_MAP[prev] !== MODULO_MAP[appState]) {
      trackEvent('modulo_cerrado', { modulo: MODULO_MAP[prev] });
    }
    if (appState && MODULO_MAP[appState] && MODULO_MAP[appState] !== MODULO_MAP[prev]) {
      if (appState === 'rapido') rapidoTimer.reset();
      trackEvent('modulo_abierto', { modulo: MODULO_MAP[appState] });
    }
  }, [appState]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Freemium ─────────────────────────────────────────────────────────────────
  // isPremium = suscripción pagada. isMipaePlus = acceso efectivo a MiPAE+: con
  // el lanzamiento abierto (ACCESO_PLUS_ABIERTO) es para todos; si se cierra,
  // vuelve a ser pagada O trial activo. Es lo que abre la IA ilimitada y los
  // héroes de capa. La distinción con isPremium importa solo donde se habla de
  // la suscripción de pago en sí (fecha de vencimiento).
  const isPremium = esPremium(profile);
  // Con el perfil del mundo: de visita rige el plan gratis de ese mundo (M3),
  // salvo con el acceso abierto, que vale en los tres.
  const isMipaePlus = tieneAccesoPlus(perfilMundo);
  // La prueba se mira con la cuenta Y con la experiencia que se está viendo:
  // dentro de MiPAE TENS (o MiPAE Estudiante) no se ofrece aunque la cuenta
  // sea de MiPAE Enfermero de visita.
  const puedeIniciarTrial = !isNative && !!session && trialDisponible(profile) && trialDisponible(perfilMundo);
  // Eje login (accessGate): el acceso anónimo a PAE/Revisa quedó cerrado.
  const canStartRapido    = () => puedeAbrir('rapido',    { isLoggedIn: !!session });
  const canStartDetallado = () => puedeAbrir('detallado', { isLoggedIn: !!session });
  // Navega a un módulo respetando el gate de login. Si el módulo requiere
  // sesión y no hay, redirige a login en vez de abrirlo.
  const irAModulo = (moduloId, fn) =>
    puedeAbrir(moduloId, { isLoggedIn: !!session }) ? fn() : handleLogin();
  // La Bibliografía de MiPAE es la pestaña "Bibliografía" de la Biblioteca,
  // no un módulo propio: mismo permiso que la Biblioteca.
  const abrirBibliografia = () => irAModulo('bibliografia', () => { setEstudioTab('bibliografia'); setAppState('bibliografia'); });

  // ── Cuota mensual de IA (MiPAE+) ─────────────────────────────────────────────
  // Uso del mes (PAE/Revisa) para usuarios logueados free. Premium = sin límite.
  const [usoIA, setUsoIA] = useState(null);          // { paes, revisas } | null
  const [premiumPaywall, setPremiumPaywall] = useState(null); // 'pae' | 'revisa' | null

  // Se lee el uso salvo con la extendida REAL (pago/trial): con el acceso
  // abierto isMipaePlus es true para todo el mundo, y colgarlo de eso dejaba
  // usoIA en null para todos, o sea la cuota de PAE (uso justo, Fase 1 de la
  // extendida, 2026-09-14) nunca se evaluaba en el cliente.
  const refrescarUsoIA = useCallback(async () => {
    if (!session || esMipaePlus(perfilMundo)) { setUsoIA(null); return; }
    const [u, pautas] = await Promise.all([obtenerUsoMes(), obtenerUsoPautaMes()]);
    // La pauta se cuenta en una RPC aparte; sin dato, su cuota es fail-open.
    setUsoIA(u ? { ...u, ...(typeof pautas === 'number' && { pautas }) } : u);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [session, profile?.plan, profile?.premium_until, profile?.trial_started_at, profile?.trial_ends_at, profile?.trial_product, deVisita]);

  // Carga inicial / al cambiar de sesión.
  useEffect(() => { refrescarUsoIA(); }, [refrescarUsoIA]);

  // ── Pasar de mundo ─────────────────────────────────────────────────────────
  // Al cambiar de cuenta o de rol se vuelve a la casa: la casa nueva es otra
  // y una visita a medias no tiene sentido. La telemetría sabe el mundo
  // visitado para que abrir y cerrar módulos de visita no se confunda con el
  // uso en casa (lib/eventTracking.js).
  useEffect(() => { setMundo(null); }, [session?.user?.id, profile?.rol]);
  useEffect(() => { setMundoTracking(deVisita ? mundo : null); }, [deVisita, mundo]);

  // M5 "al abrir la app siempre vuelve a su casa": en Android y en la PWA la
  // app vive días en segundo plano sin recargar, así que volver a primer
  // plano después de un rato también cuenta como abrirla. Un vistazo corto
  // a otra app no la saca del mundo donde estaba.
  const ocultaDesdeRef = useRef(null);
  useEffect(() => {
    if (!deVisita) return undefined;
    const alCambiar = () => {
      if (document.hidden) { ocultaDesdeRef.current = Date.now(); return; }
      const desde = ocultaDesdeRef.current;
      ocultaDesdeRef.current = null;
      if (desde && Date.now() - desde >= VUELTA_A_CASA_MS) {
        trackEvent('mundo_vuelto', { modulo: MODULOS.PERFIL, payload: { de: mundo, a: casaDe(profile), motivo: 'reapertura' } });
        setMundo(null);
        setAppState('home');
      }
    };
    document.addEventListener('visibilitychange', alCambiar);
    return () => document.removeEventListener('visibilitychange', alCambiar);
  }, [deVisita, mundo, profile]); // eslint-disable-line react-hooks/exhaustive-deps

  const cambiarMundo = (destino) => {
    const casa = casaDe(profile);
    if (!casa || !puedeEstarEn(profile, destino)) return;
    const de = deVisita ? mundo : casa;
    if (destino === de) return;
    if (destino === casa) {
      trackEvent('mundo_vuelto', { modulo: MODULOS.PERFIL, payload: { de, a: casa } });
      setMundo(null);
    } else {
      trackEvent('mundo_cambiado', { modulo: MODULOS.PERFIL, payload: { de, a: destino } });
      setMundo(destino);
    }
    // Cada mundo abre en su inicio: el inicio, el menú y la firma cambian
    // juntos, como al cambiar de perfil en Chrome.
    setAppState('home');
    try { window.scrollTo(0, 0); } catch { /* jsdom */ }
  };

  // ── Onboarding tour pre-sesión (visitantes) ─────────────────────────────────
  const [showTour, setShowTour] = useState(false);
  const [tourOrigen, setTourOrigen] = useState('auto');

  // Kill-switch del tour parametrizado por rol (ON por defecto, patrón de los
  // otros flags del archivo): apagado, el carril es null y el tour se
  // comporta exactamente como antes de esta ola (7 escenas, el CTA de cierre →
  // startDemo).
  const ONBOARDING_ROL_ENABLED = process.env.REACT_APP_ONBOARDING_ROL_ENABLED !== 'false';
  const carrilTour = ONBOARDING_ROL_ENABLED ? carrilDe(profile) : null;
  const superficieTour = ONBOARDING_ROL_ENABLED ? superficieDe(profile) : null;

  // Tour de bienvenida (onboarding-video) — UN solo disparo, cuando el embudo
  // ya terminó: usuario logueado, perfil completo y parado en el home. Nunca
  // sobre la confirmación de edad ni el onboarding conversacional. (Antes había
  // dos efectos —uno por dispositivo pre-login y otro por usuario post-login—
  // y un usuario nuevo veía el tour dos veces, a veces tapando la pantalla
  // equivocada del embudo.)
  // Llaves versionadas a _v3 (`lib/onboardingRol.js`, decisión del fundador
  // 2026-09-10): la ola de carriles vale la pena que TODA la base la vea una
  // vez más, aunque ya haya visto una versión vieja.
  // Video de bienvenida RE-GRABADO a la app actual (fundador, 2026-07-31):
  // ahora que todos aterrizan en el Home post-perfil, el video corre AHÍ,
  // antes de la primera interacción — nunca más como modal sorpresa a mitad
  // de turno.
  const introMostradoRef = useRef(false); // a lo más una vez por montaje
  useEffect(() => {
    if (!session || !profile?.perfil_completado || appState !== "home") return;
    if (introMostradoRef.current) return;
    const uid = session.user.id;
    // La marca vive en la CUENTA además del dispositivo (2026-09-12): el
    // localStorage se pierde en incógnito, al borrar datos, en un aparato
    // nuevo y en la app instalada de Android, donde el sistema puede purgar
    // el WebView (#651). Sin esto el tour reaparecía "a cada rato".
    if (profile.onboarding_visto_at) return;
    if (!tourPendiente(uid)) return;
    // Jamás a mitad de turno: con actividad de registro reciente se pospone
    // SIN marcar como visto, para que reaparezca en la próxima apertura
    // tranquila (misma regla de `debeMostrarQueCambio`).
    try {
      if (hayActividadDeTurno(cargarRegistros(uid))) return;
    } catch { /* sin registros locales: no bloquea el tour */ }
    marcarTourVisto(uid);
    // A la cuenta en segundo plano: si falla (sin conexión) el dispositivo ya
    // quedó marcado, y el próximo arranque con red vuelve a intentarlo.
    supabase.from("profiles").update({ onboarding_visto_at: new Date().toISOString() })
      .eq("user_id", uid).then(() => {}, () => {});
    setProfile((prev) => (prev ? { ...prev, onboarding_visto_at: new Date().toISOString() } : prev));
    introMostradoRef.current = true;
    setTourOrigen('auto');
    setShowTour(true);
  }, [session, profile, appState]);

  // ── Primer viaje interactivo (post-sesión, motor de nudges) ─────────────────
  const userIdForNudges = session?.user?.id || null;
  const nudges = useNudges(userIdForNudges, profile);
  const { toast } = useToast();

  // Vuelta del pago o del registro de tarjeta en Flow (urlReturn / url_return):
  // /api/flow-registro y el checkout devuelven a la app con ?pago=<estado>.
  // Se dice qué pasó, una vez, y se limpia la URL para que un refresh no lo
  // repita. El perfil se vuelve a leer al cargar, así que el plan ya viene
  // fresco.
  useEffect(() => {
    let params;
    try { params = new URLSearchParams(window.location.search); } catch { return; }
    const estado = params.get('pago');
    if (!estado) return;
    const aviso = MENSAJES_PAGO[estado];
    if (aviso) toast[aviso.tono](aviso.texto, { duration: 9000 });
    // Embudo: cuántos vuelven de Flow y cómo ('tarjeta' es quien no registró
    // la tarjeta, sin cobro). Catálogo cerrado: un valor desconocido es 'otro'.
    registrarEmbudo('pago_retorno', aviso ? estado : 'otro');
    if (estado === 'ok' || estado === 'pendiente' || estado === 'prueba') {
      verificarMiPago().then((s) => {
        if (s?.status === 'trial') { void solicitarBienvenida('prueba'); refetchPerfil(); toast.success('Tu prueba está activa. En Mi perfil puedes revisar el primer cobro y cancelar antes.'); }
        if (s?.status === 'active' && s.period_end && new Date(s.period_end).getTime() > Date.now()) {
          // Desde el 25-oct hay tres membresías: se nombra la que se pagó, y
          // el producto entra al perfil en memoria (sin él, hasta recargar,
          // la cuenta se leería como un permiso antiguo que vale en todo).
          const producto = PRODUCTOS_PLUS[s.producto] ? s.producto : null;
          setProfile(prev => prev ? { ...prev, plan: "premium", premium_until: s.period_end, ...(producto ? { premium_product: producto } : {}) } : prev);
          registrarEmbudo('pago_activo', producto || 'sin_producto');
          toast.success(producto ? `Listo, ${PRODUCTOS_PLUS[producto].nombre} está activo en tu cuenta.` : "Listo, tu membresía está activa en tu cuenta.", { duration: 9000 });
        }
      }).catch(() => {});
    }
    params.delete('pago');
    const qs = params.toString();
    try { window.history.replaceState({}, '', window.location.pathname + (qs ? `?${qs}` : '')); } catch { /* sin historial, da igual */ }
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Cama activa del turno: el paciente que estás trabajando, DERIVADO del
  // registro local (device-local) tocado más recientemente. Se recalcula al
  // volver al Home (appState cambia) para ofrecer "registrar en la cama X" en
  // un toque, sin re-navegar todo MiPAE en turno — mata la fricción de re-entrada.
  const camaActiva = useMemo(() => {
    if (appState !== "home" || !session?.user?.id) return null;
    try { return camaActivaTurno(cargarRegistros(session.user.id)); } catch { return null; }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [appState, session?.user?.id]);
  // La card protagonista del estudiante en el inicio (plan de la interfaz de
  // los tres mundos, 2.2): en casa, con sesión y sin una cama activa (con
  // ella el inicio abre con el cockpit). Con la card, el aviso del borrador
  // no se repite arriba: la card lo trae, con Continuar y Descartar.
  const conMomentoEstudiante = !!session && !deVisita && veMomentoEstudiante(perfilMundo) && !camaActiva;
  // Dónde se avisa el PAE sin terminar (propuesta de la interfaz por
  // experiencia, 2026-10-16). El PAE vive en MiPAE Estudiante, así que solo se
  // avisa donde el mundo tiene PAE: en MiPAE Enfermero y MiPAE TENS no.
  // En casa del estudiante lo trae su card y en la de la interna su fila bajo
  // el turno (las dos en el inicio); queda arriba solo para quien mira MiPAE
  // Estudiante de visita (de visita no hay card) o el estudiante con una cama
  // activa, como antes.
  const borradorEnInicio = !deVisita && (conMomentoEstudiante || (perfilMundo?.rol === "estudiante" && esElegibleTurno(perfilMundo)));
  const avisoBorradorArriba = !!borradorPendiente && perfilMundo?.rol === "estudiante" && !borradorEnInicio;
  // La pestaña del medio de la CASA queda recordada para la próxima apertura
  // (lib/navegacionMundo.js): se escribe con el perfil real, nunca de visita.
  useEffect(() => {
    if (profile?.rol) recordarSegundaPestana(segundaPestana(profile));
  }, [profile]);

  // Re-lanza el onboarding-video manualmente (botón "Ver tour de nuevo").
  const abrirTour = () => {
    closeMenu();
    setTourOrigen('de_nuevo');
    setShowTour(true);
  };

  // Ubicación aproximada (país/región) por IP — throttled ~1/día. Ver geoPing.
  useEffect(() => {
    if (session?.access_token) pingGeo(session.access_token);
  }, [session?.access_token]);

  // Retención 12 h de los registros de turno (mandato del fundador,
  // 2026-07-24): la purga corre al ABRIR la app y cada vez que vuelve a
  // primer plano (una PWA puede vivir días en background sin cold start), no
  // solo al entrar a MiPAE en turno — el registro con datos del paciente no puede
  // quedar vivo en el dispositivo esperando a que el usuario navegue a esa
  // pestaña. Borra local y espeja el borrado en Supabase (best-effort: si no
  // hay red, el pg_cron remoto lo garantiza igual por su cuenta).
  useEffect(() => {
    const userId = session?.user?.id;
    if (!userId) return;
    const purgar = () => {
      try {
        const { vivos, expirados } = purgarExpirados(cargarRegistros(userId));
        if (expirados.length) {
          guardarRegistros(userId, vivos);
          expirados.forEach((r) => { borrarRemoto(r.id); borrarMarcasLocales(r); });
        }
      } catch { /* almacenamiento no disponible: nada que purgar */ }
      // El turno del TENS vive solo en el dispositivo, con la misma retención:
      // se borra aquí aunque nadie vuelva a abrir su hub. Sin mirar el rol: una
      // enfermera de visita en MiPAE TENS también deja su turno guardado.
      purgarTensVencido(userId);
    };
    purgar();
    const onVisible = () => { if (!document.hidden) purgar(); };
    document.addEventListener("visibilitychange", onVisible);
    return () => document.removeEventListener("visibilitychange", onVisible);
  }, [session?.user?.id]);

  // Atribución de campaña (UTM/referrer) del visitante: se captura al arrancar
  // y persiste en localStorage ANTES del redirect a Google OAuth — el retorno
  // del OAuth pierde los query params, así que este es el único momento.
  // Viaja después en el payload de signup_completado (conversión por canal).
  useEffect(() => { capturarAtribucion(); }, []);

  // Widget de pantalla de inicio (Android): publica los próximos turnos cada
  // vez que cambia la rotación. El widget nativo (TuDiaWidget) lee este
  // snapshot; la racha la publica su propio motor (rachaDiaria). En web/iOS
  // publicarWidget es un no-op. Sin rotación se publica lista vacía para que
  // el widget no muestre un turno viejo.
  useEffect(() => {
    if (!session) return;
    const iso = (d) => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
    const hoy = new Date(); hoy.setHours(0, 0, 0, 0);
    const turnos = [];
    if (rotacion) {
      for (let i = 0; i <= 14 && turnos.length < 3; i++) {
        const f = new Date(hoy); f.setDate(hoy.getDate() + i);
        const t = calcularTurnoDelDia(f, rotacion);
        if (t && t.tipo !== "libre") {
          turnos.push({ fecha: iso(f), tipo: t.tipo, horaInicio: t.horaInicio || "", horaFin: t.horaFin || "" });
        }
      }
    }
    publicarWidget({ turnos });
  }, [session, rotacion]);

  // La oferta de bienvenida que abría sola la hoja de la prueba en el inicio
  // se retiró el 2026-10-17. Con el acceso abierto nunca se veía, pero el día
  // del cierre se le habría abierto sola a enfermeros y TENS: la venta salió
  // del inicio (2026-08-02, UpsellPlusHome no vuelve), lo de la membresía se
  // informa dentro del recurso y nunca en el inicio (plan de la interfaz §5),
  // y a MiPAE TENS no le corresponde membresía (Términos §6). Al estudiante ya
  // se le había sacado el 9-oct. La prueba sigue donde la persona la busca
  // (Planes y la hoja del límite). No restaurar.

  // Refresh nudges al volver al home — útil para que el motor reaccione
  // después de crear rotacion en calendario-config, completar perfil, etc.
  // No usamos el remount de StepHome porque useNudges vive en App.jsx.
  const prevAppStateForNudges = useRef(appState);
  useEffect(() => {
    if (prevAppStateForNudges.current !== 'home' && appState === 'home') {
      nudges.refresh();
      refrescarUsoIA(); // recontar cuota tras usar PAE/Revisa
    }
    prevAppStateForNudges.current = appState;
  }, [appState, nudges, refrescarUsoIA]);

  // ── Menu state ───────────────────────────────────────────────────────────────
  const [showRevisa, setShowRevisa]   = useState(false);
  const [revisaSource, setRevisaSource] = useState("unknown");
  const [revisaInitialQuery, setRevisaInitialQuery] = useState("");
  const [revisaPatientContext, setRevisaPatientContext] = useState("");
  const [revisaGuardarNota, setRevisaGuardarNota] = useState(null); // (texto) => void | null
  const [fabActive, setFabActive]     = useState(true);
  const [fabDismissed, setFabDismissed] = useState(() => {
    try { return localStorage.getItem(FAB_DISMISSED_KEY) === "1"; } catch { return false; }
  });
  const [fabJustRestored, setFabJustRestored] = useState(false);
  const dismissFab = () => {
    try { localStorage.setItem(FAB_DISMISSED_KEY, "1"); } catch { /* ignore */ }
    setFabDismissed(true);
  };
  const restoreFab = () => {
    try { localStorage.removeItem(FAB_DISMISSED_KEY); } catch { /* ignore */ }
    setFabDismissed(false);
    setFabActive(true);
    setFabJustRestored(true);
    setTimeout(() => setFabJustRestored(false), 400);
  };
  const [menuOpen, setMenuOpen]       = useState(false);
  // Confirmación de cierre de sesión, solo con turno abierto (ver handleLogout).
  const [confirmarSalida, setConfirmarSalida] = useState(false);
  // Navegación agente-céntrica (la única desde 2026-09-14, cuando se retiró el
  // flag REACT_APP_NAV_V2 junto con el Home viejo). Barra: Inicio · MiPAE en
  // turno · Benito · Enciclopedia · Bienestar. El compañero se controla desde
  // la pestaña (companeroAbierto) en vez del FAB.
  const [companeroAbierto, setCompaneroAbierto] = useState(false);
  const [companeroPrefill, setCompaneroPrefill] = useState(""); // prompt de ejemplo del Home
  // Presencia de Benito en la pestaña (panel cerrado): "pensando" mientras
  // trabaja y un punto de novedad cuando terminó una respuesta que aún no viste.
  const [benitoEstado, setBenitoEstado] = useState("reposo");
  const [benitoNovedad, setBenitoNovedad] = useState(false);
  const { dark, tema, letra, texto, adoptarApariencia } = useTheme();
  // Apariencia de la cuenta: `aparienciaRef` guarda para qué usuario ya se
  // hidrató y cuál fue lo último sincronizado, para no subir a la cuenta
  // los valores del dispositivo ANTES de leer los de la cuenta (eso pisaría
  // la elección hecha en otro aparato) ni escribir cuando nada cambió.
  const aparienciaRef = useRef({ userId: null, ultima: null });
  const aparienciaActual = { tema, letra, texto, modo: dark ? 'oscuro' : 'claro' };
  useEffect(() => {
    const userId = session?.user?.id;
    if (!userId || aparienciaRef.current.userId === userId) return;
    let vivo = true;
    cargarApariencia(userId).then((guardada) => {
      if (!vivo) return;
      if (guardada) {
        adoptarApariencia(guardada);
        aparienciaRef.current = { userId, ultima: guardada };
      } else {
        // Primera vez con cuenta: lo elegido en este dispositivo sube tal cual.
        guardarApariencia(userId, aparienciaActual);
        aparienciaRef.current = { userId, ultima: aparienciaActual };
      }
    });
    return () => { vivo = false; };
  }, [session?.user?.id]); // eslint-disable-line react-hooks/exhaustive-deps
  useEffect(() => {
    const userId = session?.user?.id;
    const ref = aparienciaRef.current;
    if (!userId || ref.userId !== userId || aparienciaIgual(ref.ultima, aparienciaActual)) return;
    const t = setTimeout(() => {
      aparienciaRef.current = { userId, ultima: aparienciaActual };
      guardarApariencia(userId, aparienciaActual);
    }, 400);
    return () => clearTimeout(t);
  }, [session?.user?.id, tema, letra, texto, dark]); // eslint-disable-line react-hooks/exhaustive-deps
  const [aparienciaOpen, setAparienciaOpen] = useState(false); // popover Apariencia (sol/luna del header)
  // Novedades a voluntad (auditoría 2026-09-28, E10): el punto discreto del
  // menú abre el detalle completo sin reconocer nada.
  const [novedadesOpen, setNovedadesOpen] = useState(false);
  // Pestaña con que abre la Biblioteca (Estudio). "bibliografia" cuando se
  // llega a la Bibliografía de MiPAE desde el buscador o el pie del menú
  // (2026-10-03); se limpia al salir, así la Biblioteca vuelve a abrir en
  // Temas desde sus otras entradas.
  const [estudioTab, setEstudioTab] = useState(null);
  useEffect(() => { if (appState !== 'bibliografia') setEstudioTab(null); }, [appState]);
  // Reconocimiento de novedades por CUENTA: se resuelve al entrar, ANTES de
  // que el Home decida si muestra el aviso (evita que aparezca y desaparezca
  // en cada carga). Cacheado por usuario en lib/novedadesCuenta.js.
  useEffect(() => {
    const userId = session?.user?.id;
    if (userId) resolverNovedadesVistas(userId);
  }, [session?.user?.id]);
  const [bienestarOpen, setBienestarOpen] = useState(false); // popover Bienestar (Respira/Bitácora)
  const [turnoCamaFoco, setTurnoCamaFoco] = useState(null); // cama en foco en MiPAE en turno → compañero contextual
  const [menuEntered, setMenuEntered] = useState(false);
  const menuOpenRef                   = useRef(false);
  const [menuPaes, setMenuPaes]             = useState([]);
  const freemiumViewRef = useRef({ home: false });

  // ── Command palette (buscador global) ─────────────────────────────────────────
  const [paletteOpen, setPaletteOpen] = useState(false);
  // Sesión de respiración en curso: mientras dura, la app se calla (sin header,
  // sin pestañas). Respirar mirando el menú es lo contrario del módulo.
  const [respiraEnSesion, setRespiraEnSesion] = useState(false);
  const [palettePaes, setPalettePaes] = useState([]);
  const [escalaInicial, setEscalaInicial] = useState(null);
  const [referenciaInicial, setReferenciaInicial] = useState(null);
  const [fichaInicial, setFichaInicial] = useState(null);
  const [gesInicial, setGesInicial] = useState(null);
  // Cama a abrir en MiPAE en turno cuando el compañero navega a un paciente específico.
  const [turnoCamaInicial, setTurnoCamaInicial] = useState(null);
  // "Empezar con una cama de práctica" del tour: MiPAE en turno crea la
  // práctica al montar y abre su ficha (onboardings por rol, 2026-09-10).
  const [turnoPracticaAlEntrar, setTurnoPracticaAlEntrar] = useState(false);
  const [labInicial, setLabInicial] = useState(null);
  const spotlight = useSpotlightData(); // contenido buscable (GES + fármacos) para el buscador global
  const [recientes, setRecientes] = useState(getRecientes); // "sigue donde quedaste" del inicio

  // ── PWA state ─────────────────────────────────────────────────────────────────
  const [swRegistration, setSwRegistration] = useState(null);
  const [isOffline, setIsOffline] = useState(!navigator.onLine);
  const [installPrompt, setInstallPrompt] = useState(null);
  const [showSafariInstall, setShowSafariInstall] = useState(false);

  const toMetricToken = (value = "") =>
    String(value || "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[̀-ͯ]/g, "")
      .replace(/[^a-z0-9]+/g, "_")
      .replace(/^_+|_+$/g, "") || "unknown";

  const logFreemiumMetric = (event, detail = null, data = {}) => {
    const token = detail ? `${event}:${toMetricToken(detail)}` : event;
    registrarMetrica(session?.user?.id, "rapido", `freemium_${token}`);
  };

  // FAB opacity: se desvanece tras 2s de inactividad, reactiva al interactuar
  useEffect(() => {
    if (!fabActive) return;
    const t = setTimeout(() => setFabActive(false), 2000);
    return () => clearTimeout(t);
  }, [fabActive]);
  useEffect(() => {
    const on = () => setFabActive(true);
    window.addEventListener('scroll', on, { passive: true });
    window.addEventListener('touchstart', on, { passive: true });
    window.addEventListener('mousemove', on, { passive: true });
    return () => {
      window.removeEventListener('scroll', on);
      window.removeEventListener('touchstart', on);
      window.removeEventListener('mousemove', on);
    };
  }, []);

  useEffect(() => {
    if (!menuOpen) return undefined;

    const previousBodyOverflow = document.body.style.overflow;
    const previousHtmlOverflow = document.documentElement.style.overflow;

    document.body.style.overflow = 'hidden';
    document.documentElement.style.overflow = 'hidden';

    return () => {
      document.body.style.overflow = previousBodyOverflow;
      document.documentElement.style.overflow = previousHtmlOverflow;
    };
  }, [menuOpen]);

  const openMenu = () => {
    setMenuOpen(true);
    requestAnimationFrame(() => requestAnimationFrame(() => setMenuEntered(true)));
    menuOpenRef.current = true;
  };

  const closeMenu = () => {
    setMenuEntered(false);
    setTimeout(() => { setMenuOpen(false); menuOpenRef.current = false; }, 300);
  };

  // Fichas de los modelos de enfermería para el buscador (un ítem por modelo
  // que abre SU ficha). El catálogo pesa (fichas completas con fuentes), así
  // que se carga recién al abrir el buscador y una sola vez, en vez de subirlo
  // al paquete con que arranca la app.
  const [modelosBuscador, setModelosBuscador] = useState([]);
  const modelosBuscadorPedidoRef = useRef(false);
  const openPalette = () => {
    setPaletteOpen(true);
    if (session?.user?.id) {
      listarPAEs(session.user.id, 20).then(setPalettePaes).catch(() => {});
    }
    if (!modelosBuscadorPedidoRef.current) {
      modelosBuscadorPedidoRef.current = true;
      import("./lib/modelosEnfermeria")
        .then(({ MODELOS }) => setModelosBuscador(MODELOS.map(({ id, corto, nombre, autora, claves }) => ({ id, corto, nombre, autora, claves: claves || [] }))))
        .catch(() => { modelosBuscadorPedidoRef.current = false; });
    }
  };
  const closePalette = () => setPaletteOpen(false);

  // Shell de escritorio: Ctrl/Cmd+K abre el buscador. En escritorio el teclado
  // ES la vía rápida, y el atajo ya es el estándar que la gente trae aprendido
  // de otras apps. Se ignora mientras se escribe en un campo (ahí Cmd+K puede
  // ser del sistema operativo) y si la paleta ya está abierta.
  useEffect(() => {
    if (!SHELL_ESCRITORIO_ENABLED) return undefined;
    const onKey = (e) => {
      if (e.key !== "k" && e.key !== "K") return;
      if (!e.metaKey && !e.ctrlKey) return;
      if (paletteOpen) return;
      const t = e.target;
      if (t?.closest?.('input, textarea, select, [contenteditable="true"]')) return;
      e.preventDefault();
      openPalette();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
    // openPalette se redefine en cada render; sus dependencias reales son estas.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paletteOpen, session?.user?.id]);

  // Cierre defensivo del popover de Bienestar al navegar: con el shell de
  // escritorio el popover puede vivir sin tab bar (se ancla al header), así que
  // saltar a un wizard con el popover abierto lo dejaría pintado en el aire.
  useEffect(() => { setBienestarOpen(false); setAparienciaOpen(false); }, [appState]);

  // El buscador deep-linkea a una escala vía escalaInicial. Una vez que el
  // componente Escalas montó y la consumió, se limpia para que entradas
  // posteriores (menú, Prepara tu turno) abran el listado, no la última escala.
  useEffect(() => {
    if (appState === "escalas" && escalaInicial) {
      setEscalaInicial(null);
    }
  }, [appState, escalaInicial]);

  // Referencia rápida: el buscador, el menú, los recientes y Benito pueden
  // deep-linkear a una sección vía referenciaInicial. Se limpia al SALIR de la
  // Enciclopedia, no al entrar (revisión 2026-10-02): ReferenciaRapida es
  // lazy, y limpiarla al entrar corría antes de que el chunk llegara, así que
  // el PRIMER deep link de cada sesión montaba en el índice. Mientras se está
  // dentro el valor no estorba: el componente lo lee solo al montar, y la
  // clave `referenciaClave` decide cuándo se remonta.
  useEffect(() => {
    if (appState !== "referencia" && referenciaInicial) {
      setReferenciaInicial(null);
    }
  }, [appState, referenciaInicial]);

  // Estado pedido por la URL (hash). Se consulta al montar y de nuevo cuando
  // la resolución de sesión termina, que llega después y lo pisaba.
  const estadoPorHash = () => {
    if (typeof window === "undefined") return null;
    if (window.location.hash === "#lab") return "laboratorio";
    return null;
  };

  // Laboratorio interactivo (prototipo): accesible vía URL con #lab.
  // Entrada principal: QuickCard "Laboratorio" en PreparaTurno.
  useEffect(() => {
    if (typeof window !== "undefined" && window.location.hash === "#lab") {
      setAppState("laboratorio");
    }
  }, []);

  // ── Supabase auth ────────────────────────────────────────────────────────────
  // Supabase re-emite SIGNED_IN cada vez que la pestaña recupera el foco. Este
  // ref guarda el id del usuario ya procesado para distinguir un login genuino
  // de esos re-disparos y no resetear la navegación al volver a la app.
  const authedUserIdRef = useRef(null);
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    // Embudo de las membresías (auditoría de conversión del 25-oct-2026): la
    // llegada por un enlace `?planes=1` se cuenta una vez, cuando es FRESCA.
    // Si esta pestaña ya guardó un regreso pendiente, la URL es la que
    // restauró la vuelta de Google o una recarga, y contarla otra vez inflaría
    // el embudo. Se mira ANTES de prepararRetornoPlanes, que lo guarda.
    let llegadaFresca = true;
    try { llegadaFresca = !window.sessionStorage.getItem(CLAVE_RETORNO_PLANES); } catch { /* sin storage: se cuenta */ }
    // El navegador de Google vuelve sin el query del correo. Restaurarlo solo
    // en web conserva la membresía elegida sin cambiar el login ni lo nativo.
    const planesParams = !isNative ? prepararRetornoPlanes() : params;
    const planesParam = planesParams.get('planes') === '1';
    // Con la URL ORIGINAL y su origen: el botón de /precios lleva
    // desde=precios. Catálogo cerrado.
    if (!isNative && llegadaFresca && params.get('planes') === '1') {
      const desde = params.get('desde') === 'precios' ? 'precios' : 'otro';
      const producto = intencionDesdeUrl(window.location.search)?.producto || 'sin_producto';
      registrarEmbudo('enlace_planes', `${desde}_${producto}`);
    }
    // "Lo nuevo de MiPAE" (campaña del 25-oct): el botón del correo lleva a la
    // pantalla de la experiencia de la persona, no a una compra. Abrirla no
    // inicia ninguna prueba.
    const loNuevoParam = params.get('lo_nuevo') === '1';
    const destinoParam = planesParam ? 'planes' : loNuevoParam ? 'lo-nuevo' : null;
    // Entrar a Planes por el enlace del correo o de /precios (?planes=1) no
    // pasaba por abrirPlanes y no dejaba rastro: el panel de membresías no
    // veía a quien llegaba desde la campaña del 25-oct. Mismo evento y misma
    // tabla que abrirPlanes, con el origen 'enlace'; una vez por carga, porque
    // solo uno de los dos caminos de abajo procesa la sesión.
    const medirPlanesPorEnlace = (userId) => registrarMetrica(userId, "rapido", "freemium_planes_abierto:enlace");
    const inicioParam = params.get('inicio');
    if (loNuevoParam) {
      setLoNuevoOrigen('correo');
      // Solo se quita este parámetro (los de la sesión, si los hay, quedan):
      // así una recarga no vuelve a abrir la pantalla.
      try {
        const limpio = new URLSearchParams(window.location.search);
        limpio.delete('lo_nuevo');
        const q = limpio.toString();
        window.history.replaceState(window.history.state, '', `${window.location.pathname}${q ? `?${q}` : ''}${window.location.hash}`);
      } catch { /* sin history: se queda el parámetro, no pasa nada grave */ }
    }
    // Deep-link público a las páginas legales. Se aceptan tanto el query param
    // histórico (?legal=privacidad|terminos) como rutas limpias (/privacidad,
    // /terminos): Google Play y la verificación OAuth de Google Cloud exigen una
    // URL pública y estable para la política de privacidad en el mismo dominio
    // que la página de inicio, y una ruta limpia es más robusta ante sus
    // revisores que el query param. Se respeta con o sin sesión (no requieren login).
    const pathLegal = { '/privacidad': 'privacidad', '/terminos': 'terminos' }[window.location.pathname] || null;
    const legalRaw = params.get('legal') || pathLegal;
    // /contacto y /instituciones (2026-10-30) siguen la misma regla: públicas,
    // con o sin sesión. Se suman acá para entrar por el mismo camino.
    const legalState = legalRaw === 'privacidad' || legalRaw === 'terminos'
      ? legalRaw
      : (RUTAS_PUBLICAS[window.location.pathname] || null);
    getSessionConTimeout().then(async (session) => {
      setSession(session);
      if (session) {
        authedUserIdRef.current = session.user.id;
        getOrCreateSessionId();
        try {
          const [p, rot] = await Promise.all([
            cargarProfile(session.user.id),
            cargarRotacion(session.user.id),
          ]);
          setProfile(p);
          setRotacion(rot);
          setTrackingContext({ userId: session.user.id, cohortId: p?.cohort_id });
          const nextState = resolveAuthState(p, window.location.pathname);
          if (!isNative && nextState === 'home' && destinoParam === 'planes') {
            consumirRetornoPlanes();
            if (!legalState) medirPlanesPorEnlace(session.user.id);
          }
          setAppState(legalState || (nextState === 'home' ? (destinoParam || destinoBienvenida(inicioParam, p) || nextState) : nextState));
        } catch {
          // Sin conexión no se pudo cargar el perfil: abrimos igual en home con
          // la sesión recuperada. Al volver internet, onAuthStateChange recarga.
          setAppState(legalState || "home");
        }
      } else {
        // Sin sesión: respeta el estado pedido por hash (#lab, la calculadora
        // de infusiones). El efecto que lo fija corre al montar y esta
        // resolución asíncrona llegaba después y lo pisaba. #onboarding ya no
        // entra por aquí: es solo admin (resolveAuthState).
        setAppState(legalState || estadoPorHash() || "home");
      }
    }).catch(() => {
      // Red de seguridad final: ante cualquier error inesperado, nunca dejar la
      // app atascada en la pantalla de carga (session === undefined).
      setSession((prev) => (prev === undefined ? null : prev));
      setAppState((prev) => prev || "home");
    });
    const { data: { subscription } } = supabase.auth.onAuthStateChange((event, session) => {
      setSession(session);
      if (session) {
        setAppState(prev => prev === "auth" ? "home" : prev);
        if (event === 'SIGNED_IN') {
          // Re-disparo de SIGNED_IN al recuperar foco la pestaña: el usuario ya
          // está procesado, no recargamos perfil ni reseteamos la navegación.
          if (authedUserIdRef.current === session.user.id) return;
          authedUserIdRef.current = session.user.id;
          clearSession();
          getOrCreateSessionId();
          Promise.all([
            cargarProfile(session.user.id),
            cargarRotacion(session.user.id),
          ]).then(([p, rot]) => {
            setProfile(p);
            setRotacion(rot);
            setTrackingContext({ userId: session.user.id, cohortId: p?.cohort_id });
            // Evento de embudo de acceso: antes el login era ciego (no se medía
            // quién entra ni con qué). provider distingue google/email; nuevo =
            // cuenta recién creada (mide registro vs re-login del magic link).
            const creadoMs = session.user.created_at ? Date.parse(session.user.created_at) : 0;
            trackEvent('login_exitoso', {
              modulo: 'auth',
              payload: {
                provider: session.user.app_metadata?.provider || 'desconocido',
                nuevo: creadoMs > 0 && Date.now() - creadoMs < 60000,
              },
            });
            const nextState = resolveAuthState(p, window.location.pathname);
            if (!isNative && nextState === 'home' && destinoParam === 'planes') {
              consumirRetornoPlanes();
              medirPlanesPorEnlace(session.user.id);
            }
            setAppState(nextState === 'home' ? (destinoParam || destinoBienvenida(inicioParam, p) || nextState) : nextState);
          }).catch(() => {
            // Sin red al recargar perfil tras el login: la sesión ya quedó
            // seteada y la app abre en home; onAuthStateChange recarga al
            // volver internet. No dejamos una promesa rechazada suelta.
            setAppState(prev => (prev === 'auth' ? 'home' : prev));
          });
          // TODO: eliminar después de release 1-2 versiones más allá del fix —
          // limpieza one-shot de la clave zombie del dedupe localStorage del
          // bug de welcome email duplicado. removeItem es no-op si no existe.
          localStorage.removeItem(`mipae_welcomed_${session.user.id}`);
        }
      } else {
        authedUserIdRef.current = null;
        if (event === 'SIGNED_OUT') {
          // Una sesión vencida desmonta el turno: mostramos el acceso del Home
          // sin ejecutar el borrado de datos reservado al cierre explícito.
          setAppState(prev => prev === 'registro-turno' ? 'home' : prev);
        }
      }
    });
    // Capacitor (no-op en web): UI nativa, deep link OAuth, recordatorios y push.
    // Cada init va aislado: si uno revienta al arrancar (plugin ausente, sin
    // Firebase, permiso denegado), se loguea y se sigue con los demás en vez de
    // arrastrar a toda la secuencia y filtrar los cleanups.
    const cleanupNativeUI = safeInit('nativeUI', initNativeUI);
    const cleanupDeepLink = safeInit('deepLinkAuth', initDeepLinkAuth);
    safeInvoke('localNotifications', initLocalNotifications);
    safeInvoke('tips', programarTips);
    const cleanupPush = safeInit('push', initPush);
    return () => {
      try { subscription.unsubscribe(); } catch { /* ya desuscrito */ }
      cleanupNativeUI();
      cleanupDeepLink();
      cleanupPush();
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // Espera a que la persona termine su perfil: antes el saludo llegaba como
  // estudiante a enfermeros y TENS. La cuenta y su marca remota mandan.
  useEffect(() => {
    if (session?.user?.id && profile?.perfil_completado) void solicitarBienvenida('cuenta');
  }, [session?.user?.id, profile?.perfil_completado]);

  // Reprograma los recordatorios de turno al cambiar la rotación, y de paso los
  // tips: el horizonte es corto a propósito, así que cada apertura de la app es
  // la que los renueva (ver lib/notificacionesPlan.js).
  useEffect(() => {
    if (rotacion) {
      safeInvoke('recordatoriosTurno', () => programarRecordatoriosTurno(rotacion));
      safeInvoke('tips', programarTips);
    }
  }, [rotacion]);

  // ── Back button / Browser history ────────────────────────────────────────────
  const stepRef       = useRef(step);
  stepRef.current     = step;
  const appStateRef   = useRef(appState);
  appStateRef.current = appState;

  // App instalada: al abrir y al volver a primer plano (como mucho cada 10
  // min) se pregunta al servidor por el interruptor del 25 y la versión
  // mínima (lib/configRemota.js).
  const consultaConfigRef = useRef(0);
  const consultarConfig = useCallback(async () => {
    consultaConfigRef.current = Date.now();
    const [config, info] = await Promise.all([
      cargarConfigRemota(),
      CapApp.getInfo().catch(() => null),
    ]);
    setConfigRemota(config);
    if (info?.version) setVersionInstalada(info.version);
    return config;
  }, []);
  useEffect(() => {
    if (!isNative) return undefined;
    consultarConfig();
    const alVolver = () => {
      if (document.visibilityState === "visible" && Date.now() - consultaConfigRef.current > 10 * 60 * 1000) consultarConfig();
    };
    document.addEventListener("visibilitychange", alVolver);
    return () => document.removeEventListener("visibilitychange", alVolver);
  }, [consultarConfig]);

  // El candado (lib/versionApp.js) se decide con tres resguardos que salieron
  // de la revisión del 20-oct: (1) solo con lo que el servidor respondió AHORA,
  // nunca con una versión mínima guardada (sin señal no se bloquea a nadie);
  // (2) solo con la sesión ya resuelta, para poder mirar sus turnos; (3) nunca
  // con un turno abierto, del enfermero o del TENS, aunque no se haya tocado
  // hace rato: espera a la próxima apertura. Una vez pedido se queda, salvo
  // que "Revisar de nuevo" encuentre que ya no se exige.
  const actualizarMedidoRef = useRef(false);
  useEffect(() => {
    if (!isNative || session === undefined || !configRemota?.fresca || pedirActualizar) return;
    const minima = configRemota.version_minima?.[platform] || null;
    const uid = session?.user?.id || null;
    let hayTurno = appStateRef.current === "registro-turno";
    try { hayTurno = hayTurno || !!camaActivaTurno(cargarRegistros(uid)); } catch { /* sin registros */ }
    try { hayTurno = hayTurno || tensConTurnoAbierto(uid); } catch { /* sin turno TENS */ }
    if (!debePedirActualizar({ instalada: versionInstalada, minima, hayTurno })) return;
    setPedirActualizar({ plataforma: platform });
    if (!actualizarMedidoRef.current) {
      actualizarMedidoRef.current = true;
      trackEvent("app_actualizar_vista", { modulo: MODULOS.HOME, payload: { plataforma: platform, instalada: versionInstalada, minima } });
    }
  }, [configRemota, versionInstalada, session, pedirActualizar]);
  const revisarActualizacion = async () => {
    const config = await consultarConfig();
    const minima = config?.fresca ? config.version_minima?.[platform] || null : undefined;
    // Sin respuesta nueva no se suelta (ni se aprieta): se sigue pidiendo.
    if (minima === undefined) return;
    if (!debePedirActualizar({ instalada: versionInstalada, minima })) setPedirActualizar(null);
  };

  const formDataRef   = useRef(formData);
  formDataRef.current = formData;
  const skipHistoryPush  = useRef(false);
  const prepBackRef      = useRef(null);   // set by PreparaInternado
  const registroBackRef  = useRef(null);   // set by RegistroTurno (MiPAE en turno)
  const fichasBackRef    = useRef(null);   // set by Fichas (Medicamentos)
  const escalasBackRef   = useRef(null);   // set by Escalas (calculadora → lista)
  const gesBackRef       = useRef(null);   // set by Ges (GES Fonasa)
  const referenciaBackRef = useRef(null);  // set by ReferenciaRapida (sección → lista)
  const detalladoAtrasRef = useRef(null);  // set by PaeDetallado (espera la revisión de seguridad)
  const showRevisaRef    = useRef(false);

  // Pila de navegación entre pantallas (appState). Permite que el botón atrás
  // —tanto la flecha del header como el back físico de Android/navegador— vuelva
  // a la pantalla ANTERIOR real (p. ej. MiPAE en turno) en vez de saltar siempre al home.
  const navStackRef       = useRef([]);
  const navPrevRef        = useRef(appState);
  const navigatingBackRef = useRef(false);
  const scrollPosRef      = useRef({});   // posición de scroll por appState
  const pendingScrollRef  = useRef(null); // scroll a restaurar tras un "atrás"

  // Push history entry on every navigation (except home)
  useEffect(() => {
    if (appState === "home") return;
    if (skipHistoryPush.current) { skipHistoryPush.current = false; return; }
    window.history.pushState({ mipaeStep: step, mipaeMode: appState }, '');
  }, [step, appState]);

  // Mantiene la pila de navegación al cambiar de pantalla.
  useEffect(() => {
    const prev = navPrevRef.current;
    if (appState === prev) return;
    const stack = navStackRef.current;
    if (navigatingBackRef.current) {
      navigatingBackRef.current = false;            // ya volvimos atrás: la pila se ajustó en irAtras
    } else if (appState === "home") {
      stack.length = 0;                             // el home es la raíz: limpia el rastro
    } else {
      const idx = stack.indexOf(appState);
      if (idx !== -1) {
        stack.length = idx;                         // volver a un ancestro ya visitado (incluye el padre)
      } else if (stack[stack.length - 1] !== prev) {
        stack.push(prev);                           // navegación hacia adelante: recuerda el origen (sin duplicar)
      }
    }
    navPrevRef.current = appState;
  }, [appState]);

  // Recuerda la posición de scroll de cada pantalla (para restaurarla al volver).
  useEffect(() => {
    let ticking = false;
    const onScroll = () => {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(() => {
        scrollPosRef.current[appStateRef.current] = window.scrollY;
        ticking = false;
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  // Tras un "atrás", restaura el scroll de la pantalla a la que volvimos.
  useEffect(() => {
    if (pendingScrollRef.current == null) return;
    const y = pendingScrollRef.current;
    pendingScrollRef.current = null;
    requestAnimationFrame(() => {
      window.scrollTo(0, y);
      setTimeout(() => window.scrollTo(0, y), 60); // reintento por si el contenido monta tarde (lazy)
    });
  }, [appState]);

  // Sync showRevisa into ref so popstate can read it without re-registering
  useEffect(() => { showRevisaRef.current = showRevisa; }, [showRevisa]);

  // Listen for browser/Android back
  useEffect(() => {
    const handlePopState = () => {
      // Priority 1: close overlays without consuming a navigation step
      if (menuOpenRef.current) {
        closeMenu();
        window.history.pushState({}, '');
        return;
      }
      if (showRevisaRef.current) {
        setShowRevisa(false);
        window.history.pushState({}, '');
        return;
      }

      const mode = appStateRef.current;
      const s    = stepRef.current;
      if (mode === "home") return;
      skipHistoryPush.current = true;

      if (mode === "rapido") {
        if (s > 1) {
          if (s === 3 && formDataRef.current.rapido?.modelo !== 'libre') setStep(1);
          else setStep(s - 1);
        } else {
          salirDePae();
        }
      } else if (mode === "detallado") {
        // Con "Reintentar la revisión" en curso, el atrás espera su veredicto
        // (salir del paso lo perdía y la selección sin revisar llegaba al plan).
        // Desde el paso 1 se sale del PAE (ya no hay pantalla de unidad a la
        // que volver, decisión del fundador 4-oct-2026), y con algo escrito
        // se pregunta antes.
        if (detalladoAtrasRef.current?.()) {
          window.history.pushState({}, '');
          skipHistoryPush.current = false;
        } else if (s > 1) setStep(s - 1);
        else if (detalladoTieneDatos(formDataRef.current)) {
          window.history.pushState({}, '');
          skipHistoryPush.current = false;
          setConfirmarSalirPae(true);
        } else salirDePae();
      } else if (mode === "prepara-practica" || mode === "prepara-internado") {
        if (prepBackRef.current?.()) {
          window.history.pushState({}, '');
          skipHistoryPush.current = false;
        } else {
          irAtras();
        }
      } else if (mode === "registro-turno") {
        // Delegar a la navegación interna de MiPAE en turno (paciente → lista → hub).
        if (registroBackRef.current?.()) {
          window.history.pushState({}, ''); // mantener un paso para el próximo back
          skipHistoryPush.current = false;
        } else {
          irAtras();
        }
      } else if (mode === "fichas") {
        // Medicamentos maneja su back interno (detalle → lista) antes de salir.
        if (fichasBackRef.current?.()) {
          window.history.pushState({}, ''); // mantener un paso para el próximo back
          skipHistoryPush.current = false;
        } else {
          irAtras();
        }
      } else if (mode === "escalas") {
        // Escalas maneja su back interno (calculadora → lista) antes de salir.
        if (escalasBackRef.current?.()) {
          window.history.pushState({}, '');
          skipHistoryPush.current = false;
        } else {
          irAtras();
        }
      } else if (mode === "ges") {
        // GES maneja su back interno (detalle → lista) antes de salir.
        if (gesBackRef.current?.()) {
          window.history.pushState({}, ''); // mantener un paso para el próximo back
          skipHistoryPush.current = false;
        } else {
          irAtras();
        }
      } else if (mode === "referencia") {
        // Referencia rápida maneja su back interno (sección → lista) antes de salir.
        if (referenciaBackRef.current?.()) {
          window.history.pushState({}, '');
          skipHistoryPush.current = false;
        } else {
          irAtras();
        }
      } else {
        irAtras();
      }
    };
    window.addEventListener('popstate', handlePopState);
    return () => window.removeEventListener('popstate', handlePopState);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Swipe to open/close menu ─────────────────────────────────────────────────
  useEffect(() => {
    let startX = 0, startY = 0;
    const onTouchStart = (e) => {
      startX = e.touches[0].clientX;
      startY = e.touches[0].clientY;
    };
    const onTouchEnd = (e) => {
      const dx = e.changedTouches[0].clientX - startX;
      const dy = e.changedTouches[0].clientY - startY;
      if (Math.abs(dx) < Math.abs(dy) * 1.5 || Math.abs(dx) < 50) return;
      if (dx < -50 && startX > window.innerWidth - 30) {
        // Swipe left from right edge → open
        setMenuOpen(true);
        requestAnimationFrame(() => requestAnimationFrame(() => setMenuEntered(true)));
        menuOpenRef.current = true;
      } else if (dx > 50 && menuOpenRef.current) {
        // Swipe right when menu open → close
        setMenuEntered(false);
        setTimeout(() => { setMenuOpen(false); menuOpenRef.current = false; }, 300);
      }
    };
    document.addEventListener('touchstart', onTouchStart, { passive: true });
    document.addEventListener('touchend', onTouchEnd, { passive: true });
    return () => {
      document.removeEventListener('touchstart', onTouchStart);
      document.removeEventListener('touchend', onTouchEnd);
    };
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  // ── Draft persistence ────────────────────────────────────────────────────────

  // El PAE sin terminar se busca cada vez que se vuelve al inicio o se abre
  // Tu PAE, no solo al abrir la app (paso 2 de la interfaz por experiencia,
  // 2026-10-16): quien sale de un PAE a medias lo encuentra ahí para seguirlo,
  // y uno que ya se guardó o se descartó deja de ofrecerse.
  useEffect(() => {
    if (appState !== "home" && appState !== "tu-pae") return;
    try {
      const now = Date.now();
      const drafts = Object.keys(localStorage)
        .filter(k => k.startsWith('mipae:draft:'))
        .map(k => {
          try { return { key: k, data: JSON.parse(localStorage.getItem(k)) }; }
          catch { return null; }
        })
        .filter(d => d && d.data?.timestamp && (now - d.data.timestamp < 24 * 60 * 60 * 1000))
        // Uno sin nada escrito (abrir el PAE y volver, antes de que el
        // autoguardado lo evitara) no se ofrece, y se limpia.
        .filter(d => {
          if (borradorTieneDatos(d.data)) return true;
          try { localStorage.removeItem(d.key); } catch { /* ignore */ }
          return false;
        })
        .sort((a, b) => b.data.timestamp - a.data.timestamp);
      setBorradorPendiente(drafts.length > 0 ? drafts[0] : null);
    } catch { /* ignore */ }
  }, [appState]);

  // Autosave on every meaningful state change while in a PAE. El Detallado
  // también (auditoría 4-oct-2026: recargar en el paso 7 perdía todo). Su id
  // de sesión lleva prefijo propio (startMode no lo asigna, y uno heredado de
  // un Rápido pisaría ese borrador); la unidad sola no es un borrador, y uno
  // ya guardado en la cuenta tampoco. El borrador guarda su `mode`.
  useEffect(() => {
    if (!esNuevoPAE) return;
    if (appState === "detallado" && step < 1) {
      // Un Detallado que arranca (unidad por elegir, sin fila en la cuenta)
      // es un borrador nuevo: el guardado del anterior no cuenta.
      if (paeGuardadoFinal && !paeIdActual) setPaeGuardadoFinal(false);
      return;
    }
    // Ya está en la cuenta, en los DOS modos: onPAESaved acaba de borrar el
    // borrador y este efecto corre justo después (depende de
    // paeGuardadoFinal). Sin esta guarda el Rápido lo reescribía, al abrir de
    // nuevo aparecía "PAE Rápido sin terminar" y "Continuar" insertaba una
    // segunda fila (revisión 4-oct-2026).
    if (paeGuardadoFinal) return;
    if (appState === "detallado") {
      if (!esSesionDetallado(sessionIdRef.current)) sessionIdRef.current = `${PREFIJO_SESION_DETALLADO}${Date.now()}`;
      // Sin nada escrito no hay borrador que retomar: "PAE Detallado sin
      // terminar" sobre una pantalla vacía sería falso.
      if (!detalladoTieneDatos(formData)) {
        try { localStorage.removeItem(`mipae:draft:${sessionIdRef.current}`); } catch { /* ignore */ }
        return;
      }
    } else if (appState !== "rapido" || !sessionIdRef.current) {
      return;
    } else if (!rapidoTieneDatos(formData)) {
      // Igual que el Detallado: abrir el Rápido y volver sin escribir no es un
      // PAE sin terminar (con solo el modelo elegido tampoco).
      try { localStorage.removeItem(`mipae:draft:${sessionIdRef.current}`); } catch { /* ignore */ }
      return;
    }
    try {
      const key = `mipae:draft:${sessionIdRef.current}`;
      localStorage.setItem(key, JSON.stringify(borradorParaGuardar({ mode: appState, step, formData, selected, esNuevoPAE })));
    } catch { /* ignore */ }
  }, [appState, step, formData, esNuevoPAE, selected, paeGuardadoFinal, paeIdActual]);

  // Warn before closing with unsaved PAE
  const hayDatosSinGuardar = (appState === "rapido" || (appState === "detallado" && detalladoTieneDatos(formData))) && esNuevoPAE && step >= 1 && !paeGuardadoFinal;
  useEffect(() => {
    const handler = (e) => {
      if (hayDatosSinGuardar) { e.preventDefault(); e.returnValue = ''; }
    };
    window.addEventListener('beforeunload', handler);
    return () => window.removeEventListener('beforeunload', handler);
  }, [hayDatosSinGuardar]);

  // ── Helpers ──────────────────────────────────────────────────────────────────
  const update = (section, key, value) => {
    setFormData(p => ({ ...p, [section]: { ...p[section], [key]: value } }));
  };

  // Helper para actualizar el plan NOC/NIC del PAE Rápido de forma atómica.
  // Acepta un mutator (newPlan o (prev) => newPlan) y persiste en formData.rapido._plan.
  // Es necesario porque las promesas IA de plazos/actividades siguen corriendo
  // después de que RapidoStep3 se desmonta — si solo usaran state local del step,
  // las actualizaciones se perderían y RapidoResumen mostraría "Calculando…" eterno.
  const updateRapidoPlan = (mutator) => {
    setFormData(p => {
      const currentPlan = p.rapido?._plan || {};
      const nextPlan = typeof mutator === 'function' ? mutator(currentPlan) : mutator;
      return { ...p, rapido: { ...p.rapido, _plan: nextPlan } };
    });
  };

  const setSection = (section, value) => {
    setFormData(p => ({ ...p, [section]: value }));
  };

  const reset = () => {
    // Salir del PAE/demo respeta el embudo: con perfil a medio completar se
    // vuelve a "perfil" (no a un home donde MiPAE en turno/Compañero no renderizan).
    setAppState(session ? resolveAuthState(profile, window.location.pathname) : "home");
    setStep(0); setUnit(null); setFormData({}); setSelected([]); setEsNuevoPAE(false);
    setPaeGuardadoFinal(false); sessionIdRef.current = null; setOrigenTurno(null);
    setEncuestaRamoModulo(null);
  };

  // Un guardado NUEVO de PAE (Rápido o Detallado) suma al contador local de la
  // micro encuesta del 3er PAE; quien llama ya separó la señal de la revisita
  // (`onPAESaved(esNuevoGuardado)`). Si toca preguntar, el módulo que guardó
  // la pinta bajo su resumen. Kill-switch REACT_APP_ENCUESTA_MOMENTO_ENABLED.
  const contarPaeGuardado = (modulo) => {
    if (!encuestaMomentoHabilitada()) return;
    const { ofrecerEncuesta } = registrarPaeGuardado({ userId: session?.user?.id });
    if (ofrecerEncuesta) setEncuestaRamoModulo(modulo);
  };

  // Salir del PAE por cualquier vía (pestañas, atrás) retira la encuesta: al
  // volver a otro PAE no se re-pinta una pregunta que ya se consumió.
  useEffect(() => {
    if (appState !== "rapido" && appState !== "detallado") setEncuestaRamoModulo(null);
  }, [appState]);

  const continuarBorrador = () => {
    if (!borradorPendiente) return;
    const d = borradorPendiente.data;
    // El borrador dice qué PAE es; uno viejo sin `mode` es del Rápido (era el
    // único que tenía borrador), así que se lee como Rápido y no se migra.
    const modo = modoDelBorrador(d);
    // Un borrador guardado antes del 2026-09-03 trae los valores de catálogo
    // del PAE Detallado con guión largo; se normalizan al leer, jamás se migran.
    setFormData(normalizarValoresPae(d.formData || {}));
    setStep(d.step || 1);
    if (modo === "detallado") setSelected(Array.isArray(d.selected) ? d.selected : []);
    // Un borrador no tiene fila en la cuenta (al guardar se borra), en los dos
    // modos: el id de otro PAE de esta sesión (uno guardado o abierto desde
    // Tus PAEs) no puede seguir vivo, porque el resumen del Rápido ahora
    // ACTUALIZA la fila cuyo id recibe en vez de insertar otra.
    setPaeIdActual(null);
    setEsNuevoPAE(d.esNuevoPAE !== undefined ? d.esNuevoPAE : true);
    setPaeGuardadoFinal(false);
    sessionIdRef.current = borradorPendiente.key.replace('mipae:draft:', '');
    setAppState(modo);
    setBorradorPendiente(null);
    setOrigenTurno(null);
  };

  // "Salir" confirmado desde el primer paso del Detallado: lo escrito se
  // pierde de verdad (también su borrador local), como dijo la pregunta.
  const salirDelDetalladoConfirmado = () => {
    setConfirmarSalirPae(false);
    if (sessionIdRef.current) {
      try { localStorage.removeItem(`mipae:draft:${sessionIdRef.current}`); } catch { /* ignore */ }
    }
    salirDePae();
  };

  const descartarBorrador = () => {
    if (borradorPendiente) {
      try { localStorage.removeItem(borradorPendiente.key); } catch { /* ignore */ }
      // Si ese borrador es el que sigue en memoria (se retomó y se salió sin la
      // flecha), también se suelta ahí: si no, la próxima puerta al PAE (el
      // inicio, el menú, Benito) lo resucitaba y lo guardaba de nuevo
      // (revisión del paso 2, 2026-10-16).
      if (sessionIdRef.current && borradorPendiente.key === `mipae:draft:${sessionIdRef.current}`) {
        sessionIdRef.current = null;
        setFormData({}); setSelected([]); setEsNuevoPAE(false); setPaeGuardadoFinal(false);
      }
    }
    setBorradorPendiente(null);
  };

  const goHome = () => {
    setAppState("home");
  };

  // Navegación para el compañero global (agente): mapea destinos "amigables" a
  // appState. Devuelve true si supo a dónde ir (lo usa la herramienta abrir_modulo).
  const irADestino = (destino) => {
    switch (destino) {
      case "inicio":       setAppState("home"); return true;
      // MiPAE en turno es gratis (D1, 2026-09-14): abrirRegistroTurno solo pide
      // sesión y el perfil completo.
      case "mi_turno":     abrirRegistroTurno("companero"); return true;
      // Por startMode, como cualquier otra puerta: sesión, cuota, borrador y
      // telemetría de inicio (antes Benito se las saltaba). "Supo a dónde ir"
      // aunque lo frene la cuota: el muro queda en pantalla.
      // Fuera de MiPAE Estudiante el PAE no existe (2026-10-16): segunda
      // defensa, como la de la evolución; la herramienta ya lo frena antes.
      case "pae_rapido":   if (!paeEnEsteMundo) return false; startMode("rapido", "companero"); return true;
      case "pae_detallado":if (!paeEnEsteMundo) return false; startMode("detallado", "companero"); return true;
      case "escalas":      setEscalaInicial(null); setAppState("escalas"); return true;
      // abrirFichas() abre la lista: setAppState("fichas") a secas reabría la
      // última ficha vista (A4).
      case "medicamentos": abrirFichas(); return true;
      case "ges":          setAppState("ges"); return true;
      case "infusiones":   abrirLaboratorio(); return true;
      // Nombre viejo (hilos y caché anteriores al 4-oct-2026): "laboratorio"
      // ahora lleva a lo que promete, los valores de laboratorio.
      case "laboratorio":  abrirReferencia("laboratorio"); return true;
      case "enciclopedia": abrirReferencia(); return true;
      case "biblioteca":   irAModulo('bibliografia', () => setAppState("bibliografia")); return true;
      case "bibliografia": abrirBibliografia(); return true;
      case "bitacora":     setAppState("bitacora"); return true;
      case "calendario":   setAppState(rotacion ? "calendario" : "calendario-config"); return true;
      case "mi_progreso":  setAppState("mi-progreso"); return true;
      case "respira":      setAppState("respira"); return true;
      // Se cuenta como cualquier otra puerta a Planes (auditoría de conversión
      // del 25-oct-2026: Benito la abría sin dejar rastro en el embudo).
      case "planes":       logFreemiumMetric('planes_abierto', 'benito'); setAppState("planes"); return true;
      // La evolución por sistema valora: el TENS no llega a ella (frontera
      // del rol, lib/tens.js), tampoco de visita en otro mundo.
      case "evolucion":    if (turnoEsCapaTens) return false; abrirEvolucionSistema("companero"); return true;
      case "reto":         setAppState("reto"); return true;
      case "revisa":       openRevisa("companero"); return true; // gating de cuota/login lo maneja openRevisa
      default:             return false;
    }
  };

  // Acciones del compañero global hacia ítems específicos.
  // `modelo` (opcional) viene de iniciar_pae: "arma un PAE con Gordon".
  // Devuelve si el PAE arrancó de verdad: si lo frenó el login o la cuota,
  // Benito no puede decir "Listo, arranqué tu PAE con Gordon" mientras en
  // pantalla está el muro.
  const iniciarPae = (modo, modelo = null) => startMode(modo === "detallado" ? "detallado" : "rapido", "companero", { modelo });
  // La herramienta de Benito pregunta ANTES de pedir el arranque (su acción
  // se difiere al final del loop y no puede devolver lo que pasó): mismas
  // condiciones que startMode, sin efectos. El motivo es catálogo cerrado.
  const puedeIniciarPae = (modo) => {
    if (!paeEnEsteMundo) return { ok: false, motivo: "otro_mundo" };
    const bloqueo = bloqueoInicioPae(modo === "detallado" ? "detallado" : "rapido");
    if (!bloqueo) return { ok: true };
    return { ok: false, motivo: bloqueo === "sin_sesion" ? "sin_sesion" : "limite" };
  };
  const abrirPacienteTurno = (cama) => { setTurnoCamaInicial(cama || null); setAppState("registro-turno"); return true; };

  // Abre la pantalla dedicada de planes MiPAE+ (oferta proactiva).
  // PAE con tu pauta: gate en el punto de uso (1 al mes en gratis, sin tope
  // con acceso Plus) y recuento de cuota tras usarla.
  const pautaProps = {
    puedeUsar: !session || puedeAccederIA('pauta', { profile: perfilCupoPae, uso: usoIA }),
    onRequierePlus: () => setPremiumPaywall('pauta'),
    onUsada: refrescarUsoIA,
  };

  // "Lo nuevo de MiPAE": la pantalla de la invitación del 25-oct. `origen`
  // solo mide de dónde se llegó (aviso del inicio, correo, menú).
  const abrirLoNuevo = (origen = "aviso") => {
    closeMenu();
    if (!session) { handleLogin(); return; }
    setLoNuevoOrigen(origen);
    setAppState("lo-nuevo");
  };

  // Los avisos de la campaña del 25 en el teléfono (lib/notificacionesLanzamiento.js)
  // necesitan saber quién es la persona (el perfil REAL, la casa), su
  // calendario con los cambios hechos a mano y lo que dice el servidor del 25:
  // se reprograman cuando cambia cualquiera. También al cerrar sesión (perfil
  // null), para que no queden avisos de una cuenta que ya no está.
  const [overridesLanzamiento, setOverridesLanzamiento] = useState(SIN_OVERRIDES);
  useEffect(() => {
    const uid = session?.user?.id;
    if (!isNative || !uid || !rotacion || !campanaVigente()) { setOverridesLanzamiento(SIN_OVERRIDES); return; }
    const hoy = new Date();
    supabase
      .from("turno_overrides")
      .select("*")
      .eq("user_id", uid)
      .gte("fecha", toDateKey(addDays(hoy, -1)))
      .lte("fecha", toDateKey(addDays(hoy, 6)))
      .then(({ data }) => setOverridesLanzamiento(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, [session?.user?.id, rotacion]);
  useEffect(() => {
    fijarContextoLanzamiento({ profile, rotacion, overrides: overridesLanzamiento });
    if (isNative) safeInvoke("tips", programarTips);
  }, [profile, rotacion, overridesLanzamiento, configRemota]);

  // Tocar uno de esos avisos lleva a "Lo nuevo de MiPAE", pero solo desde el
  // inicio y con el perfil listo: nunca saca a nadie de un turno ni de un PAE
  // a medio escribir. Si se tocó en otra pantalla, espera a la vuelta al inicio.
  const [loNuevoPorToque, setLoNuevoPorToque] = useState(false);
  useEffect(() => escucharToqueNotificacion((extra) => {
    if (extra?.destino === "lo-nuevo") setLoNuevoPorToque(true);
  }), []);
  useEffect(() => {
    // Sin sesión, un toque pendiente no se le traspasa a la próxima cuenta.
    if (loNuevoPorToque && session === null) { setLoNuevoPorToque(false); return; }
    if (!loNuevoPorToque || !session || !profile || appState !== "home") return;
    setLoNuevoPorToque(false);
    abrirLoNuevo("notificacion");
  }, [loNuevoPorToque, session, profile, appState]); // eslint-disable-line react-hooks/exhaustive-deps

  const abrirPlanes = (source = "home") => {
    closeMenu();
    if (!session) { handleLogin(); return; }
    logFreemiumMetric('planes_abierto', source);
    setAppState("planes");
  };

  // Vuelve a la pantalla anterior real según la pila de navegación.
  // Si no hay rastro, cae al home. Lo usan la flecha del header y el back físico.
  const irAtras = () => {
    const target = navStackRef.current.pop() || "home";
    navigatingBackRef.current = true;
    pendingScrollRef.current = scrollPosRef.current[target] ?? 0;
    // Volver a la Enciclopedia desde la Biblioteca: reabre la ficha o la
    // sección desde donde se salió (A35). Va en el mismo lote que el cambio de
    // pantalla, así la Enciclopedia monta directo ahí.
    if (target === "referencia" && referenciaRetornoRef.current) {
      setReferenciaInicial(referenciaRetornoRef.current);
      setReferenciaClave((c) => c + 1);
      referenciaRetornoRef.current = null;
    }
    setAppState(target);
  };

  // Salir de un PAE por "atrás" desde el primer paso. Limpia el estado del PAE
  // y vuelve al origen real (pila de navegación) en vez de forzar el home: si
  // el PAE se abrió desde MiPAE en turno, regresa a MiPAE en turno; si fue desde el home,
  // vuelve al home.
  const salirDePae = () => {
    setStep(0); setUnit(null); setFormData({}); setSelected([]); setEsNuevoPAE(false);
    setPaeGuardadoFinal(false); sessionIdRef.current = null; setOrigenTurno(null);
    irAtras();
  };

  // Abre Respira con un contexto que determina los mensajes de la sesión.
  // `tecnicaId` (y su `duracion`) llegan desde el home de Bienestar: Respira
  // salta la pantalla de elegir técnica. Sin ellos, el flujo de siempre.
  const abrirRespira = (ctx = "generico", tecnicaId = null, duracion = null) => {
    setRespiraDesdeBienestar(appState === "bienestar" || appState === "practica");
    setRespiraContexto(ctx);
    setRespiraTecnica(tecnicaId);
    setRespiraDuracion(duracion);
    setAppState("respira");
  };

  // Home del módulo Bienestar (con el flag ON). Con el flag apagado no se
  // llama: la pestaña sigue abriendo el popover.
  const abrirBienestar = () => setAppState("bienestar");
  // `origen` es catálogo cerrado ('momento' | 'lista'): viaja a la
  // telemetría de la pausa guiada (practica_*), jamás texto.
  const [practicaOrigen, setPracticaOrigen] = useState("lista");
  const abrirPractica = (id, origen = "lista") => {
    setPracticaId(id);
    setPracticaOrigen(origen === "momento" ? "momento" : "lista");
    setAppState("practica");
  };

  // Overrides del calendario para el momento de Bienestar: AYER (el ancla
  // post-noche mira el turno de ayer) y HOY. Solo al entrar al módulo y solo
  // con rotación; best-effort (sin ellos el momento cae al patrón puro, como
  // el resto de la app antes de #682).
  useEffect(() => {
    if (!BIENESTAR_MODULO_ENABLED || appState !== "bienestar") return;
    const userIdOv = session?.user?.id;
    if (!userIdOv || !rotacion) return;
    const hoy = new Date();
    supabase
      .from("turno_overrides")
      .select("*")
      .eq("user_id", userIdOv)
      .gte("fecha", toDateKey(addDays(hoy, -1)))
      .lte("fecha", toDateKey(hoy))
      .then(({ data }) => setOverridesBienestar(Array.isArray(data) ? data : []))
      .catch(() => {});
  }, [appState, session?.user?.id, rotacion]); // eslint-disable-line react-hooks/exhaustive-deps
  const turnoHoyBienestar = rotacion
    ? calcularTurnoDelDia(new Date(), rotacion, overrideDelDia(new Date(), overridesBienestar))
    : null;

  // Abre Medicamentos. Con slug, deep-linkea a la ficha del fármaco.
  const abrirFichas = (slug = null) => {
    if (slug) {
      const m = spotlight.meds.find((x) => x.slug === slug);
      setRecientes(addReciente({ tipo: "med", slug, label: m?.nombre_generico || slug, modulo: "fichas" }));
    }
    setFichaInicial(slug);
    setAppState("fichas");
  };

  // Abre el módulo GES. Con slug, deep-linkea a la ficha del problema.
  const abrirGes = (slug = null) => {
    if (slug) {
      const g = spotlight.ges.find((x) => x.slug === slug);
      setRecientes(addReciente({ tipo: "ges", slug, label: g?.nombre_corto || g?.nombre_oficial || slug, modulo: "ges" }));
      addVistaGes(slug);
    }
    setGesInicial(slug);
    setAppState("ges");
  };

  // Clave de montaje de la Enciclopedia: sube SOLO cuando se abre una sección
  // puntual (buscador, Benito, recientes, una ficha de modelo). No se deriva de
  // `referenciaInicial` porque una clave derivada remontaba al índice cuando
  // ese valor se limpiaba (revisión 2026-10-02). Con la clave aparte, Benito puede
  // abrir otra sección estando ya dentro y el deep link se queda donde llegó.
  const [referenciaClave, setReferenciaClave] = useState(0);
  // Dónde reabrir la Enciclopedia al volver de la Biblioteca (A35) y cuál es
  // la sección abierta ahora. Refs y no estado: los lee irAtras, que también
  // corre desde el listener del atrás físico registrado una sola vez.
  const referenciaRetornoRef = useRef(null);
  const seccionEnciclopediaRef = useRef(null);
  const abrirReferencia = (seccion = null) => {
    if (seccion) setReferenciaClave((c) => c + 1);
    setReferenciaInicial(seccion);
    referenciaRetornoRef.current = null; // una entrada nueva no vuelve a una ficha vieja
    setAppState("referencia");
  };

  // Registra la sección de Referencia abierta como "reciente" para el Home.
  // Memoizado: se pasa como prop a ReferenciaRapida, cuyo efecto de apertura
  // depende de esta referencia; sin useCallback cambiaba en cada render.
  // También recuerda cuál es la sección abierta, para volver a ella desde la
  // Biblioteca (abrirBibliografiaDesdeEnciclopedia).
  const registrarRefReciente = useCallback((id, titulo) => {
    if (id) seccionEnciclopediaRef.current = id;
    if (id) setRecientes(addReciente({ tipo: "referencia", slug: id, label: titulo || "Referencia", modulo: "referencia" }));
  }, []);

  // "Ver la bibliografía" desde una ficha de modelo o desde las Fuentes de LPP
  // (A35): el Volver de la Biblioteca devolvía al Inicio y borraba el PAE en
  // curso. Ahora vuelve atrás de verdad y la Enciclopedia reabre donde se
  // estaba: la ficha del modelo si la ficha manda su id, o si no la sección
  // (o el enlace "modelos:<id>" con que se llegó, que la Enciclopedia limpia
  // al salir y aquí se guarda hasta volver). La permisión de la Biblioteca no
  // cambia (decisión pendiente del fundador).
  const abrirBibliografiaDesdeEnciclopedia = (modeloId) => irAModulo('bibliografia', () => {
    const seccion = seccionEnciclopediaRef.current;
    let retorno = seccion || null;
    if (typeof modeloId === "string" && modeloId) retorno = `modelos:${modeloId}`;
    else if (seccion && typeof referenciaInicial === "string" && referenciaInicial.split(":")[0] === seccion) retorno = referenciaInicial;
    referenciaRetornoRef.current = retorno;
    setEstudioTab('bibliografia');
    setAppState('bibliografia');
  });

  // Abre la calculadora de infusiones. Con slug, preselecciona ese fármaco.
  const abrirLaboratorio = (slug = null) => {
    if (slug) {
      const m = spotlight.meds.find((x) => x.slug === slug);
      setRecientes(addReciente({ tipo: "lab", slug, label: `Infusión: ${m?.nombre_generico || slug.replace(/-/g, " ")}`, modulo: "laboratorio" }));
    }
    setLabInicial(slug);
    setAppState("laboratorio");
  };

  // Abre una escala clínica por id, registrándola en "sigue donde quedaste".
  const abrirEscala = (id = null) => {
    if (id) {
      const e = ESCALAS.find((x) => x.id === id);
      setRecientes(addReciente({ tipo: "escala", slug: id, label: e?.nombre || id, modulo: "escalas" }));
    }
    setEscalaInicial(id);
    setAppState("escalas");
  };

  // Mide el uso del lanzamiento abierto por capa (rol): qué funciones Plus usa
  // quién, para saber qué monetizar primero cuando se cierre. Solo cuenta a
  // quienes tienen el acceso liberado y no pagan (early adopters).
  const trackLanzamientoUso = (feature) => {
    if (!accesoPlusAbierto() || !session || isPremium) return;
    trackEvent('lanzamiento_plus_uso', {
      modulo: 'lanzamiento_plus',
      payload: { rol: profile?.rol || 'sin_rol', feature },
    });
  };

  const openRevisa = (source = "unknown") => {
    // Eje login: requiere sesión activa.
    if (!puedeAbrir('revisa', { isLoggedIn: !!session })) {
      logFreemiumMetric('login_cta', 'revisa_guest', { source });
      handleLogin();
      return;
    }
    // Eje pago: cuota mensual de IA (usuario logueado free).
    if (session && !puedeAccederIA('revisa', { profile: perfilMundo, uso: usoIA })) {
      logFreemiumMetric('paywall_shown', 'mipae_plus_revisa', { source });
      setPremiumPaywall('revisa');
      return;
    }
    trackLanzamientoUso('revisa');
    setRevisaSource(source);
    setShowRevisa(true);
  };

  // Puertas de módulo de junio, ABIERTAS (MiPAE extendido, D1, 2026-09-14):
  // entrega, evolución y el hub de MiPAE en turno son gratis para todos; la
  // extendida limita USO de IA (topes), no abre módulos. Los paywalls
  // 'entrega'/'evolucion'/'registro' de PremiumPaywall quedan sin disparador.
  // Fijado por test ("MiPAE en turno es gratis"): no volver a poner
  // `!isMipaePlus` como candado acá.
  const abrirEntregaTurno = (source = "home") => {
    if (!session) { handleLogin(); return; }
    trackLanzamientoUso('entrega_turno');
    setAppState('entrega-turno');
  };

  // Evolución por sistema: gratis (ver arriba).
  const abrirEvolucionSistema = (source = "home") => {
    if (!session) { handleLogin(); return; }
    trackLanzamientoUso('evolucion_sistema');
    setAppState('evolucion-sistema');
  };

  // Registro del día (MiPAE en turno): gratis (ver arriba).
  const abrirRegistroTurno = (source = "home") => {
    if (!session) { handleLogin(); return; }
    // Sin el perfil terminado MiPAE en turno no se dibuja: la pestaña "En
    // turno" dejaba una pantalla vacía en pleno onboarding (auditoría
    // estudiante 4-oct-2026, A3). Se vuelve a lo que falta del embudo. Se mira
    // perfil_completado y no resolveAuthState: el perfil recién guardado en el
    // onboarding puede no traer edad_confirmada_18 en memoria, y eso mandaba
    // a confirmar la edad a quien ya la había confirmado.
    if (!profile?.perfil_completado) { setAppState(profile?.edad_confirmada_18 ? "perfil" : "confirmacion-edad"); return; }
    // Rol TENS: su MiPAE en turno ES la capa TENS (decisión del fundador 26-jul,
    // revisada: acceso abierto a toda la app, solo esta superficie cambia de
    // cara). Sin muro MiPAE+ en v1: es la capa del piloto institucional.
    // Tres mundos: la frontera se mira con el perfil REAL, así un TENS de
    // visita en MiPAE Estudiante sigue llegando a su capa y jamás al registro
    // del enfermero; un enfermero de visita en MiPAE TENS ve la capa TENS.
    if (turnoEsCapaTens) {
      trackEvent("tens_home_abierto", { modulo: 'tens', payload: { source } });
      setAppState("registro-turno");
      return;
    }
    // Estudiante sin internado en curso (P1, decisión del fundador
    // 2026-10-04): una presentación corta con la opción de probarlo con un
    // paciente ficticio, en vez del centro de control completo. Si ya está
    // dentro (probando), tocar la pestaña lo deja donde está.
    if (veEnTurnoEstudiante(perfilMundo) && appStateRef.current !== 'registro-turno') {
      setAppState('en-turno-estudiante');
      return;
    }
    trackLanzamientoUso('registro_turno');
    setAppState('registro-turno');
  };

  // "Probar con un paciente ficticio" de la presentación (P1): entra a MiPAE
  // en turno por el MISMO camino que el cierre del tour (`practicaAlEntrar`):
  // RegistroTurno abre la cama de práctica que exista o crea una (jamás dos),
  // y sus reglas siguen intactas (nunca sube al remoto, no suma racha).
  const probarEnTurnoEstudiante = () => {
    setTurnoPracticaAlEntrar(true);
    trackLanzamientoUso('registro_turno');
    setAppState('registro-turno');
  };

  // Aterrizaje post-onboarding: TODOS aterrizan en el Home (decisión del
  // fundador, 2026-07-31). Antes el enfermero caía directo en MiPAE en turno, la
  // pantalla más compleja de la app, sin haber visto ni un mapa: era la
  // fábrica del "derechamente se pierde". Ahora el video de bienvenida
  // (re-grabado a la app actual) corre primero, y en el Home Benito empuja
  // fuerte hacia MiPAE en turno con el primer paso claro — acompañar, no lanzar al
  // agua. El gate de plan de MiPAE en turno se encuentra por el camino normal.
  const aterrizarPostOnboarding = (perfilGuardado) => {
    // Quien llegó eligiendo una membresía (el botón de /precios o el de un
    // correo) y recién creó su cuenta sigue con esa membresía, no con el
    // inicio: es lo que vino a hacer (auditoría de conversión del 25-oct-2026).
    // La vuelta de Google ya dejó `?planes=1` en la URL (lib/retornoPlanes.js).
    if (!isNative && new URLSearchParams(window.location.search).get('planes') === '1') {
      consumirRetornoPlanes();
      registrarEmbudo('planes_abierto', 'enlace');
      setAppState('planes');
      return;
    }
    const pedido = new URLSearchParams(window.location.search).get('inicio');
    setAppState(destinoBienvenida(pedido, perfilGuardado) || 'home');
  };

  // Auto-foco de MiPAE en turno (ON por defecto durante un turno en curso; dictado
  // del fundador 2026-07-31): el delta que mata la adopción es abrir la app y
  // LLEGAR a hacer lo que viniste a hacer. Con turno en curso, la app abre en
  // MiPAE en turno — y si hay una cama viva, DIRECTO en esa cama con la barra de
  // captura lista (cero navegación entre la puerta y el registro). Solo una
  // vez por sesión de app; el Home queda a un toque en la barra; se apaga en
  // el perfil (switch de siempre); nunca corre sobre el video de bienvenida
  // ni fuerza el paywall.
  const autoFocoHecho = useRef(false);
  // Dónde aterrizó el arranque (para app_abierta): 'cama' | 'registro-turno'
  // si el auto-foco disparó; null = quedó en el Home. Ref y no estado: los dos
  // efectos corren en el mismo commit y el ref es síncrono.
  const destinoBootRef = useRef(null);
  useEffect(() => {
    if (autoFocoHecho.current) return;
    if (appState !== "home" || showTour || !session || !profile?.perfil_completado || !rotacion) return;
    // El estudiante sin internado en curso tiene en "En turno" una
    // presentación, no un turno que registrar (P1): el auto-foco no le aplica.
    // Sin esto saltaba directo al centro de control que su pestaña ya no abre
    // (revisión 4-oct-2026).
    if (veEnTurnoEstudiante(profile)) return;
    // De visita en otro mundo no se salta al turno de la casa (tres mundos).
    if (deVisita) return;
    if (!getAutoFocoTurno(session.user.id)) return;
    const t = calcularTurnoDelDia(new Date(), rotacion);
    if (t.tipo === "libre" || !t.horaInicio || !t.horaFin) return;
    const now = new Date();
    const nowMin = now.getHours() * 60 + now.getMinutes();
    const [hi, mi] = t.horaInicio.split(":").map(Number);
    const [hf, mf] = t.horaFin.split(":").map(Number);
    const ini = hi * 60 + (mi || 0);
    const fin = hf * 60 + (mf || 0);
    const enCurso = t.terminaSiguienteDia ? nowMin >= ini || nowMin < fin : nowMin >= ini && nowMin < fin;
    if (!enCurso) return;
    autoFocoHecho.current = true;
    let camaViva = null;
    try { camaViva = camaActivaTurno(cargarRegistros(session.user.id)); } catch { camaViva = null; }
    destinoBootRef.current = camaViva ? "cama" : "registro-turno";
    if (camaViva) { abrirPacienteTurno(camaViva.cama); return; }
    setAppState("registro-turno");
  }, [appState, showTour, session, profile, rotacion, deVisita]); // eslint-disable-line react-hooks/exhaustive-deps

  // app_abierta: 1× por sesión de app (la métrica del delta entrada→registro,
  // plan 31-jul). El Home era mudo y sin este evento el delta no se podía
  // medir sin sesgo. Va DESPUÉS del efecto de auto-foco (mismo commit): el ref
  // ya dice dónde aterrizó. Catálogo cerrado en el payload: solo el destino.
  useEffect(() => {
    if (appState !== "home" || !session || !profile?.perfil_completado) return;
    try {
      if (sessionStorage.getItem("mipae_app_abierta")) return;
      sessionStorage.setItem("mipae_app_abierta", "1");
    } catch { return; } // sin storage no hay guard: mejor no duplicar eventos
    trackEvent("app_abierta", { modulo: "home", payload: { destino: destinoBootRef.current || "home" } });
  }, [appState, session, profile]);

  // Revisa+ (consultor de turno): abre Revisa con el contexto del paciente del
  // Registro del día como contexto persistente de la conversación (no embutido
  // en el texto de la consulta), con una pregunta sugerida lista para enviar.
  const consultarRevisaPlus = (contexto, guardarNota) => {
    setRevisaPatientContext(contexto);
    // El consultor puede devolver la orientación como nota al paciente activo.
    setRevisaGuardarNota(() => (typeof guardarNota === 'function' ? guardarNota : null));
    setRevisaInitialQuery("¿Qué debo vigilar ahora y cuándo escalar?");
    setRevisaSource('registro_turno');
    setShowRevisa(true);
  };

  const closeRevisa = () => {
    setShowRevisa(false);
    setRevisaInitialQuery("");
    setRevisaPatientContext("");
    setRevisaGuardarNota(null);
    setRevisaSource("unknown");
  };

  useEffect(() => {
    if (appState !== "home" || session || freemiumViewRef.current.home) return;
    logFreemiumMetric('explainer_viewed', 'home');
    freemiumViewRef.current.home = true;
  }, [appState, session]); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    if (!menuOpen || session) return;
    logFreemiumMetric('explainer_viewed', 'menu');
  }, [menuOpen, session]); // eslint-disable-line react-hooks/exhaustive-deps

  // ── PWA: service worker update ────────────────────────────────────────────────
  useEffect(() => {
    const handler = (e) => setSwRegistration(e.detail);
    window.addEventListener('swUpdateAvailable', handler);
    return () => window.removeEventListener('swUpdateAvailable', handler);
  }, []);

  // ── PWA: online / offline ─────────────────────────────────────────────────────
  useEffect(() => {
    const onOnline  = () => setIsOffline(false);
    const onOffline = () => setIsOffline(true);
    window.addEventListener('online',  onOnline);
    window.addEventListener('offline', onOffline);
    return () => {
      window.removeEventListener('online',  onOnline);
      window.removeEventListener('offline', onOffline);
    };
  }, []);

  // ── PWA: install prompt ───────────────────────────────────────────────────────
  // La decisión vive pura en lib/instalarPwa.js: la heurística de iOS no se
  // puede leer de un vistazo y ya se equivocó una vez (ver el comentario del
  // archivo). Acá solo se leen las señales del navegador y se pregunta.
  useEffect(() => {
    if (!debeOfrecerInstalacion({
      nativo: isNative,
      displayModeStandalone: window.matchMedia('(display-mode: standalone)').matches,
      dismissed: localStorage.getItem('mipae_install_dismissed') === '1',
    })) return;
    const handler = (e) => { e.preventDefault(); setInstallPrompt(e); };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  // ── PWA: instrucciones para Safari/iOS (no soporta beforeinstallprompt) ───────
  useEffect(() => {
    if (debeMostrarInstruccionesSafari({
      nativo: isNative,
      userAgent: navigator.userAgent,
      displayModeStandalone: window.matchMedia('(display-mode: standalone)').matches,
      navigatorStandalone: navigator.standalone,
      dismissed: localStorage.getItem('mipae_install_dismissed') === '1',
    })) {
      setShowSafariInstall(true);
    }
  }, []);

  const handleSWUpdate = () => {
    if (swRegistration?.waiting) {
      swRegistration.waiting.postMessage({ type: 'SKIP_WAITING' });
    }
    window.location.reload();
  };

  const handleInstall = async () => {
    if (!installPrompt) return;
    installPrompt.prompt();
    await installPrompt.userChoice;
    setInstallPrompt(null);
  };

  const handleDismissInstall = () => {
    localStorage.setItem('mipae_install_dismissed', '1');
    setInstallPrompt(null);
    setShowSafariInstall(false);
  };

  // Qué cuota frena un Detallado NUEVO, o null si puede empezar. Primero la
  // de PAE (la común de 5: el Detallado también la gasta), después la propia.
  const cuotaParaIniciarDetallado = () => {
    if (!session) return null;
    if (!puedeAccederIA('pae', { profile: perfilCupoPae, uso: usoIA })) return 'pae';
    if (!puedeAccederIA('detallado', { profile: perfilCupoPae, uso: usoIA })) return 'detallado';
    return null;
  };

  // Qué frena empezar un PAE NUEVO, o null si puede: 'sin_sesion' o la cuota
  // que lo frena ('pae' | 'detallado'). Sin efectos. Lo leen startMode, el
  // puente desde MiPAE en turno y la consulta de Benito (puedeIniciarPae), así
  // las tres puertas miran exactamente las mismas condiciones.
  const bloqueoInicioPae = (m) => {
    if (m === "detallado") {
      if (!canStartDetallado()) return "sin_sesion";
      return cuotaParaIniciarDetallado();
    }
    if (!canStartRapido()) return "sin_sesion";
    if (session && !puedeAccederIA('pae', { profile: perfilCupoPae, uso: usoIA })) return "pae";
    return null;
  };

  // Un Detallado NUEVO parte limpio, entre por startMode o por el puente
  // desde una cama: sin la selección, el "guardado", la sesión de borrador ni
  // la anamnesis IA del anterior. El puente no lo hacía y el Detallado de la
  // cama nacía con los diagnósticos elegidos y el "ya guardado" del PAE
  // previo (revisión 4-oct-2026). Sin la pantalla "Elige tu unidad" (P3,
  // decisión del fundador 2026-10-04) la unidad es UCI (`formData.unit`, el
  // mismo dato que guardaba esa pantalla y que el PDF usa como servicio).
  const resetPaeDetallado = (formDataInicial = { unit: UNIDAD_DETALLADO }) => {
    sessionIdRef.current = Date.now().toString();
    setPaeGuardadoFinal(false);
    setPaeIdActual(null);
    setSelected([]);
    setAnamnesisIA(null);
    setFormData(formDataInicial);
    setUnit(UNIDAD_DETALLADO);
  };

  // Puerta ÚNICA para empezar un PAE (Inicio, menú, buscador, Benito, la
  // ficha de un modelo, Mi progreso, el tour, Tus PAEs…). Devuelve true si el
  // PAE arrancó y false si lo frenó la sesión o la cuota: así quien llama
  // registra lo suyo solo cuando de verdad empezó (modelo_a_pae, B20).
  // `modelo` (opcional, solo Rápido): el modelo de valoración elegido en la
  // puerta, aplicado con la misma regla de "Armar un PAE con este modelo".
  // Auditoría estudiante 4-oct-2026: Benito abría el PAE por fuera de aquí y
  // se saltaba la cuota, el borrador y la telemetría de inicio.
  const startMode = (m, source = "unknown", { modelo = null, desdeCero = false } = {}) => {
    // Fuera de MiPAE Estudiante el PAE no existe (2026-10-16). Las superficies
    // ya no lo ofrecen; esto es la red por si un camino se escapa.
    if ((m === "rapido" || m === "detallado") && !paeEnEsteMundo) return false;
    // Un inicio "normal" (no desde MiPAE en turno) nunca debe arrastrar el banner
    // "Traído de tu turno" de una sesión anterior.
    setOrigenTurno(null);
    if (m === "rapido") {
      const bloqueo = bloqueoInicioPae("rapido");
      if (bloqueo === "sin_sesion") {
        logFreemiumMetric('login_cta', 'rapido_guest', { source });
        handleLogin();
        return false;
      }
      // Cuota mensual de IA (usuario logueado free): si superó el tope, MiPAE+.
      if (bloqueo) {
        logFreemiumMetric('paywall_shown', 'mipae_plus_pae', { source });
        setPremiumPaywall('pae');
        return false;
      }
      // Un PAE ya guardado, o reabierto desde Tus PAEs, terminó: el nuevo parte
      // vacío (formDataAlIniciarRapido). Un borrador en curso se conserva.
      // `desdeCero`: "Empieza uno nuevo" de Tu PAE promete un PAE en blanco al
      // lado del borrador que ofrece seguir. Sin esto, con un borrador
      // retomado en memoria, el "nuevo" nacía con el caso viejo y dejaba dos
      // borradores del mismo caso (revisión del paso 2, 2026-10-16). El
      // borrador anterior sigue guardado: no se toca.
      const partirDeCero = desdeCero || paeGuardadoFinal || !esNuevoPAE;
      const modeloPuerta = esModeloValoracion(modelo) ? modelo : null;
      if (modeloPuerta) recordarModelo(modeloPuerta);
      sessionIdRef.current = Date.now().toString();
      setPaeGuardadoFinal(false);
      setPaeIdActual(null);
      if (partirDeCero) { setSelected([]); setAnamnesisIA(null); }
      // También limpia el _plan viejo, para que RapidoStep3 inicie en fase
      // 'diagnosticos' (no 'plan' con datos ajenos).
      setFormData((p) => formDataAlIniciarRapido(p, { partirDeCero, modelo: modeloPuerta }));
      setAppState("rapido"); setStep(1); setEsNuevoPAE(true);
      registrarMetrica(session?.user?.id, 'rapido', 'started');
      if (session?.user?.id) registrarEvento({ userId: session.user.id, tipo: 'inicio_pae', metadatos: { modo: 'rapido' } });
      return true;
    } else if (m === "detallado") {
      const bloqueo = bloqueoInicioPae("detallado");
      if (bloqueo === "sin_sesion") {
        logFreemiumMetric('login_cta', 'detallado_guest', { source });
        handleLogin();
        return false;
      }
      // PAE Detallado: cuota mensual (2 en el plan gratis, uso justo), no
      // candado de módulo (MiPAE extendido, D1/D4, 2026-09-14). Un Detallado
      // también gasta uno de los 5 PAE del mes (su generación de diagnósticos
      // es capa 'diagnosticos', la que el servidor cuenta como PAE): se mira
      // acá, a la entrada, para que nadie llene la valoración completa y
      // choque con el tope recién al generar (2026-09-26).
      if (bloqueo) {
        logFreemiumMetric('paywall_shown', `mipae_plus_${bloqueo}`, { source });
        setPremiumPaywall(bloqueo);
        return false;
      }
      // Un Detallado nuevo parte limpio: si se salió del anterior por la barra
      // de pestañas, su paciente, su síntesis y sus diagnósticos seguían en
      // memoria y aparecían en el nuevo (auditoría estudiante 4-oct-2026).
      // Sesión de borrador propia, igual que el Rápido, y directo al paso 1.
      resetPaeDetallado();
      trackLanzamientoUso('pae_detallado');
      setAppState("detallado"); setStep(1); setEsNuevoPAE(true);
      registrarMetrica(session?.user?.id, 'detallado', 'started');
      if (session?.user?.id) registrarEvento({ userId: session.user.id, tipo: 'inicio_pae', metadatos: { modo: 'detallado' } });
      return true;
    }
    return false;
  };

  // Puente MiPAE en turno → PAE: arranca un PAE (rápido o detallado) precargado con
  // lo que el enfermero YA documentó en el turno — no solo el texto plano de
  // contextoClinico, también los antecedentes/alergias/sexo de la evolución
  // por sistema (paePrefillDesdeTurno, turnoPaeBridge.js), ya sin PII.
  // El usuario revisa y completa antes de generar el plan. Respeta el mismo
  // gating de login/cuota/MiPAE+ que startMode.
  const crearPaeDesdeTurno = (modo, registro) => {
    const { anamnesis: anamnesisPrefill, textoContexto } = paePrefillDesdeTurno(registro);
    const cama = sanitizarCama(registro?.cama);
    if (modo === 'rapido') {
      const bloqueo = bloqueoInicioPae('rapido');
      if (bloqueo === 'sin_sesion') {
        logFreemiumMetric('login_cta', 'rapido_guest', { source: 'mi_turno' });
        handleLogin();
        return;
      }
      if (bloqueo) {
        logFreemiumMetric('paywall_shown', 'mipae_plus_pae', { source: 'mi_turno' });
        setPremiumPaywall('pae');
        return;
      }
      sessionIdRef.current = Date.now().toString();
      setPaeGuardadoFinal(false);
      setPaeIdActual(null);
      // El formData se reemplaza entero (parte de cero, como startMode con
      // `partirDeCero`): la selección y la anamnesis IA del PAE anterior
      // tampoco pueden viajar al de esta cama.
      setSelected([]); setAnamnesisIA(null);
      // modelo 'libre' (no 'henderson'): es el único que muestra el campo
      // "Datos que lo confirman" (libre.confirman) en el paso 1 — con
      // 'henderson' el prefill quedaba en un campo que la UI nunca renderiza.
      setFormData({ rapido: { modelo: 'libre', libre: { confirman: textoContexto } } });
      setOrigenTurno({ cama });
      setAppState('rapido'); setStep(1); setEsNuevoPAE(true);
      registrarMetrica(session?.user?.id, 'rapido', 'started');
    } else {
      const bloqueo = bloqueoInicioPae('detallado');
      if (bloqueo === 'sin_sesion') {
        logFreemiumMetric('login_cta', 'detallado_guest', { source: 'mi_turno' });
        handleLogin();
        return;
      }
      if (bloqueo) {
        logFreemiumMetric('paywall_shown', `mipae_plus_${bloqueo}`, { source: 'mi_turno' });
        setPremiumPaywall(bloqueo);
        return;
      }
      // Directo al paso 1 en UCI, igual que startMode (P3), y con el mismo
      // reinicio: solo cambia que el paciente viene de la cama.
      resetPaeDetallado({ unit: UNIDAD_DETALLADO, anamnesis: { ...anamnesisPrefill, evolucion: textoContexto } });
      setOrigenTurno({ cama });
      trackLanzamientoUso('pae_detallado');
      setAppState('detallado'); setStep(1); setEsNuevoPAE(true);
      registrarMetrica(session?.user?.id, 'detallado', 'started');
    }
    trackEvent('pae_desde_turno', { modulo: MODULOS.MI_TURNO, payload: { modo } });
    if (session?.user?.id) registrarEvento({ userId: session.user.id, tipo: 'inicio_pae', metadatos: { modo, origen: 'mi_turno' } });
  };

  const startDemo = (etapa = "estudiante") => {
    setEtapaDemo(["estudiante", "interno", "enfermero", "tens"].includes(etapa) ? etapa : "estudiante");
    setAppState("demo");
  };

  // Salir a mitad de turno es el caso caro: el barrido local se lleva lo que no
  // alcanzó a subir. Preguntamos SOLO si hay un turno vivo (cama abierta, ni
  // cerrada ni de práctica), para no ponerle una puerta más al que solo quiere
  // salir de su cuenta.
  const hayTurnoAbierto = () => {
    try { return !!camaActivaTurno(cargarRegistros(session?.user?.id)); }
    catch { return false; }
  };

  const handleLogout = () => {
    if (hayTurnoAbierto()) { setConfirmarSalida(true); return; }
    return ejecutarLogout();
  };

  const ejecutarLogout = async () => {
    setConfirmarSalida(false);
    // Primero descargar lo amortiguado: el guardado local dentro de su ventana
    // de debounce y los push al remoto en cola. Sin esto, cerrar sesión dos
    // segundos después de escribir se llevaba justo eso. Con tope de tiempo:
    // sin señal el upsert puede quedarse colgado y salir no puede depender de
    // que haya internet.
    try {
      await Promise.race([
        flushEscriturasTurno(),
        new Promise((r) => setTimeout(r, 2500)),
      ]);
    } catch { /* pushRemoto no lanza; si igual pasara, salir manda */ }

    clearSession();
    // signOut() de supabase-js viene con scope 'global' por defecto: cierra la
    // sesión en TODOS los dispositivos del usuario, no solo en este. Es lo que
    // permite rescatar una sesión olvidada en un computador prestado desde el
    // teléfono, así que se conserva a propósito.
    //
    // El barrido local va DESPUÉS (signOut necesita la sesión para llamar al
    // servidor) y en `finally`: si la red falla, igual queremos que este
    // dispositivo quede sin borradores. Salir es salir, aunque el servidor no
    // se entere todavía.
    try {
      await supabase.auth.signOut();
    } catch {
      // sin red el servidor no se entera, pero el usuario igual sale de ESTE
      // dispositivo: seguimos al barrido y al reset de la UI.
    } finally {
      clearLocalMipaeKeys({ conservar: PREFERENCIAS_DISPOSITIVO });
      await clearNativeMipaeKeys();
    }
    setMenuPaes([]);
    setRotacion(null);
    setAppState("home");
    setStep(0); setUnit(null); setFormData({}); setSelected([]); setOrigenTurno(null);
  };

  const handleConfirmarEdad = async () => {
    // UPDATE explícito para fila existente — no tocar nombre ni otros campos.
    // INSERT para usuario nuevo — nombre placeholder requerido (NOT NULL sin default).
    // upsert con onConflict:"user_id" fallaba porque PostgREST resuelve conflictos
    // por PK (id), no por la UK de user_id, y el INSERT resultante rompe NOT NULL.
    let dbError;
    if (profile) {
      ({ error: dbError } = await supabase
        .from("profiles")
        .update({ edad_confirmada_18: true })
        .eq("user_id", session.user.id));
    } else {
      const nombreInicial = session?.user?.user_metadata?.full_name
        || session?.user?.user_metadata?.name
        || '';
      ({ error: dbError } = await supabase
        .from("profiles")
        .insert({ user_id: session.user.id, nombre: nombreInicial, edad_confirmada_18: true }));
    }
    if (dbError) throw dbError;
    const p = await cargarProfile(session.user.id);
    setProfile(p);
    setTrackingContext({ userId: session.user.id, cohortId: p?.cohort_id });
    if (!p?.perfil_completado) {
      setAppState("perfil");
    } else {
      setAppState("home");
    }
  };

  // Lleva al visitante a la tarjeta de acceso de la portada (Apple, Google y
  // correo juntos). En iPhone reemplaza a handleLogin en las puertas nuevas:
  // Apple exige que su botón esté al lado de Google (guideline 4.8).
  const irAlAcceso = () => {
    setAppState("home");
    setTimeout(() => {
      const acceso = document.getElementById("acceso-mipae");
      acceso?.scrollIntoView?.({ block: "center" });
      acceso?.querySelector("button")?.focus({ preventScroll: true });
    }, 180);
  };

  // Toda puerta que pide cuenta pasa por aquí (Benito, Bitácora, el menú, los
  // módulos con candado). Tres casos, y el orden importa:
  //   1. Con sesión pero sin perfil completo, lo que falta es el PERFIL, no
  //      otra cuenta. Antes esto abría Google igual: el revisor de Apple entró
  //      con Apple el 2026-10-01, saltó el perfil, tocó Benito y la Bitácora y
  //      cada toque le abría Google, que en su iPad nunca volvía (cuarto
  //      rechazo, "no pudimos iniciar sesión para usar Benito y Bitácora").
  //   2. En la app de iOS no hay Google (GOOGLE_LOGIN_DISPONIBLE): se lleva a
  //      la tarjeta de acceso con Apple y el correo.
  //   3. En web y Android, Google como siempre.
  const handleLogin = async () => {
    if (session) { setAppState("perfil"); return; }
    if (!GOOGLE_LOGIN_DISPONIBLE) { irAlAcceso(); return; }
    await signInWithGoogle();
  };

  // Devuelve el resultado en vez de tragárselo como handleLogin: la pantalla de
  // entrada muestra el error bajo el botón (y calla si la persona canceló).
  const handleLoginApple = () => signInWithApple();

  const handleAbrirPAE = async (pae) => {
    closeMenu();
    const data = await cargarPAE(pae.id, session.user.id);
    // Si no se pudo traer (sin conexión, sesión vencida), se dice y se ofrece
    // reintentar: antes el toque no hacía nada (B24). El estado del PAE en
    // curso se toca recién con el PAE en la mano, para no desarmar un
    // borrador por un intento fallido.
    if (!data) {
      toast.error("No pudimos abrir ese PAE. Revisa tu conexión e inténtalo de nuevo.", {
        duration: 8000,
        action: { label: "Reintentar", onClick: () => handleAbrirPAE(pae) },
      });
      return;
    }
    setEsNuevoPAE(false);
    setPaeIdActual(pae.id);
    setOrigenTurno(null);
    // Mismo caso que continuarBorrador: los PAE guardados en `paes.datos` antes
    // del 2026-09-03 llevan el catálogo viejo con guión largo.
    const { formData: fdCrudo, selected: sel } = data.datos || {};
    const fd = normalizarValoresPae(fdCrudo);
    if (pae.modo === 'rapido') {
      setFormData(fd || {}); setSelected([]);
      setAppState('rapido'); setStep(4);
    } else {
      setFormData(fd || {}); setSelected(sel || []);
      setAppState('detallado'); setStep(13);
    }
  };

  const handleOpenMenu = () => {
    openMenu();
    if (session?.user?.id && menuPaes.length === 0) {
      listarPAEs(session.user.id, 5).then(data => setMenuPaes(data));
    }
  };

  // ── Back action per view ─────────────────────────────────────────────────────
  const handleBack = () => {
    // MiPAE en turno maneja su propio back interno (paciente → lista → hub) antes de salir.
    if (appState === "registro-turno") {
      if (registroBackRef.current?.()) {
        window.history.pushState({}, '');
        skipHistoryPush.current = false;
      } else {
        irAtras();
      }
      return;
    }
    // Medicamentos maneja su back interno (detalle → lista) antes de salir.
    if (appState === "fichas") {
      if (fichasBackRef.current?.()) {
        window.history.pushState({}, '');
        skipHistoryPush.current = false;
      } else {
        irAtras();
      }
      return;
    }
    // Escalas maneja su back interno (calculadora → lista) antes de salir.
    if (appState === "escalas") {
      if (escalasBackRef.current?.()) {
        window.history.pushState({}, '');
        skipHistoryPush.current = false;
      } else {
        irAtras();
      }
      return;
    }
    // GES maneja su back interno (detalle → lista) antes de salir.
    if (appState === "ges") {
      if (gesBackRef.current?.()) {
        window.history.pushState({}, '');
        skipHistoryPush.current = false;
      } else {
        irAtras();
      }
      return;
    }
    // Referencia rápida: primero vuelve de sección → lista, luego sale.
    if (appState === "referencia") {
      if (referenciaBackRef.current?.()) {
        window.history.pushState({}, '');
        skipHistoryPush.current = false;
      } else {
        irAtras();
      }
      return;
    }
    skipHistoryPush.current = true;
    if (appState === "rapido") {
      if (step <= 1) { salirDePae(); }
      else if (step === 2) { setStep(1); }
      else if (step === 3) {
        if (formData.rapido?.modelo === 'libre') setStep(2); else setStep(1);
      } else { setStep(step - 1); } // step 4 → 3
    } else if (appState === "demo") {
      irAtras();
    } else if (appState === "detallado") {
      // Mismas dos esperas que el atrás de Android: el reintento de la
      // revisión, y salir desde el paso 1 con algo escrito pregunta antes.
      if (detalladoAtrasRef.current?.()) skipHistoryPush.current = false;
      else if (step > 1) setStep(step - 1);
      else if (detalladoTieneDatos(formData)) { skipHistoryPush.current = false; setConfirmarSalirPae(true); }
      else salirDePae();
    } else {
      irAtras();
    }
  };

  // ── Computed values ──────────────────────────────────────────────────────────
  const vs = step <= 2 ? 1 : step === 3 ? 2 : 3; // visual step for rapido

  const headerTitle = {
    home:               null,
    perfil:             "Mi perfil",
    "mis-paes":         "Tus PAEs",
    "tu-pae":           "Tu PAE",
    "lo-nuevo":         "Lo nuevo de MiPAE",
    ajustes:            "Ajustes",
    rapido:             "PAE Rápido",
    demo:               "Caso demo",
    detallado:          "PAE Detallado",
    privacidad:         "Privacidad",
    terminos:           "Términos de uso",
    "que-es-mipae":     "¿Qué es MiPAE?",
    contacto:           "Contacto",
    instituciones:      "Para instituciones",
    "prepara-practica": "Prepara tu práctica",
    "prepara-internado":"Prepara tu internado",
    "prepara-examen":   "Prepara tu examen",
    // Mismo nombre que el menú (A28): la pantalla es la Biblioteca; su
    // pestaña "Bibliografía" sigue llamándose así por dentro.
    bibliografia:       "Biblioteca",
    admin:              "Métricas",
    "labs-voz":         "MiPAE Voice",
    "jefatura":         "Panel de gestión",
    "dialisis":         "Diálisis",
    "mi-progreso":      "Mi progreso",
    "calendario":       "Mi calendario",
    "calendario-config":"Mi calendario",
    "prepara-turno":    "Prepara tu turno",
    "entrega-turno":    "Entrega de turno",
    "evolucion-sistema":"Evolución por sistema",
    "registro-turno":   "MiPAE en turno",
    "en-turno-estudiante": "MiPAE en turno",
    "bitacora":         "Bitácora",
    "reto":             "El reto del día",
    "escalas":          "Escalas clínicas",
    "respira":          "Respira",
    "bienestar":        "Bienestar",
    "practica":         "Pausa guiada",
    "fichas":           "Medicamentos",
    "ges":              "GES Fonasa",
    "referencia":       "Enciclopedia",
    "laboratorio":      "Laboratorio",
  }[appState];

  // Perfil: si no está completado aún, el botón back no lleva a home
  // (no queremos que el usuario se quede sin perfil). Si ya completó, sí puede volver.
  const showBack = appState !== "home" && !(appState === "perfil" && !profile?.perfil_completado);
  const showRapidoProgress = appState === "rapido" && step >= 1 && step <= 4;

  // Etiqueta contextual del botón atrás: a dónde lleva. Los módulos con back
  // interno multinivel (MiPAE en turno, fichas, GES, prepara) no la muestran porque
  // el primer "atrás" es interno (detalle → lista) y no al inicio.
  const INTERNAL_BACK_VIEWS = ["registro-turno", "fichas", "ges", "referencia", "prepara-practica", "prepara-internado"];
  const backDest = ["rapido", "detallado", "demo"].includes(appState)
    ? "Atrás"
    : INTERNAL_BACK_VIEWS.includes(appState)
      ? null
      : "Inicio";

  // Disclaimer pre-PAE bloqueante: si el usuario aún no aceptó el módulo,
  // renderiza el modal full-screen en lugar del contenido del módulo.
  // Solo aplica a usuarios logueados con perfil cargado — guests freemium
  // pasan derecho (verán el disclaimer cuando se registren).
  const pendingDisclaimer =
    appState === "rapido"    && session && profile && !profile.disclaimer_pae_rapido_aceptado    ? 'pae_rapido'    :
    appState === "detallado" && session && profile && !profile.disclaimer_pae_detallado_aceptado ? 'pae_detallado' :
    null;

  // ── Telemetría del arranque del PAE Rápido (maqueta preview-pae-rapido-arranque,
  // decisión D3): `paso_iniciado {paso:'modelo'}` sigue INTACTO (es la serie del
  // 73% y se dispara aunque el aviso de uso tape la pantalla). Este evento se
  // agrega aparte, UNA vez por entrada (guard por ref, patrón #523), recién
  // cuando el paso 1 se VE, y anota si el aviso de uso se mostró en esta
  // entrada (`primera_vez`): así se sabe cuántos se van en el aviso y cuántos
  // en el formulario. La variante es catálogo cerrado de lib/paeArranque.js.
  // Vive después de `pendingDisclaimer` porque depende de él.
  const arranqueRapidoRef = useRef({ emitido: false, avisoVisto: false });
  useEffect(() => {
    if (appState !== 'rapido') { arranqueRapidoRef.current = { emitido: false, avisoVisto: false }; return; }
    if (pendingDisclaimer === 'pae_rapido') { arranqueRapidoRef.current.avisoVisto = true; return; }
    if (step !== 1 || arranqueRapidoRef.current.emitido) return;
    arranqueRapidoRef.current.emitido = true;
    // Variante EFECTIVA (flag o preferencia del dispositivo) y su origen, ambos
    // de catálogo cerrado. Un cambio a mitad del paso emite aparte
    // `pae_rapido_arranque_cambio` desde RapidoStep1.
    const { variante, origen } = resolverArranque();
    trackEvent('pae_rapido_arranque', {
      modulo: 'pae_rapido',
      paso: 'modelo',
      payload: { variante, origen, primera_vez: arranqueRapidoRef.current.avisoVisto },
    });
  }, [appState, step, pendingDisclaimer]);

  // Barra de pestañas inferior: oculta en wizards a pantalla completa y disclaimers.
  // También durante el onboarding (perfil sin terminar): sus destinos exigen el
  // perfil completo y "En turno" llevaba a una pantalla vacía (A3).
  const enOnboardingPerfil = appState === "perfil" && !profile?.perfil_completado;
  // Visitante de la web (sesión ya resuelta como ausente: con session
  // undefined todavía no se sabe y no se cambia de navegación a medio cargar).
  const navPublica = NAV_PUBLICA_ENABLED && !isNative && session === null;
  const showTabBar = !navPublica && !pendingDisclaimer && !respiraEnSesion && !enOnboardingPerfil && ![
    "rapido", "detallado", "demo", "prepara-practica", "prepara-internado",
    "prepara-turno", "cuenta-eliminada", "confirmacion-edad", "onboarding-preview",
  ].includes(appState);
  // Con el teclado en pantalla abierto la barra de pestañas se retira
  // (dictado del fundador 2026-08-18: nadie navega a otra sección a mitad de
  // una frase, y con el teclado arriba cada pixel de contenido vale doble).
  // Solo afecta móvil: en escritorio no hay teclado en pantalla y el hook
  // queda en false. El padding inferior del contenido se conserva (keyed en
  // showTabBar): es holgura de scroll, no un hueco visible.
  const tecladoAbierto = useTecladoAbierto();
  // Navegación agente-céntrica: la barra tiene 5 destinos con Benito al centro;
  // las consultas (escalas, fármacos, GES, lab) viven bajo "Enciclopedia" y en
  // el menú. Era un kill-switch (REACT_APP_NAV_V2) desde #400; se retiró el
  // 2026-09-14 al borrar el Home viejo: apagarlo dejaba la barra vieja apuntando
  // a un Home que ya no existe, así que no era una salida de emergencia sino un
  // comentario. El compañero se monta con sesión y perfil completo (la nav lo
  // necesita: trae su propio compañero).
  const companeroDisponible = !!(session && profile?.perfil_completado);
  // Bus global "pregúntale a Benito" (pieza 4 de "más toque de IA"): las
  // superficies profundas (un campo de las ramas, una escala) disparan un
  // CustomEvent con su prefill y el panel se abre acá, sin prop-drilling.
  // El evento SOLO nace de un toque del usuario: Benito jamás se abre solo.
  useEffect(() => {
    if (!companeroDisponible) return undefined;
    const abrir = (e) => {
      const prefill = e?.detail?.prefill;
      if (!prefill) return;
      setCompaneroPrefill(prefill);
      setCompaneroAbierto(true);
      setBenitoNovedad(false);
    };
    window.addEventListener(EVENTO_BENITO_PREGUNTA, abrir);
    return () => window.removeEventListener(EVENTO_BENITO_PREGUNTA, abrir);
  }, [companeroDisponible]);
  // Con sesión y el perfil todavía cargando, la pestaña recordada (sin el
  // salto "En turno" → "PAE"); con perfil, la regla del mundo.
  const pestanaDelMedio = profile ? segundaPestana(perfilMundo) : session ? segundaPestanaRecordada() : "turno";
  const tabItems = [
    // 4 destinos: el menú completo (hamburguesa) sigue accesible desde el header.
    { key: "home", label: "Inicio", icon: House, active: appState === "home", onClick: goHome },
    // "MiPAE en turno" no cabe en la pestaña de 10 px (a 360 px parte en dos
    // líneas), así que la barra del teléfono muestra "En turno" (labelCorto) y
    // el nombre completo queda en el aria-label y en el header de escritorio.
    // La segunda pestaña es por mundo (I3 del plan de la interfaz de los tres
    // mundos, lib/navegacionMundo.js): el estudiante sin internado en curso
    // tiene PAE, que es su herramienta de todos los días; el resto, En turno.
    // PAE abre por la misma puerta que el menú (startMode: sesión, cuota,
    // borrador y telemetría). EnTurnoEstudiante sigue en el menú y el buscador.
    pestanaDelMedio === "pae"
      // Ya dentro de un PAE, tocar la pestaña lo deja donde está (como En
      // turno): startMode reiniciaría el Rápido en el paso 1 o sacaría del
      // Detallado, y la pestaña resaltada se toca por reflejo.
      ? { key: "pae", label: "PAE", icon: FileText, active: ["tu-pae", "rapido", "detallado", "mis-paes"].includes(appState), onClick: () => { if (["rapido", "detallado"].includes(appState)) return; setAppState("tu-pae"); } }
      : { key: "turno", label: "MiPAE en turno", labelCorto: "En turno", icon: ClipboardList, active: ["registro-turno", "en-turno-estudiante"].includes(appState), onClick: () => abrirRegistroTurno("tab") },
    // PresenciaBenito ignora props ajenas (size/strokeWidth que BottomTabBar le
    // pasa como si fuera un ícono lucide); acá además la usamos para reflejar
    // el estado real de Benito (pensando/reposo) cuando el panel está cerrado
    // — con el panel abierto el header del panel ya muestra el estado, así que
    // la pestaña vuelve a reposo para no duplicar la animación.
    { key: "companero", label: "Benito", icon: (p) => <PresenciaBenito estado={companeroAbierto ? "reposo" : benitoEstado} size={p.size} />, active: companeroAbierto, badge: benitoNovedad && !companeroAbierto, onClick: () => { if (!companeroDisponible) { handleLogin(); return; } setCompaneroAbierto(true); setBenitoNovedad(false); } },
    { key: "enciclopedia", label: "Enciclopedia", icon: BookOpen, active: appState === "referencia", onClick: () => abrirReferencia() },
    // Con el módulo (flag ON, 2026-09-23) Bienestar ES un destino: abre su
    // home, como las otras pestañas, y queda activa en todo lo que vive
    // adentro (Respira, la Bitácora, una pausa guiada). Sin caret: ya no
    // despliega nada.
    // Con el flag apagado vuelve lo de antes: caret chico que anticipa que
    // "Bienestar" despliega un menú (Respira + Bitácora) en vez de navegar
    // directo (P1 backlog lanzamiento, "Bienestar no es un destino real").
    BIENESTAR_MODULO_ENABLED
      ? { key: "bienestar", label: "Bienestar", icon: Heart, active: ["bienestar", "respira", "bitacora", "practica"].includes(appState), onClick: abrirBienestar }
      : { key: "bienestar", label: "Bienestar", icon: (p) => (
          <span className="relative inline-flex">
            <Heart size={p.size} strokeWidth={p.strokeWidth} />
            <ChevronDown size={10} strokeWidth={2.5} className="absolute -bottom-1 -right-1.5" aria-hidden="true" />
          </span>
        ), active: bienestarOpen || appState === "respira" || appState === "bitacora", onClick: () => setBienestarOpen((v) => !v) },
  ];

  // Shell de escritorio: las MISMAS pestañas de la barra, repartidas en el
  // header (fuente única, cero navegación paralela). Los destinos van como
  // texto y Benito se va al extremo derecho, pegado al dock que abre. Con el
  // módulo Bienestar (flag ON) Bienestar es un destino más y va como texto
  // junto a Inicio, MiPAE en turno y Enciclopedia; con el flag apagado
  // conserva su botón con popover (itemBienestarNav).
  const navHeaderKeys    = BIENESTAR_MODULO_ENABLED ? ["home", "turno", "pae", "enciclopedia", "bienestar"] : ["home", "turno", "pae", "enciclopedia"];
  const navHeaderItems   = SHELL_ESCRITORIO_ENABLED ? tabItems.filter((it) => navHeaderKeys.includes(it.key)) : [];
  const itemBienestarNav = SHELL_ESCRITORIO_ENABLED && !BIENESTAR_MODULO_ENABLED ? tabItems.find((it) => it.key === "bienestar") : null;
  const itemBenitoNav    = SHELL_ESCRITORIO_ENABLED ? tabItems.find((it) => it.key === "companero") : null;
  // La navegación del visitante de la web (header de escritorio y menú).
  // Planes es la página pública /precios (solo web, venta-solo-web); las otras
  // tres son pantallas públicas de la SPA.
  const navPublicaItems = [
    { key: "que-es", label: "¿Qué es MiPAE?", icon: Lightbulb, active: appState === "que-es-mipae", onClick: () => setAppState("que-es-mipae") },
    { key: "instituciones", label: "Para instituciones", icon: Building2, active: appState === "instituciones", onClick: () => setAppState("instituciones") },
    { key: "planes", label: "Planes", icon: Tag, href: "/precios" },
    { key: "contacto", label: "Contacto", icon: MessageCircle, active: appState === "contacto", onClick: () => setAppState("contacto") },
  ];

  const userName  = session?.user?.user_metadata?.full_name || session?.user?.user_metadata?.name;
  const userEmail = session?.user?.email;
  // Reanudar el onboarding donde quedó: lo ya respondido en una visita previa
  // se da por contestado y el guion salta a lo que falta. Sin esto, quien
  // abandonaba a mitad volvía a la primera pregunta cada vez. El nombre de
  // Google entra solo si el perfil no trae uno propio (el usuario pudo
  // corregirlo). perfilParaReanudar descarta lo que esté fuera de vocabulario
  // (los tres roles de lib/roles.js).
  const perfilPendiente = useMemo(() => {
    const guardado = perfilParaReanudar(profile);
    return { ...guardado, nombre: guardado.nombre || userName || "" };
  }, [profile, userName]);
  const initials  = userName
    ? userName.trim().split(/\s+/).map(w => w[0]).slice(0, 2).join('').toUpperCase()
    : userEmail ? userEmail[0].toUpperCase() : '?';

  // ── Buscador global: lista plana de destinos navegables ─────────────────────
  // Se reconstruye en cada render (barato) para evitar closures obsoletas.
  const paletteSesionLista = session && profile?.perfil_completado;
  const paletteEsAdmin = ['admin', 'owner'].includes(profile?.role);
  const paletteItems = [];
  paletteItems.push({ id: 'nav-home', group: 'Secciones', label: 'Inicio', keywords: ['home', 'volver', 'principal'], icon: <House size={17} strokeWidth={1.6} />, onSelect: goHome });
  if (session) {
    paletteItems.push({ id: 'nav-perfil', group: 'Secciones', label: 'Mi perfil', keywords: ['cuenta', 'datos', 'ajustes', 'configuracion'], icon: <UserCircle size={17} strokeWidth={1.6} />, onSelect: () => setAppState('perfil') });
    paletteItems.push({ id: 'nav-ajustes', group: 'Secciones', label: 'Ajustes', keywords: ['tema', 'color', 'letra', 'oscuro', 'notificaciones', 'configuracion'], icon: <Settings2 size={17} strokeWidth={1.6} />, onSelect: () => setAppState('ajustes') });
    if (veTusPaes) paletteItems.push({ id: 'nav-mis-paes', group: 'Secciones', label: 'Tus PAEs', keywords: ['guardados', 'pae'], icon: <FileText size={17} strokeWidth={1.6} />, onSelect: () => setAppState('mis-paes') });
  }
  if (paletteSesionLista) {
    // Mi progreso cuenta PAEs y formación: se ofrece donde vive el PAE, como
    // en Mi perfil (filasLoTuyo) y en el inicio.
    if (paeEnEsteMundo) paletteItems.push({ id: 'nav-progreso', group: 'Secciones', label: 'Mi progreso', keywords: ['avance', 'estadisticas'], icon: <TrendingUp size={17} strokeWidth={1.6} />, onSelect: () => setAppState('mi-progreso') });
    paletteItems.push({ id: 'nav-calendario', group: 'Secciones', label: 'Mi calendario', keywords: ['turnos', 'rotacion'], icon: <Calendar size={17} strokeWidth={1.6} />, onSelect: () => setAppState(rotacion ? 'calendario' : 'calendario-config') });
  }
  // En MiPAE Enfermero y MiPAE TENS el PAE no se abre: un solo resultado dice
  // dónde vive y pasa a ese mundo, para quien lo busque por costumbre.
  if (paeEnEsteMundo) {
    paletteItems.push({ id: 'nav-pae-rapido', group: 'Secciones', label: 'PAE Rápido', sub: 'Diagnóstico NANDA-I guiado', keywords: ['pae', 'nanda', 'noc', 'nic', 'diagnostico'], icon: <Sparkles size={17} strokeWidth={1.6} />, onSelect: () => startMode('rapido', 'palette') });
    paletteItems.push({ id: 'nav-pae-detallado', group: 'Secciones', label: 'PAE Detallado', sub: 'Valoración por sistemas', keywords: ['pae', 'valoracion', 'henderson', 'sistemas'], icon: <PenLine size={17} strokeWidth={1.6} />, onSelect: () => startMode('detallado', 'palette') });
  } else if (puedePasarAEstudiante) {
    paletteItems.push({ id: 'nav-pae-estudiante', group: 'Secciones', label: 'PAE Rápido y PAE Detallado', sub: 'Viven en MiPAE Estudiante. Toca para pasar.', keywords: ['pae', 'nanda', 'noc', 'nic', 'diagnostico', 'valoracion', 'henderson', 'rapido', 'detallado'], icon: <ArrowLeftRight size={17} strokeWidth={1.6} />, onSelect: () => cambiarMundo('estudiante') });
  }
  paletteItems.push({ id: 'nav-mi-turno', group: 'Secciones', label: 'MiPAE en turno', sub: 'Centro de control del turno', keywords: ['turno', 'pacientes', 'entrega', 'evolucion', 'registro'], icon: <ClipboardList size={17} strokeWidth={1.6} />, onSelect: () => (paletteSesionLista ? abrirRegistroTurno('palette') : handleLogin()) });
  // Material de formación (Prepara tu turno/práctica/internado): el menú no
  // se lo muestra a la capa de ejercicio (dictado del fundador 2026-09-10) ni
  // al TENS (2026-10-16), y el buscador dice lo mismo. Coherencia entre
  // superficies, 2026-09-14.
  const preparaEnBuscador = !esCapaEjercicio(perfilMundo) && !esTens(perfilMundo);
  if (preparaEnBuscador) paletteItems.push({ id: 'nav-prepara-turno', group: 'Secciones', label: 'Prepara tu turno', keywords: ['tema', 'turno'], icon: <Clock size={17} strokeWidth={1.6} />, onSelect: () => setAppState('prepara-turno') });
  if (paletteSesionLista) {
    paletteItems.push({ id: 'nav-bitacora', group: 'Secciones', label: 'Bitácora', keywords: ['reflexion', 'turno'], icon: <ClipboardList size={17} strokeWidth={1.6} />, onSelect: () => setAppState('bitacora') });
  }
  paletteItems.push({ id: 'nav-revisa', group: 'Secciones', label: 'Revisa', sub: 'Consulta rápida en el turno', keywords: ['consulta', 'sbar', 'asistente', 'pregunta'], icon: <Zap size={17} strokeWidth={1.6} />, onSelect: () => openRevisa('palette') });
  paletteItems.push({ id: 'nav-escalas', group: 'Secciones', label: 'Escalas clínicas', keywords: ['calculadora', 'glasgow', 'braden'], icon: <Activity size={17} strokeWidth={1.6} />, onSelect: () => { setEscalaInicial(null); setAppState('escalas'); } });
  // Bienestar (2026-09-23): el home del módulo. Respira y Bitácora se quedan
  // como destinos propios en el buscador.
  if (BIENESTAR_MODULO_ENABLED) paletteItems.push({ id: 'nav-bienestar', group: 'Secciones', label: 'Bienestar', sub: 'Respira, pausas guiadas y Bitácora', keywords: ['autocuidado', 'pausa', 'calma', 'respiracion', 'mindfulness', 'bitacora'], icon: <Heart size={17} strokeWidth={1.6} />, onSelect: abrirBienestar });
  paletteItems.push({ id: 'nav-respira', group: 'Secciones', label: 'Respira', sub: 'Respiración guiada para una pausa', keywords: ['respiracion', 'pausa', 'calma', 'ansiedad'], icon: <Wind size={17} strokeWidth={1.6} />, onSelect: () => abrirRespira('generico') });
  paletteItems.push({ id: 'nav-fichas', group: 'Secciones', label: 'Medicamentos', sub: 'Fichas de fármacos', keywords: ['vademecum', 'farmaco', 'medicamento', 'droga', 'dosis', 'dilucion', 'ficha'], icon: <Pill size={17} strokeWidth={1.6} />, onSelect: () => abrirFichas() });
  paletteItems.push({ id: 'nav-laboratorio', group: 'Secciones', label: 'Calculadora de infusiones', sub: 'Goteos y diluciones (gamma)', keywords: ['laboratorio', 'infusion', 'gamma', 'goteo', 'dilucion', 'bomba', 'bic', 'mcg/kg/min', 'vasoactivo', 'calculadora'], icon: <Activity size={17} strokeWidth={1.6} />, onSelect: () => abrirLaboratorio() });
  paletteItems.push({ id: 'nav-ref-lab',         group: 'Secciones', label: 'Valores de laboratorio', sub: 'Normal/alto/bajo + cuidados', keywords: ['laboratorio', 'examenes', 'hemograma', 'elp', 'potasio', 'creatinina', 'rango', 'referencia'], icon: <FlaskConical size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('laboratorio') });
  paletteItems.push({ id: 'nav-ref-gases',       group: 'Secciones', label: 'Gases arteriales', sub: 'Intérprete ácido-base', keywords: ['gases', 'gsa', 'ph', 'acidosis', 'alcalosis', 'pco2', 'hco3', 'referencia'], icon: <Wind size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('gases') });
  paletteItems.push({ id: 'nav-ref-vacunas',     group: 'Secciones', label: 'Vacunas PNI', sub: 'Calendario y cuidados', keywords: ['vacunas', 'pni', 'inmunizacion', 'calendario', 'bcg', 'referencia'], icon: <Syringe size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('vacunas') });
  paletteItems.push({ id: 'nav-ref-aislamiento', group: 'Secciones', label: 'Aislamiento y EPP', sub: 'Precauciones y secuencia EPP', keywords: ['aislamiento', 'epp', 'precaucion', 'contacto', 'gotitas', 'aerea', 'referencia'], icon: <ShieldAlert size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('aislamiento') });
  paletteItems.push({ id: 'nav-ref-calc', group: 'Secciones', label: 'Calculadoras', sub: 'Lab y del turno (dosis, goteo, balance)', keywords: ['calculadora', 'anion gap', 'calcio corregido', 'sodio corregido', 'osmolaridad', 'dosis', 'mg/kg', 'goteo', 'gotas', 'balance hidrico', 'diuresis', 'referencia'], icon: <Sigma size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('calculadoras') });
  paletteItems.push({ id: 'nav-ref-proc', group: 'Secciones', label: 'Procedimientos paso a paso', sub: 'Cuidados del paciente, VVP, sondeo vesical, curación', keywords: ['procedimiento', 'cuidados', 'aseo', 'aseo bucal', 'cambio de posicion', 'movilizar', 'caidas', 'brazalete', 'identificacion', 'signos vitales', 'alimentacion', 'entrega de turno', 'cateter urinario', 'vvp', 'via venosa', 'sonda', 'foley', 'cateterismo', 'curacion', 'herida', 'referencia'], icon: <ListChecks size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('procedimientos') });
  paletteItems.push({ id: 'nav-ref-estudio', group: 'Secciones', label: 'Modo estudio', sub: 'Quiz de gases, lab, aislamiento, LPP, escalas, cuidados y GES', keywords: ['estudio', 'quiz', 'practica', 'preguntas', 'examen', 'repaso', 'referencia', 'reconoce', 'tarjetas'], icon: <GraduationCap size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('estudio') });
  paletteItems.push({ id: 'nav-ref-modelos', group: 'Secciones', label: 'Modelos de enfermería', sub: 'Henderson, Gordon, Orem, Roy y más', keywords: ['modelo', 'modelos', 'teoria', 'teorias', 'marco teorico', 'henderson', 'gordon', 'orem', 'roy', 'roper', 'astorquiza', 'peplau', 'watson', 'leininger', 'pender', 'nightingale', 'kolcaba', 'patrones funcionales', 'referencia'], icon: <Library size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('modelos') });
  // Un ítem por modelo (aparece al escribir): abre su ficha, no el índice.
  modelosBuscador.forEach((m) => {
    paletteItems.push({
      id: `modelo-${m.id}`,
      group: 'Modelos de enfermería',
      label: m.corto,
      sub: `${m.nombre} · ${m.autora}`,
      keywords: ['modelo', 'teoria', m.autora, ...m.claves],
      icon: <Library size={17} strokeWidth={1.6} />,
      searchOnly: true,
      onSelect: () => abrirReferencia(`modelos:${m.id}`),
    });
  });
  paletteItems.push({ id: 'nav-ref-recepcion', group: 'Secciones', label: 'Recepción de paciente', sub: 'Checklist de inicio de turno (SBAR)', keywords: ['recepcion', 'recibir', 'checklist', 'sbar', 'inicio de turno', 'entrega', 'referencia'], icon: <ClipboardCheck size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('recepcion') });
  paletteItems.push({ id: 'nav-ref-lpp', group: 'Secciones', label: 'Lesiones por presión', sub: 'Valoración, prevención y manejo (guía 2025)', keywords: ['lpp', 'upp', 'ulcera', 'escara', 'lesion por presion', 'braden', 'colchon', 'antiescaras', 'aposito', 'dai', 'referencia'], icon: <Layers size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('lpp') });
  paletteItems.push({ id: 'nav-ref-piel', group: 'Secciones', label: 'Atlas de piel y heridas', sub: 'Reconoce y describe lesiones de piel, con esquemas sin fotos', keywords: ['atlas', 'piel', 'herida', 'desgarro', 'skin tear', 'marsi', 'adhesivo', 'equimosis', 'hematoma', 'quemadura', 'dermatitis', 'humedad', 'venosa', 'arterial', 'pie diabetico', 'mucosa', 'dehiscencia'], icon: <Bandage size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia('piel') });
  // Cuidados paliativos es borrador: solo aparece en el buscador de una vista previa
  // (itemBuscadorPaliativos devuelve null fuera de ella; lib/borradores.js).
  const itemPaliativos = itemBuscadorPaliativos();
  if (itemPaliativos) {
    const { seccion: seccionPaliativos, ...item } = itemPaliativos;
    paletteItems.push({ ...item, icon: <HeartHandshake size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia(seccionPaliativos) });
  }
  // Accesos vasculares nació borrador el 16-oct-2026: igual que paliativos, solo aparece en
  // el buscador de una vista previa hasta que se publique.
  const itemAccesos = itemBuscadorAccesos();
  if (itemAccesos) {
    const { seccion: seccionAccesos, ...item } = itemAccesos;
    paletteItems.push({ ...item, icon: <Droplets size={17} strokeWidth={1.6} />, onSelect: () => abrirReferencia(seccionAccesos) });
  }
  if (preparaEnBuscador) paletteItems.push({ id: 'nav-prepara-practica',  group: 'Secciones', label: 'Prepara tu práctica',   keywords: ['practica', 'rotacion', 'pregrado'], icon: <BookOpen size={17} strokeWidth={1.6} />, onSelect: () => setAppState('prepara-practica') });
  if (preparaEnBuscador) paletteItems.push({ id: 'nav-prepara-internado', group: 'Secciones', label: 'Prepara tu internado', keywords: ['primer dia', 'recursos'], icon: <BookOpen size={17} strokeWidth={1.6} />, onSelect: () => setAppState('prepara-internado') });
  // El cuarto "Prepara" faltaba en el buscador (A29). Los cuatro viven aquí
  // aunque el menú le muestre al estudiante solo el de su etapa (P2). Mismo
  // permiso que en el menú: pide cuenta.
  if (preparaEnBuscador) paletteItems.push({ id: 'nav-prepara-examen', group: 'Secciones', label: 'Prepara tu examen', keywords: ['examen', 'grado', 'egreso', 'concurso', 'titulo', 'internado'], icon: <GraduationCap size={17} strokeWidth={1.6} />, onSelect: () => irAModulo('prepara-examen', () => setAppState('prepara-examen')) });
  if (paletteEsAdmin) {
    paletteItems.push({ id: 'nav-admin', group: 'Secciones', label: 'Métricas', keywords: ['admin', 'estadisticas'], icon: <BarChart2 size={17} strokeWidth={1.6} />, onSelect: () => setAppState('admin') });
    paletteItems.push({ id: 'nav-labs-voz', group: 'Secciones', label: 'MiPAE Voice (labs)', keywords: ['voz', 'experimento', 'labs'], icon: <Mic size={17} strokeWidth={1.6} />, onSelect: () => setAppState('labs-voz') });
  }
  if (veDialisis(perfilMundo)) {
    paletteItems.push({ id: 'nav-dialisis', group: 'Secciones', label: 'Diálisis', keywords: ['dialisis', 'diálisis', 'trr', 'terapia', 'crrt', 'hemodialisis', 'hemodiálisis'], icon: <Droplets size={17} strokeWidth={1.6} />, onSelect: () => setAppState('dialisis') });
  }
  if (veJefatura(profile)) {
    paletteItems.push({ id: 'nav-jefatura', group: 'Secciones', label: 'Panel de gestión', keywords: ['gestión del cuidado', 'panel', 'jefatura', 'supervisión', 'tablero', 'unidad', 'turno en vivo', 'reportes'], icon: <BarChart2 size={17} strokeWidth={1.6} />, onSelect: () => setAppState('jefatura') });
  }
  paletteItems.push({ id: 'nav-que-es', group: 'Información', label: '¿Qué es MiPAE?', keywords: ['ayuda', 'info'], icon: <Lightbulb size={17} strokeWidth={1.6} />, onSelect: () => setAppState('que-es-mipae') });
  paletteItems.push({ id: 'nav-contacto', group: 'Información', label: session ? 'Contacto y ayuda' : 'Contacto', sub: 'WhatsApp y correo', keywords: ['contacto', 'whatsapp', 'correo', 'email', 'ayuda', 'soporte', 'escribir', 'sebastian'], icon: <MessageCircle size={17} strokeWidth={1.6} />, onSelect: () => setAppState('contacto') });
  if (!isNative) paletteItems.push({ id: 'nav-instituciones', group: 'Información', label: 'MiPAE para instituciones', sub: 'Clínicas, hospitales, universidades', keywords: ['institucion', 'clinica', 'hospital', 'universidad', 'convenio', 'demostracion', 'demo', 'alianza', 'empresa'], icon: <Building2 size={17} strokeWidth={1.6} />, onSelect: () => setAppState('instituciones') });
  paletteItems.push({ id: 'nav-bibliografia', group: 'Información', label: 'Bibliografía de MiPAE', sub: 'Las fuentes que usa MiPAE y dónde', keywords: ['fuentes', 'referencias', 'bibliografia', 'citas', 'guias', 'respaldo', 'evidencia'], icon: <BookMarked size={17} strokeWidth={1.6} />, onSelect: abrirBibliografia });
  paletteItems.push({ id: 'nav-privacidad', group: 'Información', label: 'Privacidad', keywords: ['datos', 'politica'], icon: <Lock size={17} strokeWidth={1.6} />, onSelect: () => setAppState('privacidad') });
  paletteItems.push({ id: 'nav-terminos', group: 'Información', label: 'Términos', keywords: ['legal', 'uso'], icon: <BookOpen size={17} strokeWidth={1.6} />, onSelect: () => setAppState('terminos') });
  // Contenido buscable (aparece solo al escribir): los 90 problemas GES y los fármacos.
  spotlight.ges.forEach((g) => {
    paletteItems.push({
      id: `ges-${g.numero_problema}`,
      group: 'GES',
      label: g.nombre_corto || g.nombre_oficial,
      sub: `GES N°${g.numero_problema}`,
      keywords: [String(g.numero_problema), g.nombre_oficial, ...(g.sinonimos || []), g.categoria_clinica],
      icon: <ShieldCheck size={17} strokeWidth={1.6} />,
      searchOnly: true,
      onSelect: () => abrirGes(g.slug),
    });
  });
  spotlight.meds.forEach((m) => {
    paletteItems.push({
      id: `med-${m.slug}`,
      group: 'Medicamentos',
      label: m.nombre_generico || m.slug,
      sub: m.grupo_farmacologico || 'Fármaco',
      keywords: [...(m.nombres_comerciales || []), m.grupo_farmacologico, m.indicaciones_resumen],
      icon: <Pill size={17} strokeWidth={1.6} />,
      searchOnly: true,
      onSelect: () => abrirFichas(m.slug),
    });
  });

  // Calculadora de infusiones: cada fármaco con preset deep-linkea a la calc.
  CALCULADORAS_SLUGS.forEach((s) => {
    const m = spotlight.meds.find((x) => x.slug === s);
    const nombre = m?.nombre_generico || s.replace(/-/g, ' ');
    paletteItems.push({
      id: `lab-${s}`,
      group: 'Calculadora de infusiones',
      label: `Infusión: ${nombre}`,
      sub: 'gamma · goteo · bomba',
      keywords: [s.replace(/-/g, ' '), 'infusion', 'gamma', 'goteo', 'dilucion', 'bomba', ...(m?.nombres_comerciales || [])],
      icon: <Activity size={17} strokeWidth={1.6} />,
      searchOnly: true,
      onSelect: () => abrirLaboratorio(s),
    });
  });

  ESCALAS.forEach((e) => {
    paletteItems.push({
      id: `escala-${e.id}`,
      group: 'Escalas clínicas',
      label: e.nombre,
      sub: e.titulo,
      keywords: [e.titulo, e.desc],
      icon: <Activity size={17} strokeWidth={1.6} />,
      onSelect: () => abrirEscala(e.id),
    });
  });
  // Los PAEs guardados se abren donde vive el PAE. Fuera de MiPAE Estudiante
  // queda un solo resultado que pasa a ese mundo y abre Tus PAEs.
  if (!paeEnEsteMundo && palettePaes.length > 0 && puedePasarAEstudiante) {
    paletteItems.push({
      id: 'pae-guardados-estudiante',
      group: 'Tus PAEs guardados',
      label: 'Tus PAEs guardados',
      sub: 'Viven en MiPAE Estudiante. Toca para pasar.',
      keywords: ['pae', 'guardados', 'rapido', 'detallado'],
      icon: <ArrowLeftRight size={17} strokeWidth={1.6} />,
      onSelect: () => { cambiarMundo('estudiante'); setAppState('mis-paes'); },
    });
  }
  (paeEnEsteMundo ? palettePaes : []).forEach((p) => {
    paletteItems.push({
      id: `pae-${p.id}`,
      group: 'Tus PAEs guardados',
      label: p.titulo || (p.modo === 'rapido' ? 'PAE Rápido' : 'PAE Detallado'),
      sub: p.modo === 'rapido' ? 'PAE Rápido' : 'PAE Detallado',
      keywords: ['pae', p.modo],
      icon: p.modo === 'rapido'
        ? <Sparkles size={17} strokeWidth={1.6} />
        : <PenLine size={17} strokeWidth={1.6} />,
      onSelect: () => handleAbrirPAE(p),
    });
  });

  // ── Loading ──────────────────────────────────────────────────────────────────
  if (session === undefined) {
    return (
      <div className="min-h-screen bg-paper flex items-center justify-center py-20">
        <SelloAnimado size={240} />
      </div>
    );
  }

  // El candado de versión (lib/versionApp.js): solo en la app instalada y solo
  // si el servidor exige una versión que este teléfono no tiene.
  if (pedirActualizar) {
    return (
      <ActualizaMiPAE
        plataforma={pedirActualizar.plataforma}
        onAbrirTienda={() => trackEvent("app_actualizar_tienda", { modulo: MODULOS.HOME, payload: { plataforma: pedirActualizar.plataforma } })}
        onRevisar={revisarActualizacion}
      />
    );
  }

  return (
    // El padding derecho reflowa la app cuando el dock de Benito está abierto
    // (fuera del ternario de la tab bar: el dock también abre en vistas sin
    // barra, como el PAE). Sin transición de padding a propósito.
    <div className={`min-h-screen ${showTabBar ? `pb-[calc(3.5rem_+_env(safe-area-inset-bottom))]${SHELL_ESCRITORIO_ENABLED ? " lg:pb-0" : ""}` : ""}${SHELL_ESCRITORIO_ENABLED && companeroAbierto ? " lg:pr-[360px] xl:pr-[400px]" : ""}`}>

      {/* ── Global Header — oculto en Prepara tu internado, Cuenta eliminada, Confirmación edad y Disclaimer pre-PAE ── */}
      {!["prepara-practica", "prepara-internado", "prepara-turno", "cuenta-eliminada", "confirmacion-edad"].includes(appState) && !pendingDisclaimer && !respiraEnSesion && <header className="no-print sticky top-0 z-30 bg-paper/90 backdrop-blur-md border-b border-edge" style={{ marginTop: 'calc(-1 * env(safe-area-inset-top))', paddingTop: 'env(safe-area-inset-top)' }}>
        {/* Bajo 400 px (casi todos los Android) los espacios se achican: con
            la marca, la capa ("enfermero/a", "estudiante") y cuatro botones,
            el menú quedaba 30 a 40 px fuera de la pantalla en un teléfono de
            360 px (medido en Chromium el 2026-10-04). Desde 400 px, como antes. */}
        <div className={`max-w-[820px] mx-auto px-3 min-[400px]:px-4 h-14 flex items-center gap-0.5 min-[400px]:gap-3${SHELL_ESCRITORIO_ENABLED ? " lg:max-w-[1240px]" : ""}`}>

          {/* Left: wordmark or back button */}
          {showBack ? (
            <button
              type="button"
              onClick={handleBack}
              aria-label={backDest ? `Volver a ${backDest}` : "Volver"}
              className="flex items-center gap-0.5 flex-shrink-0 -ml-1 pr-1 py-1 rounded-tk-md text-ink-muted hover:text-ink transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
            >
              <ChevronLeft size={20} strokeWidth={1.7} />
              {backDest && <span className="text-small font-sans font-medium leading-none">{backDest}</span>}
            </button>
          ) : (
            <button
              type="button"
              onClick={goHome}
              className="inline-flex items-center flex-shrink-0 bg-transparent p-0 text-left align-middle appearance-none transition-all duration-150 hover:opacity-90 focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 focus-visible:ring-offset-2 focus-visible:ring-offset-paper rounded-tk-md"
              aria-label={capaHeader ? `Volver al inicio, tu capa: ${capaHeader.palabra}` : "Volver al inicio"}
              title="Volver al inicio"
            >
              <LockupHeader capa={capaHeader} espacioRef={espacioHeaderRef} />
            </button>
          )}

          {/* Center: title + step indicator */}
          {/* Además de llevar el título, este hueco es el límite del nombre del
              modo que se despliega en el lockup (espacioRef de LockupHeader). */}
          <div ref={espacioHeaderRef} className="flex-1 min-w-0">
            {showBack && headerTitle && (
              <div className="flex items-center gap-2">
                <Heading level="h3" as="h1" className="text-ink truncate">
                  {headerTitle}
                </Heading>
                {appState === "rapido" && step >= 1 && step <= 4 && (
                  <span className="text-micro text-ink-muted font-sans flex-shrink-0">
                    Paso {vs} de 3
                  </span>
                )}
              </div>
            )}
          </div>

          {/* Shell de escritorio: la navegación como texto dentro del header.
              El título es lo único elástico (flex-1 min-w-0 trunca) y la nav no
              se encoge ni parte líneas. Se llama "Secciones" y no "Navegación
              principal" porque ese nombre ya es de la barra inferior: dos
              landmarks nav homónimos son ruido para un lector de pantalla. */}
          {/* Visitante de la web: la navegación de un sitio, no la de la app. */}
          {navPublica && (
            <nav className="hidden lg:flex items-center gap-1 flex-shrink-0" aria-label="Secciones">
              {navPublicaItems.map((it) => {
                const clase = `px-3 py-2 rounded-tk-md text-small font-sans whitespace-nowrap transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 ${it.active ? "text-accent font-semibold" : "text-ink-muted font-medium hover:text-ink"}`;
                return it.href
                  ? <a key={it.key} href={it.href} className={clase}>{it.label}</a>
                  : (
                    <button key={it.key} type="button" onClick={it.onClick} aria-current={it.active ? "page" : undefined} className={clase}>
                      {it.label}
                    </button>
                  );
              })}
            </nav>
          )}
          {SHELL_ESCRITORIO_ENABLED && !navPublica && navHeaderItems.length > 0 && (
            <nav className="hidden lg:flex items-center gap-1 flex-shrink-0" aria-label="Secciones">
              {navHeaderItems.map((it) => (
                <button
                  key={it.key}
                  type="button"
                  onClick={it.onClick}
                  aria-current={it.active ? "page" : undefined}
                  className={`px-3 py-2 rounded-tk-md text-small font-sans whitespace-nowrap transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 ${it.active ? "text-accent font-semibold" : "text-ink-muted font-medium hover:text-ink"}`}
                >
                  {it.label}
                </button>
              ))}
              {itemBienestarNav && (
                <button
                  type="button"
                  onClick={itemBienestarNav.onClick}
                  aria-expanded={bienestarOpen}
                  aria-haspopup="menu"
                  className={`inline-flex items-center gap-0.5 px-3 py-2 rounded-tk-md text-small font-sans whitespace-nowrap transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 ${itemBienestarNav.active ? "text-accent font-semibold" : "text-ink-muted font-medium hover:text-ink"}`}
                >
                  {itemBienestarNav.label}
                  <ChevronDown size={12} strokeWidth={2} aria-hidden="true" />
                </button>
              )}
            </nav>
          )}

          {/* Right: search + theme toggle + hamburger */}
          <IconButton
            variant="muted"
            size="sm"
            icon={<Search size={18} strokeWidth={1.6} />}
            ariaLabel="Buscar en MiPAE"
            onClick={openPalette}
            className="flex-shrink-0"
          />
          {/* Sol/luna abre el popover Apariencia (2026-09-10, "que sea más
              accesible cambiar el color y la fuente"): claro/oscuro es su
              primera fila, y debajo temas, letra y tamaño. Un tap desde
              cualquier pantalla. */}
          <IconButton
            variant="muted"
            size="sm"
            icon={dark
              ? <Sun size={18} strokeWidth={1.6} />
              : <Moon size={18} strokeWidth={1.6} />
            }
            ariaLabel="Apariencia: modo, colores y letra"
            aria-expanded={aparienciaOpen}
            aria-haspopup="dialog"
            onClick={() => setAparienciaOpen((v) => !v)}
            className="flex-shrink-0"
          />
          {/* Avatar = la puerta a Mi perfil en UN tap (2026-09-10, "que el
              panel de control se sienta más así"). El toggle día/noche se
              QUEDA en el header (el fundador lo pidió de vuelta el mismo día)
              y además vive dentro del panel junto al tema. Solo con sesión y
              perfil completo: antes de eso el embudo de entrada manda. */}
          {session && profile?.perfil_completado && (
            <button
              type="button"
              onClick={() => { registrarMetrica(session.user.id, 'perfil', 'header_avatar_tap'); setAppState("perfil"); }}
              aria-label="Mi perfil"
              aria-current={appState === "perfil" ? "page" : undefined}
              className={`flex-shrink-0 w-[40px] h-[40px] grid place-items-center rounded-full transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 ${appState === "perfil" ? "bg-accent-bg" : "hover:bg-surface"}`}
            >
              <span className="w-8 h-8 rounded-full bg-[var(--color-accent)] text-paper text-small font-bold font-sans grid place-items-center">
                {initials}
              </span>
            </button>
          )}
          {/* Benito va ANTES del menú hamburguesa: con Benito al extremo el
              menú "se perdía" detrás de él (dictado del fundador 2026-09-10).
              El menú es el último control del header en todas las anchuras.
              Reusa el onClick del ítem (trae la guarda de sesión y el apagado
              del badge): nada se duplica aquí. */}
          {SHELL_ESCRITORIO_ENABLED && !navPublica && itemBenitoNav && (() => {
            const IconoBenito = itemBenitoNav.icon;
            return (
              <button
                type="button"
                onClick={itemBenitoNav.onClick}
                aria-pressed={itemBenitoNav.active}
                aria-label={itemBenitoNav.badge ? "Benito (tiene algo para ti)" : "Benito"}
                className={`relative hidden lg:inline-flex items-center gap-1.5 flex-shrink-0 pl-2.5 pr-3 py-1.5 rounded-tk-md border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40 ${itemBenitoNav.active ? "border-accent-border bg-accent-bg text-accent" : "border-edge text-ink-muted hover:text-ink hover:border-accent-border"}`}
              >
                <IconoBenito size={18} strokeWidth={1.7} />
                {/* El rótulo aparece desde xl. Entre 1024 y 1280, con el panel
                    abierto el header se encoge 360px y el botón se salía del
                    contenedor: ahí queda solo la cara de Benito, que es la marca.
                    El aria-label no cambia, así que un lector de pantalla lo
                    sigue anunciando igual. */}
                <span className="hidden xl:inline text-small font-sans font-medium">Benito</span>
                {itemBenitoNav.badge && <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-clinical-stable ring-2 ring-paper" aria-hidden="true" />}
              </button>
            );
          })()}
          {/* Entrar y crear cuenta llevan a la MISMA tarjeta de acceso de la
              portada (Google y correo juntos, "Crea tu cuenta gratis o
              entra"): una sola puerta, dos nombres para quien busca uno u otro. */}
          {navPublica && (
            <div className="hidden lg:flex items-center gap-2 flex-shrink-0">
              <Button variant="ghost" size="sm" onClick={irAlAcceso} className="min-h-[40px]">Iniciar sesión</Button>
              <Button variant="primary" size="sm" onClick={irAlAcceso} className="min-h-[40px]">Crear cuenta</Button>
            </div>
          )}
          <IconButton
            size="sm"
            icon={menuOpen
              ? <X size={18} strokeWidth={1.6} />
              : <Menu size={20} strokeWidth={1.6} />
            }
            ariaLabel={menuOpen ? "Cerrar menú" : "Abrir menú"}
            onClick={handleOpenMenu}
            className="flex-shrink-0"
          />
        </div>

        {/* Progress bar for PAE Rápido */}
        {showRapidoProgress && (
          <div className="h-[3px] bg-edge">
            <div
              className="h-full bg-[var(--color-accent)] transition-all duration-300"
              style={{ width: `${Math.round((vs / 3) * 100)}%` }}
            />
          </div>
        )}
      </header>}
      {session && deVisita && !["prepara-practica", "prepara-internado", "prepara-turno", "cuenta-eliminada", "confirmacion-edad"].includes(appState) && !pendingDisclaimer && !respiraEnSesion && (
        <BandaMundo
          mundo={mundo}
          casa={casaDe(profile)}
          conPlanGratis={!tieneAccesoPlus(perfilMundo) && esMipaePlus(profile)}
          onVolver={() => cambiarMundo(casaDe(profile))}
        />
      )}

      {/* ── Global Menu Panel ── */}
      {menuOpen && (
        <>
          <div
            className={`fixed inset-0 z-40 bg-ink/40 transition-opacity duration-200 ${menuEntered ? 'opacity-100' : 'opacity-0'}`}
            onClick={closeMenu}
            aria-hidden="true"
          />
          <div className={`fixed top-0 right-0 bottom-0 z-50 w-[300px] h-[100dvh] max-h-[100dvh] min-h-0 overflow-hidden bg-paper flex flex-col shadow-tk-modal transition-transform duration-300 ease-out ${menuEntered ? 'translate-x-0' : 'translate-x-full'}`} style={{ paddingTop: 'env(safe-area-inset-top)' }}>

            {/* Panel header */}
            <div className="h-14 flex items-center justify-between px-5 border-b border-edge flex-shrink-0">
              <span className="text-h3 text-ink font-sans">Menú</span>
              <IconButton
                variant="muted"
                size="sm"
                icon={<X size={18} strokeWidth={1.6} />}
                ariaLabel="Cerrar menú"
                onClick={closeMenu}
              />
            </div>

            {/* Scrollable content */}
            <div
              className="flex-1 min-h-0 overflow-y-auto overscroll-contain px-4 py-4 flex flex-col gap-2"
              style={{ WebkitOverflowScrolling: 'touch', touchAction: 'pan-y' }}
            >

              {/* User chip / login */}
              {session ? (
                <Card variant="surface" padding="sm" className="mb-3">
                  {/* El chip ES la puerta a Mi perfil: el menú se quedó solo
                      con módulos (2026-09-10) y lo personal vive en el panel. */}
                  <button
                    type="button"
                    onClick={() => { closeMenu(); if (profile?.perfil_completado) setAppState("perfil"); }}
                    className="w-full flex items-center gap-3 text-left rounded-tk-sm focus:outline-none focus-visible:ring-2 focus-visible:ring-accent/40"
                    aria-label="Abrir Mi perfil"
                  >
                    <div className="w-9 h-9 rounded-full bg-[var(--color-accent)] flex items-center justify-center text-paper text-small font-bold flex-shrink-0 font-sans">
                      {initials}
                    </div>
                    <div className="min-w-0">
                      {userName && (
                        <div className="flex items-center gap-1.5 min-w-0">
                          <div className="text-small font-semibold text-ink truncate font-sans">{userName}</div>
                          {/* El sello es de la extendida REAL (pago o prueba),
                              no del acceso abierto: con isMipaePlus se le
                              pintaba a todos (A6, precedente de Mi perfil). */}
                          {esMipaePlus(perfilMundo) && <PlusBadge size="xs" className="flex-shrink-0" nombre={nombreMembresia(profile)} />}
                        </div>
                      )}
                      <div className="text-micro text-ink-muted truncate font-sans normal-case tracking-normal font-normal">{userEmail}</div>
                    </div>
                    <ChevronRight size={16} strokeWidth={1.6} className="ml-auto text-ink-muted flex-shrink-0" aria-hidden="true" />
                  </button>
                </Card>
              ) : navPublica ? (
                // Visitante de la web: crear cuenta y entrar van a la tarjeta de
                // acceso de la portada, que tiene Google y el correo juntos.
                <div className="mb-2 flex flex-col gap-2">
                  <Button variant="primary" onClick={() => { closeMenu(); irAlAcceso(); }} className="w-full min-h-[44px]">
                    Crear mi cuenta gratuita
                  </Button>
                  <Button variant="secondary" onClick={() => { closeMenu(); irAlAcceso(); }} className="w-full min-h-[44px]">
                    Iniciar sesión
                  </Button>
                </div>
              ) : (
                <Button
                  variant="secondary"
                  iconLeft={GOOGLE_LOGIN_DISPONIBLE ? <GoogleIcon /> : undefined}
                  onClick={() => { closeMenu(); handleLogin(); }}
                  className="w-full mb-2"
                >
                  {GOOGLE_LOGIN_DISPONIBLE ? "Iniciar sesión con Google" : "Iniciar sesión"}
                </Button>
              )}

              {/* Nav sections. Menú por experiencia (propuesta aprobada por
                  el fundador el 2026-10-16, docs/plan-interfaz-por-experiencia.md
                  §2; el prototipo mostraba estos mismos grupos). Cada
                  experiencia abre con lo suyo y no ve lo que no le toca: el
                  PAE vive en MiPAE Estudiante, el TENS no recibe las guías
                  de la formación ni Revisa, y nada se muestra con candado
                  para empujar a otra experiencia (queda en el buscador). Se
                  decide con el perfil del MUNDO, como el resto del menú. */}
              {(() => {
                const capaMenu = navPublica
                  ? 'publica'
                  : !session || !perfilMundo?.rol
                  ? 'visitante'
                  : esTens(perfilMundo)
                    ? 'tens'
                    : esCapaEjercicio(perfilMundo)
                      ? 'enfermero'
                      : esElegibleTurno(perfilMundo) ? 'interna' : 'estudiante';
                const I = {
                  tusPaes: session && profile?.perfil_completado && veTusPaes ? {
                    label: "Tus PAEs",
                    icon: FileText,
                    action: () => { closeMenu(); setAppState("mis-paes"); },
                    sub: "Los que ya guardaste",
                  } : null,
                  rapido: {
                    label: "PAE Rápido",
                    icon: Sparkles,
                    module: "pae-rapido",
                    action: () => { closeMenu(); startMode("rapido", "menu"); },
                    badge: !session ? 'lock' : null,
                    sub: !session ? 'Diagnóstico NANDA-I guiado' : null,
                  },
                  detallado: {
                    label: "PAE Detallado",
                    icon: PenLine,
                    module: "pae-detallado",
                    action: () => { closeMenu(); startMode("detallado", "menu"); },
                    badge: !session ? 'lock' : null,
                    sub: !session ? 'Guarda y profundiza tu caso' : null,
                  },
                  turno: {
                    label: "MiPAE en turno",
                    icon: ClipboardList,
                    // "registro-turno" no existe en los mapas de color: el
                    // ícono salía gris. MiPAE en turno usa el color de
                    // prepara-turno (el mismo del cockpit).
                    module: "prepara-turno",
                    action: () => { closeMenu(); abrirRegistroTurno("menu"); },
                    badge: !session ? 'lock' : null,
                    // El TENS tiene su propio registro: pacientes, cuidados y entrega.
                    sub: capaMenu === 'tens' ? "Tus pacientes, cuidados y entrega" : "Tu centro de control del turno",
                  },
                  // Diálisis: pantalla propia, APARTE del turno (corrección del
                  // fundador 2026-09-21). El team de terapias extracorpóreas no
                  // tiene turno abierto ni camas propias: llegan llamados,
                  // conectan a un paciente de otra enfermera y se van. Vive en
                  // "Tu turno" porque es trabajo del turno, no en una sección suelta.
                  dialisis: veDialisis(perfilMundo) ? { label: "Registrar una terapia", icon: Droplets, sub: "Diálisis", action: () => { closeMenu(); setAppState("dialisis"); } } : null,
                  recepcion: { label: "Recepción de paciente", icon: ClipboardCheck, module: "enciclopedia", action: () => { closeMenu(); abrirReferencia("recepcion"); }, sub: "Checklist de inicio (SBAR)" },
                  revisa: { label: "Revisa", icon: Zap, module: "revisa", action: () => { closeMenu(); openRevisa('menu'); }, badge: !session ? 'lock' : null },
                  fabRevisa: fabDismissed ? { label: "Mostrar acceso rápido a Revisa", icon: Plus, action: () => { closeMenu(); restoreFab(); } } : null,
                  escalas: { label: "Escalas clínicas", icon: Activity, module: "escalas", action: () => { closeMenu(); setAppState("escalas"); } },
                  medicamentos: { label: "Medicamentos", icon: Pill, module: "medicamentos", action: () => { closeMenu(); abrirFichas(); } },
                  enciclopedia: { label: "Enciclopedia", icon: BookOpen, module: "enciclopedia", action: () => { closeMenu(); abrirReferencia(); }, sub: "Exámenes, fármacos, escalas, protocolos" },
                  // Los cuidados del paciente (plan del mundo TENS): la sección
                  // Procedimientos de la Enciclopedia, con su color, igual que el
                  // atajo del inicio.
                  cuidados: { label: "Cuidados del paciente", icon: ListChecks, module: "enciclopedia", action: () => { closeMenu(); abrirReferencia("procedimientos"); }, sub: "Paso a paso, con su porqué" },
                  estudio: { label: "Modo estudio", icon: GraduationCap, module: "enciclopedia", action: () => { closeMenu(); abrirReferencia("estudio"); }, sub: "Preguntas para repasar gases, laboratorio, aislamiento, lesiones por presión, escalas, cuidados del paciente y GES" },
                  // P4 (decisión del fundador 2026-10-04): las fichas de los
                  // modelos, a un toque. Mismo texto que el atajo del inicio;
                  // donde no hay PAE, el de la Enciclopedia.
                  modelos: { label: "Modelos de enfermería", icon: Library, module: "enciclopedia", action: () => { closeMenu(); abrirReferencia("modelos"); }, sub: paeEnEsteMundo ? "Doce modelos para valorar y justificar tu PAE" : "Henderson, Gordon, Orem, Roy y más, con un caso de ejemplo" },
                  biblioteca: { label: "Biblioteca", icon: BookOpen, module: "bibliografia", action: () => { closeMenu(); irAModulo('bibliografia', () => setAppState("bibliografia")); }, badge: !session ? 'lock' : null, sub: "Temas y bibliografía" },
                };
                // Al estudiante, SOLO el "Prepara" de su etapa (P2, decisión del
                // fundador 2026-10-04; preparaDelMenu en lib/homeExplora.js). Los
                // cuatro siguen en el buscador. Desde el 2026-10-16 van dentro de
                // "Tu formación", que reemplaza a "MiPAE te acompaña".
                const prepara = preparaDelMenu(perfilMundo).map((id) => ({
                  "prepara-practica": { label: "Prepara tu práctica", icon: BookOpen, module: "prepara-practica", action: () => { closeMenu(); setAppState("prepara-practica"); } },
                  "prepara-internado": { label: "Prepara tu internado", icon: BookOpen, module: "prepara-internado", action: () => { closeMenu(); setAppState("prepara-internado"); } },
                  "prepara-turno": { label: "Prepara tu turno", icon: Clock, module: "prepara-turno", action: () => { closeMenu(); setAppState("prepara-turno"); } },
                  "prepara-examen": { label: "Prepara tu examen", icon: GraduationCap, module: "prepara-examen", action: () => { closeMenu(); irAModulo('prepara-examen', () => setAppState("prepara-examen")); }, badge: !session ? 'lock' : null },
                })[id]);
                const seccion = (title, items) => ({ title, items: items.filter(Boolean) });
                // "Volver al inicio" se queda en todas: dentro de un PAE la barra
                // de abajo se esconde en el teléfono y el menú es el camino a casa.
                const inicio = seccion("Inicio", [{ label: "Volver al inicio", icon: House, action: () => { closeMenu(); goHome(); } }]);
                const tuPae = seccion("Tu PAE", [I.tusPaes, I.rapido, I.detallado]);
                // El estudiante sin internado en curso abre MiPAE en turno desde
                // aquí y ve su presentación con la cama de práctica (P1,
                // decisión del fundador 2026-10-04): es parte de su formación,
                // no un turno propio.
                const tuFormacion = seccion("Tu formación", [
                  ...prepara,
                  capaMenu === 'estudiante' ? { ...I.turno, sub: "Conócelo antes de tu internado" } : null,
                  I.estudio, I.modelos, I.biblioteca,
                ]);
                const consulta = seccion("Consulta", [I.escalas, I.medicamentos, I.revisa, I.fabRevisa, I.enciclopedia]);
                const tuTurno = seccion("Tu turno", [I.turno, I.dialisis, I.recepcion]);
                const bienestar = seccion("Bienestar", [
                  // Con el módulo, la sección abre con su home, que se llama
                  // igual que su título ("Tu pausa"): un ítem "Bienestar" bajo
                  // el título "Bienestar" repetía la palabra. Respira y la
                  // Bitácora siguen a un toque, como en el buscador, y cada
                  // fila dice lo mismo que dice en las otras superficies.
                  BIENESTAR_MODULO_ENABLED ? { label: "Tu pausa", icon: Heart, module: "bienestar", sub: "Respira, pausas guiadas y Bitácora", action: () => { closeMenu(); abrirBienestar(); } } : null,
                  { label: "Respira", icon: Wind, module: "respira", sub: BIENESTAR_MODULO_ENABLED ? "Respiración guiada para una pausa" : null, action: () => { closeMenu(); abrirRespira("generico"); } },
                  {
                    label: "Bitácora",
                    icon: ClipboardList,
                    module: "bitacora",
                    sub: BIENESTAR_MODULO_ENABLED ? "Cómo viviste tu turno" : null,
                    // Con sesión pero sin perfil completo, `handleLogin` no hacía
                    // nada visible (NAV-02, auditoría 2026-09-28: "Bitácora no
                    // abrió"): la Bitácora exige perfil completo, así que se
                    // lleva a completarlo, que es la puerta real. Sin sesión,
                    // el login de siempre.
                    action: session && profile?.perfil_completado
                      ? () => { closeMenu(); setAppState("bitacora"); }
                      : session
                        ? () => { closeMenu(); setAppState("perfil"); }
                        : () => { closeMenu(); handleLogin(); },
                    badge: !session ? 'lock' : null,
                  },
                ]);
                const SECCIONES = {
                  estudiante: [tuPae, tuFormacion, consulta, bienestar],
                  // La interna trabaja turnos: su turno va primero, como en su
                  // inicio, y el PAE no se esconde por estar en internado.
                  interna: [tuTurno, tuPae, tuFormacion, consulta, bienestar],
                  // Con los mundos apagados no hay a dónde pasar: el PAE vuelve a la casa.
                  // Modelos de enfermería no va en su menú (decisión del fundador
                  // 2026-10-16): sirven para valorar y fundamentar un PAE, que vive
                  // en MiPAE Estudiante. Siguen en la Enciclopedia y el buscador.
                  enfermero: [tuTurno, ...(mundosOn ? [] : [tuPae]), consulta, seccion("Aprende", [I.estudio, I.biblioteca]), bienestar],
                  // TENS: su turno, su consulta con los cuidados primero y Modo
                  // estudio. Sin PAE, guías de la formación ni Revisa (I6 del
                  // plan de los tres mundos y propuesta del 16-oct).
                  tens: [
                    seccion("Tu turno", [I.turno]),
                    ...(mundosOn ? [] : [tuPae]),
                    seccion("Consulta", [I.cuidados, I.escalas, I.medicamentos, I.enciclopedia]),
                    seccion("Aprende", [I.estudio]),
                    bienestar,
                  ],
                  // Sin rol todavía, o el visitante de la app instalada: todo a
                  // la vista, con candado donde pide entrar, para que sepa qué hay.
                  visitante: [tuPae, consulta, tuTurno, tuFormacion, bienestar],
                  // Visitante de la WEB (navegación pública, 2026-10-30): conocer
                  // MiPAE y contactarnos, y lo que se abre sin cuenta (lo mismo
                  // que la portada ofrece "sin cuenta"). Lo que pide cuenta no se
                  // lista: lo cuenta la portada y lo encuentra el buscador.
                  publica: [
                    seccion("Conoce MiPAE", navPublicaItems.map((it) => ({
                      label: it.label,
                      icon: it.icon,
                      action: () => { closeMenu(); if (it.href) window.location.assign(it.href); else it.onClick(); },
                    }))),
                    seccion("Se abren sin cuenta", [
                      I.escalas, I.medicamentos, I.enciclopedia, I.estudio,
                      { label: "Respira", icon: Wind, module: "respira", sub: "Respiración guiada para una pausa", action: () => { closeMenu(); abrirRespira("generico"); } },
                    ]),
                  ],
                };
                return [
                  inicio,
                  ...SECCIONES[capaMenu].filter((s) => s.items.length > 0),
                  ...(['admin','owner'].includes(profile?.role) ? [{
                    title: "Admin",
                    items: [
                      { label: "Métricas", icon: BarChart2, action: () => { closeMenu(); setAppState("admin"); } },
                      // POC MiPAE Voice: entrada solo para admin, el resto de los
                      // usuarios no ve ni sabe que el experimento existe.
                      { label: "MiPAE Voice (labs)", icon: Mic, action: () => { closeMenu(); setAppState("labs-voz"); } },
                    ],
                  }] : []),
                // Panel de gestión: página propia (no una pestaña de
                // Métricas), decisión del fundador 2026-09-10. La ve admin y
                // quien tenga el permiso acotado `ve_jefatura` (una jefatura
                // real sin ser admin), en su propia sección del menú.
                ...(veJefatura(profile) ? [{
                  title: "Jefatura",
                  items: [
                    { label: "Panel de gestión", icon: BarChart2, action: () => { closeMenu(); setAppState("jefatura"); } },
                  ],
                }] : []),
                ];
              })().map(({ title, items }) => {
                return (
                  <div key={title} className="flex flex-col gap-1 mb-2">
                    <p className="text-micro text-ink-muted px-3 pt-2 pb-1 font-sans">
                      {title}
                    </p>
                    {items.map(({ label, icon: Icon, module, action, soon, badge, sub }) => {
                      return (
                        <MenuItem
                          key={label}
                          icon={<Icon size={17} strokeWidth={1.6} />}
                          label={label}
                          description={sub || undefined}
                          module={module}
                          disabled={soon}
                          badge={badge && !soon
                        ? (badge === 'lock'
                          ? <Lock size={12} strokeWidth={2} className="text-ink-faint" />
                          : <Badge tone="info">{badge}</Badge>)
                        : undefined}
                          onClick={action}
                        />
                      );
                    })}
                  </div>
                );
              })}
            </div>

            {/* Panel footer */}
            <div className="border-t border-edge px-4 py-4 flex flex-col gap-2 flex-shrink-0">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 px-3">
                {/* En la navegación pública ¿Qué es MiPAE? y Contacto ya van
                    arriba, y "Danos tu opinión" pide una cuenta: no se repiten. */}
                {!navPublica && (
                  <>
                <button
                  type="button"
                  onClick={() => { closeMenu(); setAppState("que-es-mipae"); }}
                  className="text-small text-ink-muted hover:text-ink transition-colors font-sans"
                >
                  ¿Qué es MiPAE?
                </button>
                <span className="text-ink-faint select-none">·</span>
                {/* Pedir ayuda si ya se usa MiPAE (2026-10-30): WhatsApp de
                    Sebastián y el correo, en la pantalla Contacto. */}
                <button
                  type="button"
                  onClick={() => { closeMenu(); setAppState("contacto"); }}
                  className="text-small text-ink-muted hover:text-ink transition-colors font-sans"
                >
                  {session ? "Contacto y ayuda" : "Contacto"}
                </button>
                <span className="text-ink-faint select-none">·</span>
                {/* Mismo canal y mismo nombre que Mi perfil (A30): la pantalla
                    "Danos tu opinión" (TuOpinion → feedback_general). El
                    mailto en inglés quedaba fuera del panel "Voces de los
                    usuarios". Pide cuenta, como el resto de lo que se guarda. */}
                <button
                  type="button"
                  onClick={() => { closeMenu(); if (session) setAppState("opinion"); else handleLogin(); }}
                  className="text-small text-ink-muted hover:text-ink transition-colors font-sans"
                >
                  Danos tu opinión
                </button>
                <span className="text-ink-faint select-none">·</span>
                  </>
                )}
                <button
                  type="button"
                  onClick={abrirTour}
                  className="text-small text-ink-muted hover:text-ink transition-colors font-sans"
                >
                  Ver tour de nuevo
                </button>
                <span className="text-ink-faint select-none">·</span>
                <button
                  type="button"
                  onClick={() => { closeMenu(); setNovedadesOpen(true); trackEvent("que_cambio_abierto", { modulo: "home", payload: { origen: "menu" } }); }}
                  className="text-small text-ink-muted hover:text-ink transition-colors font-sans"
                >
                  Novedades
                </button>
                <span className="text-ink-faint select-none">·</span>
                <button
                  type="button"
                  onClick={() => { closeMenu(); abrirBibliografia(); }}
                  className="text-small text-ink-muted hover:text-ink transition-colors font-sans"
                >
                  Bibliografía
                </button>
              </div>
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1 px-3">
                {session && profile?.perfil_completado && (
                  <>
                    <button
                      type="button"
                      onClick={() => { closeMenu(); setAppState("ajustes"); }}
                      className="text-small text-ink-faint hover:text-ink-muted transition-colors font-sans"
                    >
                      Ajustes
                    </button>
                    <span className="text-ink-faint select-none">·</span>
                  </>
                )}
                <button
                  type="button"
                  onClick={() => { closeMenu(); setAppState("privacidad"); }}
                  className="text-small text-ink-faint hover:text-ink-muted transition-colors font-sans"
                >
                  Privacidad
                </button>
                <span className="text-ink-faint select-none">·</span>
                <button
                  type="button"
                  onClick={() => { closeMenu(); setAppState("terminos"); }}
                  className="text-small text-ink-faint hover:text-ink-muted transition-colors font-sans"
                >
                  Términos
                </button>
              </div>
              {session && (
                <MenuItem
                  variant="danger"
                  icon={<LogOut size={17} strokeWidth={1.6} />}
                  label="Cerrar sesión"
                  /* Hacer visible lo que la app ya hacía: el signOut es global.
                     Nació de una usuaria que dejó la sesión abierta en un
                     computador prestado y no tenía cómo saber que podía
                     cerrarla desde su teléfono. */
                  description="Se cierra en todos tus dispositivos"
                  onClick={() => { closeMenu(); handleLogout(); }}
                />
              )}
            </div>
          </div>
        </>
      )}

      {/* ── Global Command Palette — buscador ── */}
      <CommandPalette open={paletteOpen} onClose={closePalette} items={paletteItems} />

      {/* Salir del PAE Detallado con algo escrito: se pregunta antes. */}
      <Modal
        open={confirmarSalirPae}
        onClose={() => setConfirmarSalirPae(false)}
        tone="danger"
        title="¿Salir del PAE?"
        confirmLabel="Salir"
        cancelLabel="Seguir en el PAE"
        onConfirm={salirDelDetalladoConfirmado}
      >
        <p>Perderás lo que escribiste en este PAE Detallado.</p>
      </Modal>

      {/* Cerrar sesión con turno abierto: el barrido local se lleva lo que no
          alcanzó a subir, así que acá se dice antes, sin dramatizar. */}
      <Modal
        open={confirmarSalida}
        onClose={() => setConfirmarSalida(false)}
        tone="danger"
        title="Tienes un turno abierto"
        confirmLabel="Cerrar sesión"
        cancelLabel="Cancelar"
        onConfirm={ejecutarLogout}
      >
        <p className="mb-3">
          Tu sesión se cierra en todos tus dispositivos y este equipo queda sin tus
          borradores. Cuando entres de nuevo, tu turno se descarga otra vez.
        </p>
        <p>
          Antes de salir subimos lo que quede pendiente. Con mala señal, lo último
          que escribiste puede no alcanzar a subir.
        </p>
      </Modal>

      {/* ── Global FAB — Revisa (oculto cuando hay barra de pestañas: Revisa vive ahí) ── */}
      {!showRevisa && !fabDismissed && !showTabBar && !navPublica && (
        <RevisaFab
          active={fabActive}
          justRestored={fabJustRestored}
          onOpen={() => openRevisa('fab')}
          onDismiss={dismissFab}
        />
      )}
      <Suspense fallback={<div className="flex items-center justify-center min-h-[40vh]"><div className="w-6 h-6 rounded-full border-2 border-edge border-t-[var(--brand)] animate-spin" /></div>}>

      {showRevisa && (
        <Revisa
          onClose={closeRevisa}
          userId={session?.user?.id}
          entrySource={revisaSource}
          initialQuery={revisaInitialQuery}
          patientContext={revisaPatientContext}
          userPerfil={{ rol: profile?.rol, servicio: nombreServicio(rotacion) }}
          isPremium={isMipaePlus}
          selloExtendida={esMipaePlus(perfilMundo)}
          onAbrirFicha={(slug) => { closeRevisa(); abrirFichas(slug); }}
          onAbrirEscala={(id) => { closeRevisa(); abrirEscala(id); }}
          onAbrirGes={(slug) => { closeRevisa(); abrirGes(slug); }}
          onGuardarEnTurno={revisaGuardarNota || undefined}
          onConocerPlus={!isNative && session && !isMipaePlus && !deVisita ? () => { closeRevisa(); abrirPlanes('revisa_panel'); } : undefined}
        />
      )}

      {/* El tour jamás tapa el embudo (edad/perfil): si algo lo deja encendido
          ahí, se pospone hasta una pantalla donde corresponda. */}
      {showTour && appState !== "confirmacion-edad" && !(appState === "perfil" && !profile?.perfil_completado) && (
        <div className="fixed inset-0 z-[60]" style={{ background: '#F6F5EE' }}>
          <OnboardingVideo
            loop={false}
            carril={carrilTour}
            superficie={superficieTour}
            origen={tourOrigen}
            onSkip={() => setShowTour(false)}
            onEntrar={() => setShowTour(false)}
            onProbar={() => {
              setShowTour(false);
              // Por superficie (kill-switch apagado ⇒ superficieTour es null,
              // cae al PAE demo de siempre). En 'turno' la enfermera aterriza
              // DIRECTO en la ficha de una cama de práctica con dispositivos y
              // riesgos: el dato decía que el onboarding se veía y no llevaba a
              // documentar. El TENS no tiene práctica (su beat vive en HomeTens).
              if (superficieTour === 'turno') { setTurnoPracticaAlEntrar(true); abrirRegistroTurno('tour'); return; }
              if (superficieTour === 'tens') { abrirRegistroTurno('tour'); return; }
              if (superficieTour === 'jefatura') { setAppState('jefatura'); return; }
              // El CTA del estudiante dice "Empezar mi primer PAE" (ctaCierre):
              // abre su PAE de verdad, no el ejemplo de solo lectura (A10).
              // Donde no hay PAE (una estudiante que mira otro mundo y repite el
              // tour), el botón no queda mudo: vuelve al inicio.
              if (superficieTour === 'pae') { if (paeEnEsteMundo) startMode('rapido', 'tour'); else goHome(); return; }
              startDemo();
            }}
          />
        </div>
      )}

      {/* ── Views ── */}

      {appState === "cuenta-eliminada" && (
        <CuentaEliminada
          onIrAlInicio={() => {
            setAppState("home");
            try { window.location.href = "/"; } catch { /* ignore */ }
          }}
        />
      )}

      {appState === "confirmacion-edad" && session && (
        <ConfirmacionEdad
          onConfirmar={handleConfirmarEdad}
          onLogout={handleLogout}
          onPrivacidad={() => setAppState("privacidad")}
          onTerminos={() => setAppState("terminos")}
        />
      )}

      {/* Al guardar, la fila del perfil se FUNDE con el perfil en memoria:
          reemplazarlo dejaba fuera la edad confirmada (y el embudo volvía a
          pedirla en la primera puerta que lo revisara), el rol de admin y la
          institución que el estudiante ya no edita (A17). */}
      {appState === "perfil" && session && !profile?.perfil_completado && (
        process.env.REACT_APP_ONBOARDING_AGENTE_ENABLED !== 'false' && !perfilModoForm ? (
          <OnboardingAgente
            userId={session.user.id}
            perfilInicial={perfilPendiente}
            onGuardado={(p) => { setProfile((prev) => ({ ...(prev || {}), ...p })); trackEvent('signup_completado', { modulo: 'onboarding', payload: { rol: p?.rol || 'sin_rol', ...(p?.origen_conocido ? { origen: p.origen_conocido } : {}), ...atribucionParaPayload() } }); pingGeo(session?.access_token); aterrizarPostOnboarding(p); }}
            onUsarFormulario={() => setPerfilModoForm(true)}
          />
        ) : (
          <Perfil
            userId={session.user.id}
            perfilInicial={perfilPendiente}
            esEdicion={false}
            onGuardado={(p) => { setProfile((prev) => ({ ...(prev || {}), ...p })); trackEvent('signup_completado', { modulo: 'onboarding', payload: { rol: p?.rol || 'sin_rol', ...(p?.origen_conocido ? { origen: p.origen_conocido } : {}), ...atribucionParaPayload() } }); pingGeo(session?.access_token); aterrizarPostOnboarding(p); }}
          />
        )
      )}

      {appState === "perfil" && session && profile?.perfil_completado && (
        <PanelUsuario
          onRefrescarPerfil={refetchPerfil}
          userId={session.user.id}
          userEmail={session.user.email}
          profile={profile}
          userName={userName}
          rotacion={rotacion}
          // La tarjeta "Tu plan" mira la suscripción REAL (pago o prueba), no el
          // acceso abierto: con topes vigentes para el plan gratis, decirle a cada
          // persona gratis que tiene MiPAE+ y acceso completo era falso (2026-09-26).
          isPremium={esMipaePlus(profile)}
          // Se FUNDE con lo que ya había: la fila guardada trae solo los
          // campos del formulario, y reemplazar el perfil entero borraba de
          // memoria la edad confirmada, el rol de admin, el plan y la
          // institución que el estudiante ya no edita (A17).
          onGuardado={(p) => setProfile((prev) => ({ ...(prev || {}), ...p }))}
          onVolver={irAtras}
          onAbrirMisPaes={() => setAppState("mis-paes")}
          onAbrirProgreso={() => setAppState("mi-progreso")}
          onAbrirCalendario={() => {
            registrarMetrica(session.user.id, 'calendario', 'calendario_menu_click');
            setAppState(rotacion ? "calendario" : "calendario-config");
          }}
          onAbrirBitacora={() => setAppState("bitacora")}
          onAbrirAjustes={() => setAppState("ajustes")}
          onAbrirOpinion={() => setAppState("opinion")}
          // Tres mundos: la casa y pasar a otro mundo. El aviso de que el plan
          // vale solo en casa se dice solo cuando es verdad (acceso cerrado y
          // plan vigente).
          mundo={deVisita ? mundo : null}
          planSoloEnCasa={!accesoPlusAbierto() && esMipaePlus(profile)}
          onCambiarMundo={cambiarMundo}
          /* Aporte voluntario SOLO en la web (política de Play sobre bienes
             digitales, decisión B2B 2026-08-02): en nativo la fila ni aparece. */
          // El aporte es contratar Estudiante Plus: un TENS no puede (MiPAE TENS
          // es gratuito), así que no se le ofrece.
          onAportar={!isNative && profile?.rol !== 'tens' ? () => abrirPlanes('panel') : undefined}
          onResetTour={abrirTour}
          onHacersePremium={() => abrirPlanes('panel')}
          onCuentaEliminada={() => {
            setSession(null);
            setProfile(null);
            setAppState("cuenta-eliminada");
          }}
        />
      )}

      {appState === "ajustes" && session && profile?.perfil_completado && (
        <Ajustes
          userId={session.user.id}
          profile={profile}
          rotacion={rotacion}
          onVolver={irAtras}
        />
      )}

      {appState === "mis-paes" && session && profile?.perfil_completado && (veMisPaes(profile) || veTusPaes) && (
        <MisPaes
          userId={session.user.id}
          onVolver={irAtras}
          // El PAE vive en MiPAE Estudiante: si se llega aquí desde otro mundo
          // (una estudiante de visita abre Tus PAEs desde Mi perfil), abrir
          // uno la lleva a MiPAE Estudiante, y el vacío no ofrece armar uno
          // donde no se puede.
          onAbrirPAE={paeEnEsteMundo ? handleAbrirPAE : (p) => { cambiarMundo("estudiante"); handleAbrirPAE(p); }}
          onNuevoPae={paeEnEsteMundo ? () => startMode("rapido", "mis_paes") : null}
        />
      )}

      {/* Tu PAE: lo que abre la pestaña PAE (paso 2 de la interfaz por
          experiencia, maqueta "Seguir primero" elegida el 2026-10-16). Lo
          empezado manda: el borrador es el mismo que avisa el inicio y se
          sigue o se descarta con las mismas funciones. Solo donde vive el PAE. */}
      {appState === "tu-pae" && session && profile?.perfil_completado && paeEnEsteMundo && (
        <TuPae
          userId={session.user.id}
          borrador={borradorPendiente?.data || null}
          onContinuarBorrador={continuarBorrador}
          onDescartarBorrador={descartarBorrador}
          onNuevo={(m) => startMode(m, "tu_pae", { desdeCero: true })}
          onAbrirPAE={handleAbrirPAE}
          onVerTodos={() => setAppState("mis-paes")}
        />
      )}

      {appState === "opinion" && session && (
        <TuOpinion onVolver={irAtras} />
      )}

      {appState === "lo-nuevo" && session && (
        <LoNuevoMiPAE
          profile={profile}
          mundo={mundo}
          origen={loNuevoOrigen}
          onVolver={irAtras}
          onMetric={logFreemiumMetric}
          onRefrescarPerfil={refetchPerfil}
          onTrialIniciado={goHome}
          onVerPlanes={isNative ? undefined : () => abrirPlanes("lo_nuevo")}
          onUsar={(id) => {
            if (id === "turno") abrirRegistroTurno("lo_nuevo");
            else if (id === "pae") setAppState(paeEnEsteMundo ? "tu-pae" : "home");
            else setAppState("perfil");
          }}
          onTerminos={() => setAppState("terminos")}
        />
      )}

      {appState === "planes" && session && (
        <Planes
          profile={profile}
          trialDisponible={puedeIniciarTrial}
          onVolver={irAtras}
          onCompletarPerfil={() => setAppState("perfil")}
          onMetric={logFreemiumMetric}
          onTrialIniciado={async () => { await refetchPerfil(); goHome(); }}
        />
      )}

      {/* Borrador pendiente: dice qué PAE es (Rápido o Detallado), con el
          ancho del Home, tokens y botones de 44 px. */}
      {appState === "home" && avisoBorradorArriba && (
        <div className="max-w-[480px] mx-auto px-5 pt-4">
          <Banner
            tone="info"
            action={
              <span className="flex items-center gap-2">
                <Button size="sm" onClick={continuarBorrador} className="min-h-[44px]">
                  Continuar
                </Button>
                <Button size="sm" variant="ghost" onClick={descartarBorrador} className="min-h-[44px]">
                  Descartar
                </Button>
              </span>
            }
          >
            <span className="block font-semibold text-ink">{nombreDelBorrador(borradorPendiente.data)} sin terminar</span>
            <span className="block">{haceCuanto(borradorPendiente.data.timestamp)}. ¿Continuar donde lo dejaste?</span>
          </Banner>
        </div>
      )}

      {appState === "home" && (
        <>
          {/* Cinturón: si algún camino dejó al usuario en el home con el perfil
              a medio completar (sin él, MiPAE en turno y el compañero no renderizan),
              el home lo dice y ofrece la salida — nunca un home mudo. */}
          {session && profile && !profile.perfil_completado && (
            <div className="max-w-[480px] mx-auto px-5 pt-4">
              <div className="flex items-center gap-3 rounded-tk-md border border-accent-border bg-accent-bg/40 px-4 py-3">
                <p className="flex-1 text-small text-ink font-sans leading-snug">
                  Termina tu perfil para desbloquear MiPAE en turno y tu compañero.
                </p>
                <Button size="sm" onClick={() => setAppState("perfil")} className="flex-shrink-0">
                  Completar
                </Button>
              </div>
            </div>
          )}
          {/* El contador de cuota salió del Home (Fase 2 de la extendida,
              2026-09-16): "te queda 1 PAE" en pantalla choca con la regla
              anti-culpa. El tope se explica en el punto de uso (PremiumPaywall
              y la burbuja de Benito). */}
          {/* MiPAE+ salió del Home (decisión del fundador, 2026-08-02: el rumbo
              es B2B y el banner distraía más de lo que ayudaba). UpsellPlusHome
              NO vuelve. AvisoLanzamientoPlus se reconectó el 2026-09-14 SOLO
              como aviso de FECHA (los 14 días de aviso de los Términos §6):
              sin REACT_APP_PLUS_FECHA_CIERRE no pinta nada; con la fecha avisa
              que el plan gratis tendrá topes de IA y que todo lo que se usa
              hoy sigue gratis. Sin botón de compra: también lo ve la app
              instalada. */}
          {session && profile?.rol !== 'estudiante' && accesoPlusAbierto() && <AvisoLanzamientoPlus />}
          {session && enTransicionEstudiante(profile) && !esMipaePlus(profile) && (
            <div role="note" className="rounded-xl border border-edge bg-surface p-4 mb-4 text-sm text-ink">
              <strong>MiPAE Estudiante cambia el 25 de octubre.</strong>{" "}
              Hasta el 24 mantienes tus condiciones actuales. Desde el 25, la cuenta gratuita incluye 1 PAE al mes en total, compartido entre Rápido, Detallado y con tu pauta, y 3 consultas diarias a Benito. Tus trabajos guardados siguen disponibles.
              {!isNative && <span> La membresía opcional, Estudiante Plus, cuesta $7.990 CLP mensuales.</span>}
            </div>
          )}
          {/* El aviso permanece al vencer: explica el cambio y permite contratar en web. */}
          {session && !accesoPlusAbierto() && (
            <AvisoTrial profile={profile} onPlanes={!isNative ? (origen = 'trial_home') => abrirPlanes(origen) : undefined} onPagoConfirmado={refetchPerfil} />
          )}
          <StepHome
            onSelectMode={(m, source = "home") => {
              if (m === "admin")     { setAppState("admin"); return; }
              startMode(m, source);
            }}
            onDemo={startDemo}
            onPrivacidad={() => setAppState("privacidad")}
            onTerminos={() => setAppState("terminos")}
            onQueEsMiPAE={() => setAppState("que-es-mipae")}
            onContacto={() => setAppState("contacto")}
            onInstituciones={isNative ? undefined : () => setAppState("instituciones")}
            onPreparaPractica={() => setAppState("prepara-practica")}
            onPreparaInternado={() => setAppState("prepara-internado")}
            onAbrirRevisa={() => openRevisa('home')}
            onAbrirEscalas={() => setAppState("escalas")}
            onAbrirMedicamentos={() => abrirFichas()}
            onAbrirGes={() => abrirGes()}
            onAbrirReferencia={() => abrirReferencia()}
            onAbrirRecepcion={() => abrirReferencia("recepcion")}
            onAbrirEstudio={() => abrirReferencia("estudio")}
            onAbrirValoresLab={() => abrirReferencia("laboratorio")}
            onAbrirAislamiento={() => abrirReferencia("aislamiento")}
            onAbrirModelos={() => abrirReferencia("modelos")}
            onAbrirProcedimientos={() => abrirReferencia("procedimientos")}
            onAbrirReto={() => setAppState("reto")}
            onAbrirBibliografia={() => setAppState("bibliografia")}
            onPreparaTurno={() => setAppState("prepara-turno")}
            onRegistroTurno={() => abrirRegistroTurno("home")}
            camaActiva={camaActiva}
            onRegistrarEnCama={(cama) => abrirPacienteTurno(cama)}
            onAbrirBitacora={() => setAppState("bitacora")}
            onAbrirRespira={(ctx) => abrirRespira(ctx || "pre_turno")}
            onAbrirBienestar={BIENESTAR_MODULO_ENABLED ? abrirBienestar : undefined}
            onLogin={handleLogin}
            onLoginApple={handleLoginApple}
            membresiaPendiente={session === null && !isNative ? nombreIntencion(intencionDesdeUrl(window.location.search)) : null}
            onMiProgreso={() => setAppState("mi-progreso")}
            onMisPaes={veTusPaes ? () => setAppState("mis-paes") : undefined}
            recientes={recientes}
            onAbrirReciente={(it) => {
              if (it.tipo === "ges") abrirGes(it.slug);
              else if (it.tipo === "escala") abrirEscala(it.slug);
              else if (it.tipo === "lab") abrirLaboratorio(it.slug);
              else if (it.tipo === "referencia") abrirReferencia(it.slug);
              else abrirFichas(it.slug);
            }}
            onIrPerfil={() => setAppState("perfil")}
            userEmail={userEmail}
            userName={userName}
            profile={perfilMundo}
            userId={session?.user?.id}
            rotacion={rotacion}
            onConfigCalendario={() => setAppState("calendario-config")}
            onVerCalendario={(dia = null) => {
              setCalendarioDiaInicial(dia);
              // Sin rotación el calendario no tiene nada que mostrar: se va a
              // cargarla, igual que el resto de las entradas al calendario.
              setAppState(rotacion ? "calendario" : "calendario-config");
            }}
            homeNudges={session ? nudgesDelPerfil(nudges.getActiveForScope('home'), perfilMundo).filter(n => n.mode === 'card') : []}
            onNudgeAction={(nudge) => nudges.executeAction(nudge, (target) => setAppState(target))}
            onNudgeDismiss={nudges.dismiss}
            onAbrirCompanero={() => { setCompaneroPrefill(""); setCompaneroAbierto(true); setBenitoNovedad(false); }}
            onCompaneroPrompt={(texto) => { setCompaneroPrefill(texto); setCompaneroAbierto(true); setBenitoNovedad(false); }}
            deVisita={deVisita}
            conMomentoEstudiante={conMomentoEstudiante}
            borrador={borradorEnInicio ? (borradorPendiente?.data || null) : null}
            onContinuarBorrador={continuarBorrador}
            onDescartarBorrador={descartarBorrador}
            onLoNuevo={() => abrirLoNuevo("aviso")}
            onTrialIniciado={() => { refetchPerfil(); }}
          />
        </>
      )}

      {appState === "calendario-config" && session && profile?.perfil_completado && (
        <CalendarioConfig
          userId={session.user.id}
          rotacionInicial={rotacion}
          onGuardado={(nuevaRotacion) => {
            setRotacion(nuevaRotacion);
            setAppState("calendario");
          }}
          onVolver={() => setAppState(rotacion ? "calendario" : "home")}
        />
      )}

      {appState === "calendario" && session && profile?.perfil_completado && (
        <CalendarioVista
          rotacion={rotacion}
          userId={session.user.id}
          onEditarConfig={() => setAppState("calendario-config")}
          diaInicial={calendarioDiaInicial}
        />
      )}

      {appState === "escalas" && (
        <Escalas
          isMipaePlus={enciclopediaCompleta}
          onRequierePlus={() => abrirPlanes('escalas')}
          userId={session?.user?.id}
          onVolver={irAtras}
          escalaInicial={escalaInicial}
          onRegisterBack={(fn) => { escalasBackRef.current = fn; }}
          onAbrirEstudio={() => abrirReferencia("estudio:escalas")}
        />
      )}

      {appState === "prepara-turno" && (
        (session && profile?.perfil_completado)
          ? <div className="bg-paper min-h-screen text-ink">
              <PreparaTurno
                rotacion={rotacion}
                onIrBitacora={() => setAppState("bitacora")}
                onVolver={irAtras}
                onPrimerTurnoPreparado={nudges.markPrimerTurnoPreparado}
              />
            </div>
          : <div className="bg-paper min-h-screen text-ink">
              <PreparaTurnoGuia
                onVolver={irAtras}
                onIrBitacora={undefined}
                onPrimerTurnoPreparado={undefined}
              />
            </div>
      )}

      {appState === "entrega-turno" && session && profile?.perfil_completado && (
        <EntregaTurno
          profile={profile}
          userId={session.user.id}
          onVolver={irAtras}
        />
      )}

      {appState === "evolucion-sistema" && session && profile?.perfil_completado && !turnoEsCapaTens && (
        <EvolucionSistema
          onVolver={irAtras}
          userId={session.user.id}
        />
      )}

      {appState === "en-turno-estudiante" && session && profile?.perfil_completado && (
        <EnTurnoEstudiante
          etapa={perfilMundo?.etapa_internado || null}
          onProbar={probarEnTurnoEstudiante}
          onVolverInicio={goHome}
          onIrPerfil={() => setAppState("perfil")}
        />
      )}

      {appState === "registro-turno" && session && profile?.perfil_completado && turnoEsCapaTens && (
        <HomeTens userId={session.user.id} nombre={(profile?.nombre || "").split(" ")[0]} profile={profile} rotacion={rotacion} onVerBibliografia={abrirBibliografia} />
      )}
      {appState === "registro-turno" && session && profile?.perfil_completado && !turnoEsCapaTens && (
        <RegistroTurno
          userId={session.user.id}
          profile={profile}
          rotacion={rotacion}
          onVolver={irAtras}
          onConsultar={consultarRevisaPlus}
          onConfigCalendario={() => setAppState("calendario-config")}
          onCrearPaeDesdeTurno={crearPaeDesdeTurno}
          onAbrirEscalas={(id) => { setEscalaInicial(id || null); setAppState("escalas"); }}
          onAbrirGes={(slug) => abrirGes(slug)}
          onAbrirFicha={(slug) => abrirFichas(slug)}
          onIrBitacora={() => setAppState("bitacora")}
          onAbrirEntregaTurno={() => abrirEntregaTurno("mi_turno")}
          onAbrirEvolucionSistema={() => abrirEvolucionSistema("mi_turno")}
          onAbrirCalendario={() => setAppState(rotacion ? "calendario" : "calendario-config")}
          onRegisterBack={(fn) => { registroBackRef.current = fn; }}
          camaInicial={turnoCamaInicial}
          practicaAlEntrar={turnoPracticaAlEntrar}
          onPracticaAlEntrarUsada={() => setTurnoPracticaAlEntrar(false)}
          carril={carrilTour}
          onCamaInicialUsada={() => setTurnoCamaInicial(null)}
          onCamaFoco={setTurnoCamaFoco}
          onAbrirCompanero={companeroDisponible ? (texto) => { setCompaneroPrefill(texto || ""); setCompaneroAbierto(true); setBenitoNovedad(false); } : undefined}
        />
      )}

      {appState === "bitacora" && session && profile?.perfil_completado && (
        <Bitacora
          userId={session.user.id}
          profile={profile}
          rotacion={rotacion}
          onVolver={irAtras}
          onAbrirRespira={(ctx) => abrirRespira(ctx || "post_turno")}
        />
      )}

      {appState === "reto" && session && (
        <RetoDelDia
          userId={session.user.id}
          onVolver={irAtras}
          onPreguntarBenito={companeroDisponible ? (texto) => { setCompaneroPrefill(texto || ""); setCompaneroAbierto(true); setBenitoNovedad(false); } : undefined}
        />
      )}

      {appState === "respira" && (
        <Respira
          contexto={respiraContexto}
          tecnicaInicial={respiraTecnica}
          duracionInicial={respiraDuracion}
          dentroDeBienestar={BIENESTAR_MODULO_ENABLED && respiraDesdeBienestar}
          puedePreguntarBenito={companeroDisponible}
          onVolver={irAtras}
          onSesionChange={setRespiraEnSesion}
          onIrBitacora={session && profile?.perfil_completado ? () => setAppState("bitacora") : undefined}
        />
      )}

      {/* Home del módulo Bienestar. Abierto sin sesión como Respira (la
          Bitácora de adentro sí pide entrar). */}
      {BIENESTAR_MODULO_ENABLED && appState === "bienestar" && (
        <BienestarHome
          userId={session?.user?.id || null}
          session={session}
          profile={profile}
          rotacion={rotacion}
          turnoHoy={turnoHoyBienestar}
          overrides={overridesBienestar}
          onAbrirRespira={(tecnicaId, ctx, duracion) => abrirRespira(ctx || "generico", tecnicaId, duracion)}
          onAbrirPractica={abrirPractica}
          onAbrirBitacora={() => setAppState("bitacora")}
          onLogin={handleLogin}
        />
      )}

      {BIENESTAR_MODULO_ENABLED && appState === "practica" && practicaId && (
        <PracticaGuiada
          practicaId={practicaId}
          userId={session?.user?.id || null}
          onVolver={irAtras}
          onIrBitacora={session && profile?.perfil_completado ? () => setAppState("bitacora") : null}
          origen={practicaOrigen}
        />
      )}

      {appState === "fichas" && <Fichas fichaInicial={fichaInicial} onRegisterBack={(fn) => { fichasBackRef.current = fn; }} isMipaePlus={enciclopediaCompleta} onRequierePlus={() => abrirPlanes('farmacos')} />}

      {appState === "ges" && <Ges fichaInicial={gesInicial} onRegisterBack={(fn) => { gesBackRef.current = fn; }} onAbrirMedicamento={(slug) => abrirFichas(slug)} isMipaePlus={CONTENIDO_ESTUDIO_ABIERTO} onRequierePlus={requierePlusNoop} onAbrirEstudio={() => abrirReferencia("estudio:ges")} />}
      {appState === "referencia" && <ReferenciaRapida key={referenciaClave} onAbrirBibliografia={abrirBibliografiaDesdeEnciclopedia} seccionInicial={referenciaInicial} onSeccionAbierta={registrarRefReciente} onRegisterBack={(fn) => { referenciaBackRef.current = fn; }} isMipaePlus={enciclopediaCompleta} onRequierePlus={() => abrirPlanes('laboratorio')} onAbrirEscalas={() => { setEscalaInicial(null); setAppState("escalas"); }} onAbrirMedicamentos={() => abrirFichas()} onAbrirGes={() => abrirGes()} onAbrirInfusiones={() => abrirLaboratorio()} onAbrirRevisa={() => openRevisa('enciclopedia')} userId={session?.user?.id || null} profile={perfilMundo} onVerPlanes={() => abrirPlanes('procedimientos')} onPreguntarBenito={companeroDisponible ? (texto) => { setCompaneroPrefill(texto || ""); setCompaneroAbierto(true); setBenitoNovedad(false); } : undefined} onAbrirPae={!paeEnEsteMundo ? undefined : (modeloId) => {
        // modelo_a_pae sale recién cuando el PAE arrancó (B20): antes se
        // emitía en la ficha aunque terminara en el login o en el muro.
        const arranco = startMode('rapido', 'enciclopedia_modelo', { modelo: modeloId });
        if (arranco && esModeloValoracion(modeloId)) trackEvent('modelo_a_pae', { modulo: 'enciclopedia', payload: { modelo: modeloId } });
      }} />}

      {appState === "laboratorio" && (
        <LaboratorioInteractivo
          initialSlug={labInicial}
          onVolver={() => {
            if (typeof window !== "undefined" && window.location.hash) {
              window.history.replaceState(null, "", window.location.pathname);
            }
            irAtras();
          }}
        />
      )}

      {appState === "onboarding-preview" && ['admin','owner'].includes(profile?.role) && (
        <div className="z-[60]" style={{ position: "fixed", inset: 0, background: "#F6F5EE" }}>
          <OnboardingVideo loop carril={null} origen="preview" />
        </div>
      )}

      {/* POC MiPAE Voice: experimento aislado, solo admin. */}
      {appState === "labs-voz" && session && ['admin','owner'].includes(profile?.role) && (
        <VoiceDocLab onVolver={() => setAppState("home")} />
      )}

      {/* Panel de gestión: página propia. Admin y `ve_jefatura`; la
          mitad que lee la RPC agregada de toda la plataforma sigue siendo
          solo admin (esAdmin). */}
      {appState === "jefatura" && session && veJefatura(profile) && (
        <TableroJefatura onVolver={() => setAppState("home")} esAdmin={['admin','owner'].includes(profile?.role)} />
      )}

      {/* Diálisis: pantalla propia del team de terapias extracorpóreas. No
          guarda nada: compone sus salidas y suelta. */}
      {appState === "dialisis" && session && veDialisis(perfilMundo) && (
        <Dialisis onVolver={() => setAppState("home")} toast={toast} />
      )}

      {appState === "privacidad" && <LegalPages initialTab="privacidad" onVolver={irAtras} />}
      {appState === "terminos"   && <LegalPages initialTab="terminos"   onVolver={irAtras} />}

      {appState === "admin" && ['admin','owner'].includes(profile?.role) && (
        <AdminMetrics onVolver={irAtras} profile={profile} />
      )}

      {appState === "mi-progreso" && session && profile?.perfil_completado && (
        <MiProgreso
          userId={session.user.id}
          profile={profile}
          onStartPAE={paeEnEsteMundo ? () => startMode("rapido", "mi_progreso") : undefined}
          onIrBitacora={() => setAppState("bitacora")}
        />
      )}

      {appState === "bibliografia" && (
        <Estudio
          key={estudioTab || "inicio"}
          tabInicial={estudioTab}
          // Atrás de verdad (A35): reset() borraba de memoria el PAE en curso
          // y mandaba al Inicio aunque se hubiera llegado desde una ficha.
          onVolver={irAtras}
          isMipaePlus={CONTENIDO_ESTUDIO_ABIERTO}
          onRequierePlus={requierePlusNoop}
        />
      )}

      {appState === "prepara-practica" && (
        <div className="bg-paper min-h-screen text-ink">
          <PreparaPractica
            onVolver={goHome}
            onAbrirRevisa={() => openRevisa('prepara_practica')}
            onAbrirRespira={() => abrirRespira("generico")}
            onAbrirEscalas={() => { setEscalaInicial(null); setAppState("escalas"); }}
            onAbrirMedicamentos={() => abrirFichas()}
            onAbrirPAERapido={() => startMode("rapido", "prepara_practica")}
            onAbrirBitacora={() => irAModulo('bitacora', () => setAppState("bitacora"))}
            onRegisterBack={(fn) => { prepBackRef.current = fn; }}
          />
        </div>
      )}

      {appState === "prepara-internado" && (
        <div className="bg-paper min-h-screen text-ink">
          <PreparaInternado
            onVolver={goHome}
            onAbrirRevisa={() => openRevisa('prepara_internado')}
            // Antes mandaba al Home a resaltar la tarjeta "Prepara tu turno" del
            // Home viejo; esa tarjeta no existe desde julio, así que el enlace
            // dejaba a la persona en el Inicio sin explicación. Va directo (2026-09-14).
            onIrPreparaTurno={() => setAppState("prepara-turno")}
            onAbrirRespira={() => abrirRespira("generico")}
            onAbrirEscalas={() => { setEscalaInicial(null); setAppState("escalas"); }}
            onAbrirMedicamentos={() => abrirFichas()}
            onAbrirPAERapido={() => startMode("rapido", "prepara_internado")}
            onAbrirBitacora={() => irAModulo('bitacora', () => setAppState("bitacora"))}
            onRegisterBack={(fn) => { prepBackRef.current = fn; }}
          />
        </div>
      )}

      {appState === "prepara-examen" && (
        <div className="bg-paper min-h-screen text-ink">
          <PreparaExamen
            etapa={profile?.etapa_internado || null}
            onAbrirPAERapido={() => startMode("rapido", "prepara_examen")}
            onAbrirPAEDetallado={() => startMode("detallado", "prepara_examen")}
            onAbrirRevisa={() => openRevisa('prepara_examen')}
            onAbrirEscalas={() => { setEscalaInicial(null); setAppState("escalas"); }}
            onAbrirMedicamentos={() => abrirFichas()}
            onAbrirBitacora={() => setAppState("bitacora")}
            onAbrirRespira={() => abrirRespira("estudio")}
          />
        </div>
      )}

      {appState === "que-es-mipae" && (
        <div className="bg-paper min-h-screen text-ink">
          <QueEsMiPAE
            onVolver={irAtras}
            sesion={!!session}
            // "Crear mi cuenta" lleva a la tarjeta de acceso de la portada
            // (Apple y Google juntos, guideline 4.8): nunca un Google suelto.
            onCrearCuenta={irAlAcceso}
            onPrivacidad={() => setAppState("privacidad")}
            onTerminos={() => setAppState("terminos")}
            onContacto={() => setAppState("contacto")}
            onDemo={startDemo}
            onAbrirEscalas={() => setAppState("escalas")}
            onAbrirMedicamentos={() => abrirFichas()}
            onAbrirReferencia={() => abrirReferencia()}
            onAbrirEstudio={() => abrirReferencia("estudio")}
          />
        </div>
      )}

      {/* Contacto y Para instituciones (2026-10-30): públicas, con o sin
          sesión. Para instituciones solo existe en la web. */}
      {appState === "contacto" && (
        <Contacto
          sesion={!!session}
          onCrearCuenta={irAlAcceso}
          onInstituciones={isNative ? undefined : () => setAppState("instituciones")}
        />
      )}
      {appState === "instituciones" && !isNative && (
        <ParaInstituciones
          sesion={!!session}
          onCrearCuenta={irAlAcceso}
          onContacto={() => setAppState("contacto")}
        />
      )}

      {appState === "rapido" && pendingDisclaimer === 'pae_rapido' && (
        <DisclaimerPAE
          modulo="pae_rapido"
          userId={session.user.id}
          onAceptado={refetchPerfil}
          onCancelar={() => setAppState("home")}
          onPrivacidad={() => setAppState("privacidad")}
          onTerminos={() => setAppState("terminos")}
        />
      )}

      {appState === "rapido" && !pendingDisclaimer && (
        <div className="min-h-screen" style={{ background: 'var(--module-pae-rapido-bg)', '--color-accent': 'var(--module-pae-rapido)', '--color-accent-hover': 'var(--module-pae-rapido-hover)', '--color-accent-bg': 'var(--module-pae-rapido-accent-bg)', '--color-accent-border': 'var(--module-pae-rapido-accent-border)', '--accent-rgb': 'var(--module-pae-rapido-rgb)' }}>
          <div className="max-w-[700px] mx-auto px-5 py-8 pb-16">
            {step === 1 && (
              <>
                {/* La card/enlace de Respira lo dibuja RapidoStep1 según el
                    arranque efectivo (card arriba en 'hoy', enlace al pie en
                    B): el arranque puede cambiar dentro del paso por la
                    preferencia del dispositivo, sin pasar por este router. */}
                <RapidoStep1
                  data={formData}
                  update={update}
                  onNext={() => { if (formData.rapido?.modelo === 'libre') setStep(2); else setStep(3); }}
                  origenTurno={origenTurno}
                  onRespira={() => abrirRespira("pre_pae")}
                  // Primer uso guiado del carril estudiante con superficie PAE
                  // (onboardings por rol, 2026-09-10): una card descartable,
                  // jamás una redirección. Los demás carriles no la ven.
                  mostrarPrimerUso={carrilTour === 'estudiante' && superficieTour === 'pae'}
                  onDemo={startDemo}
                  // "¿Cuál elijo?" del modelo de enfermería: prefill a Benito,
                  // cuyo panel se abre encima sin perder el PAE en curso.
                  onPreguntarBenito={companeroDisponible ? (texto) => { setCompaneroPrefill(texto || ""); setCompaneroAbierto(true); setBenitoNovedad(false); } : undefined}
                />
              </>
            )}
            {step === 2 && formData.rapido?.modelo === 'libre' && (
              <RapidoStep2Libre data={formData} update={update} onNext={() => setStep(3)} onBack={() => setStep(1)} />
            )}
            {step === 3 && (
              <RapidoStep3
                data={formData}
                update={update}
                updatePlan={updateRapidoPlan}
                onNext={() => { setStep(4); if (esNuevoPAE) registrarMetrica(session?.user?.id, 'rapido', 'completed'); }}
                onBack={() => { if (formData.rapido?.modelo === 'libre') setStep(2); else setStep(1); }}
                onAnamnesisChange={setAnamnesisIA}
                contexto="pae_rapido"
              />
            )}
            {step === 4 && (
              <RapidoResumen
                data={formData}
                onReset={reset}
                userId={session?.user?.id}
                esNuevo={esNuevoPAE}
                paeIdInicial={paeIdActual}
                onPaeIdReady={setPaeIdActual}
                anamnesisIA={anamnesisIA}
                registroGuardado={registroRapidoRef}
                onPAESaved={(esNuevoGuardado = false) => {
                  setPaeGuardadoFinal(true);
                  // Solo el guardado REAL emite el evento y cuenta para la
                  // micro encuesta: la revisita desde "Mis PAE" llega en
                  // false (bug de datos del 2026-08-29, embudo inflado).
                  if (esNuevoGuardado) {
                    trackEvent('pae_guardado', { modulo: 'pae_rapido', paso: 'resumen' });
                    contarPaeGuardado('pae_rapido');
                  }
                  if (sessionIdRef.current) {
                    try { localStorage.removeItem(`mipae:draft:${sessionIdRef.current}`); } catch { /* ignore */ }
                  }
                }}
                pauta={pautaProps}
                onRepasarConBenito={companeroDisponible ? () => {
                  // Prefill (no auto-envío): Benito usa su tool mis_paes para
                  // traer el PAE recién guardado y repasarlo conversando.
                  setCompaneroPrefill('Acabo de guardar un PAE. Mira mis PAE recientes y hazme 3 preguntas cortas para fijar lo que aprendí.');
                  setCompaneroAbierto(true);
                  setBenitoNovedad(false);
                } : undefined}
              />
            )}
            {step === 4 && encuestaRamoModulo === 'pae_rapido' && session?.user?.id && (
              <EncuestaRamo
                userId={session.user.id}
                modulo="pae_rapido"
                onCerrar={() => setEncuestaRamoModulo(null)}
                className="mt-6"
              />
            )}
          </div>
          <FooterRecordatorio />
        </div>
      )}

      {appState === "demo" && (
        <DemoPublica
          etapa={etapaDemo}
          onVolver={irAtras}
          onCrear={() => {
            // En iPhone, a la tarjeta de acceso (Apple al lado de Google).
            if (!session) { if (APPLE_LOGIN_DISPONIBLE) irAlAcceso(); else handleLogin(); return; }
            if (etapaDemo === "enfermero" || etapaDemo === "tens" || etapaDemo === "interno") abrirRegistroTurno("home");
            else startMode("rapido", "demo");
          }}
        />
      )}

      {appState === "detallado" && pendingDisclaimer === 'pae_detallado' && (
        <DisclaimerPAE
          modulo="pae_detallado"
          userId={session.user.id}
          onAceptado={refetchPerfil}
          onCancelar={() => setAppState("home")}
          onPrivacidad={() => setAppState("privacidad")}
          onTerminos={() => setAppState("terminos")}
        />
      )}

      {appState === "detallado" && !pendingDisclaimer && (
        <PaeDetallado
          step={step}
          setStep={setStep}
          formData={formData}
          update={update}
          setSection={setSection}
          selected={selected}
          setSelected={setSelected}
          session={session}
          esNuevoPAE={esNuevoPAE}
          paeIdInicial={paeIdActual}
          onPaeIdReady={setPaeIdActual}
          onReset={reset}
          setUnit={setUnit}
          onAbrirRespira={() => abrirRespira("pre_pae")}
          origenTurno={origenTurno}
          onPAESaved={(esNuevoGuardado) => {
            if (!esNuevoGuardado) return;
            contarPaeGuardado('pae_detallado');
            // Ya está en la cuenta: el borrador local sobra y cerrar no avisa.
            setPaeGuardadoFinal(true);
            if (sessionIdRef.current) {
              try { localStorage.removeItem(`mipae:draft:${sessionIdRef.current}`); } catch { /* ignore */ }
            }
          }}
          atrasRef={detalladoAtrasRef}
          pauta={pautaProps}
          onPreguntarBenito={companeroDisponible ? (texto) => { setCompaneroPrefill(texto || ""); setCompaneroAbierto(true); setBenitoNovedad(false); } : undefined}
          pieResumen={encuestaRamoModulo === 'pae_detallado' && session?.user?.id ? (
            <EncuestaRamo
              userId={session.user.id}
              modulo="pae_detallado"
              onCerrar={() => setEncuestaRamoModulo(null)}
              className="mt-6"
            />
          ) : null}
        />
      )}

      </Suspense>

      {/* Compañero global: agente flotante en toda la app (loop + herramientas).
          Va en su PROPIO Suspense, fuera del de las rutas: así navegar a un
          módulo lazy no lo desmonta ni aborta su loop a mitad de camino. */}
      {companeroDisponible && (
        <Suspense fallback={null}>
          <CompaneroGlobal
            userId={session.user.id}
            userName={userName}
            // Chips, lo que ofrece y su cuota siguen al mundo; quién es la
            // persona sale de su casa (tres mundos).
            profile={perfilMundo}
            perfilCasa={profile}
            camaFoco={turnoCamaFoco}
            rotacion={rotacion}
            onEstadoBenito={setBenitoEstado}
            onNovedad={setBenitoNovedad}
            abierto={companeroAbierto}
            // Cerrar CONSUME el prefill: sin esto, el chip de hace horas se
            // re-inyectaba en cada apertura desde la pestaña (barrido 2026-08-02).
            onAbiertoChange={(v) => { setCompaneroAbierto(v); if (!v) setCompaneroPrefill(""); }}
            ocultarFab
            textoInicial={companeroPrefill}
            acciones={{
              irADestino,
              abrirEscala,
              abrirFicha: abrirFichas,
              abrirGes,
              abrirReferencia,
              abrirPaciente: abrirPacienteTurno,
              iniciarPae,
              puedeIniciarPae,
              // La evolución por sistema valora: la capa TENS no llega a ella.
              // Y el PAE vive en MiPAE Estudiante.
              // Mi progreso cuenta PAEs y formación: donde no hay PAE tampoco
              // se abre (salió del inicio, del buscador y de Mi perfil).
              puedeAbrirDestino: (destino) => !(destino === "evolucion" && turnoEsCapaTens)
                && !((destino === "pae_rapido" || destino === "pae_detallado" || destino === "mi_progreso") && !paeEnEsteMundo),
              abrirPlanes: () => abrirPlanes('benito_tope'),
              // Paywall desde el panel (PDF de Benito sin acceso a la extendida).
              abrirPaywall: (feature) => setPremiumPaywall(feature),
            }}
          />
        </Suspense>
      )}

      {premiumPaywall && (
        <PremiumPaywall
          feature={premiumPaywall}
          // El límite del PAE de quien viene de una casa sin PAE se dice con
          // la casa (perfilCupoPae): su hoja de siempre, sin la venta del
          // estudiante.
          profile={FEATURES_PAE.includes(premiumPaywall) ? perfilCupoPae : perfilMundo}
          // Lo que se cobra lo decide el rol real (api/flow-checkout.js): de
          // visita la hoja no vende y lleva a Planes, que usa este perfil.
          perfilReal={profile}
          // De visita no se gasta la prueba de la cuenta (no destrabaría nada
          // fuera de casa), y a quien tiene la extendida en casa se le dice
          // dónde no tiene límite en vez de venderle lo que ya tiene.
          trialDisponible={puedeIniciarTrial && !deVisita}
          // "Vuelve a tu casa" no sirve para el PAE si la casa no lo tiene.
          fueraDeCasa={deVisita && esMipaePlus(profile) && !(cupoPaeDeCasa && FEATURES_PAE.includes(premiumPaywall)) ? { casa: nombreMundo(casaDe(profile)), onVolver: () => cambiarMundo(casaDe(profile)) } : null}
          onMetric={logFreemiumMetric}
          onClose={() => setPremiumPaywall(null)}
          onVerPlanes={() => { const f = premiumPaywall; setPremiumPaywall(null); abrirPlanes(`limite_${f}`); }}
          onCompletarPerfil={() => { setPremiumPaywall(null); setAppState("perfil"); }}
          onTrialIniciado={async () => { await refetchPerfil(); setPremiumPaywall(null); }}
        />
      )}

      {/* ── PWA: indicador offline ────────────────────────────────────────────── */}
      {isOffline && (
        <div className="fixed top-14 inset-x-0 z-40 flex justify-center pointer-events-none">
          <div className="flex items-center gap-1.5 bg-[#f97316] text-white text-11px font-semibold px-3 py-1 rounded-b-xl shadow-md font-sans">
            <WifiOff size={12} />
            Sin conexión
          </div>
        </div>
      )}

      {/* ── PWA: banner de actualización (prioridad sobre install) ────────────── */}
      {swRegistration && (
        <div className="fixed bottom-4 inset-x-4 z-[55] max-w-sm mx-auto rounded-2xl bg-[var(--brand)] text-white shadow-2xl px-4 py-3 flex items-center gap-3">
          <RefreshCw size={16} className="flex-shrink-0 text-white/70" />
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold font-sans">Nueva versión disponible</div>
            <div className="text-11px text-white/60 font-sans">Actualiza para ver los cambios</div>
          </div>
          <Button
            variant="secondary"
            size="sm"
            onClick={handleSWUpdate}
            className="flex-shrink-0 whitespace-nowrap"
          >
            Actualizar
          </Button>
        </div>
      )}

      {/* ── PWA: prompt de instalación (solo si no hay update pendiente) ─────── */}
      {/* Nunca sobre MiPAE en turno (pedido del fundador 2026-09-28): ahí la
          barra de captura vive pegada al fondo y este banner la tapaba junto
          con el borrador. Vuelve a ofrecerse en cualquier otra pantalla. */}
      {!swRegistration && installPrompt && appState !== "registro-turno" && (
        <div className="fixed bottom-4 inset-x-4 z-[54] max-w-sm mx-auto rounded-2xl bg-paper border border-edge shadow-2xl px-4 py-3 flex items-center gap-3">
          <div className="w-9 h-9 rounded-xl bg-[var(--accent-bg)] border border-[var(--accent-border)] flex items-center justify-center flex-shrink-0">
            <Download size={16} className="text-accent" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="text-sm font-semibold text-ink font-sans">Instalar MiPAE</div>
            <div className="text-11px text-ink-muted font-sans">Acceso rápido desde tu pantalla</div>
          </div>
          <div className="flex items-center gap-1.5 flex-shrink-0">
            <Button size="sm" onClick={handleInstall} className="whitespace-nowrap">
              Instalar
            </Button>
            <button
              onClick={handleDismissInstall}
              aria-label="Cerrar"
              className="text-ink-muted hover:text-ink transition-colors p-1"
            >
              <X size={14} />
            </button>
          </div>
        </div>
      )}

      {/* ── PWA: instrucciones Safari/iOS — bottom sheet ──────────────────────── */}
      {/* Como "Instalar MiPAE": nunca encima del registro del turno (propuesta
          de la interfaz por experiencia, 2026-10-16, avisos sin interrumpir). */}
      {!swRegistration && !installPrompt && showSafariInstall && appState !== "registro-turno" && (
        <div className="fixed inset-0 z-[60] flex items-end">
          {/* Backdrop */}
          <div
            className="absolute inset-0 bg-black/30"
            onClick={handleDismissInstall}
          />

          {/* Sheet */}
          <div className="relative w-full bg-paper rounded-t-[24px] shadow-2xl"
               style={{ paddingBottom: 'max(env(safe-area-inset-bottom, 0px), 16px)' }}>

            {/* Handle */}
            <div className="flex justify-center pt-3 pb-1">
              <div className="w-10 h-1 rounded-full bg-edge" />
            </div>

            <div className="px-6 pt-3 pb-4">
              {/* Cabecera */}
              <div className="flex items-center gap-3.5 mb-5">
                <div className="w-14 h-14 rounded-[16px] bg-[var(--brand)] flex items-center justify-center flex-shrink-0 shadow-sm">
                  <span className="font-serif text-white text-22px font-bold leading-none">M</span>
                </div>
                <div>
                  <h2 className="font-serif text-19px font-bold text-ink leading-snug">
                    Guarda MiPAE en tu iPhone
                  </h2>
                  <p className="text-13px text-ink-subtle font-sans mt-0.5">
                    Acceso directo, sin abrir el navegador
                  </p>
                </div>
              </div>

              {/* Pasos */}
              <div className="flex flex-col gap-4 mb-5">
                {[
                  {
                    n: 1,
                    content: (
                      <>
                        Toca el ícono{' '}
                        <ArrowUpFromLine size={13} className="inline align-middle text-accent mx-0.5" strokeWidth={2.5} />
                        {' '}<strong className="text-ink">Compartir</strong>{' '}
                        en la barra inferior de Safari
                      </>
                    ),
                  },
                  {
                    n: 2,
                    content: (
                      <>
                        Desliza hacia abajo y toca{' '}
                        <strong className="text-ink">"Agregar a pantalla de inicio"</strong>
                        {' '}<Plus size={13} className="inline align-middle text-accent mx-0.5" strokeWidth={2.5} />
                      </>
                    ),
                  },
                  {
                    n: 3,
                    content: (
                      <>
                        Toca{' '}
                        <strong className="text-ink">"Agregar"</strong>
                        {' '}<Check size={13} className="inline align-middle text-accent mx-0.5" strokeWidth={2.5} />
                        {' '}en la esquina superior derecha
                      </>
                    ),
                  },
                ].map(({ n, content }) => (
                  <div key={n} className="flex items-start gap-3.5">
                    <div className="w-6 h-6 rounded-full bg-accent text-white text-11px font-bold font-sans flex items-center justify-center flex-shrink-0 mt-0.5">
                      {n}
                    </div>
                    <p className="text-14px font-sans text-ink-subtle leading-snug flex-1">
                      {content}
                    </p>
                  </div>
                ))}
              </div>

              {/* Pista visual */}
              <div className="flex items-center justify-center gap-2 mb-4 py-2.5 px-4 rounded-[10px] bg-surface border border-edge">
                <ArrowUpFromLine size={14} className="text-accent flex-shrink-0" strokeWidth={2.5} />
                <p className="text-12px font-sans text-ink-muted leading-snug">
                  El botón Compartir está en la barra inferior de Safari
                </p>
              </div>

              <button
                onClick={handleDismissInstall}
                className="w-full py-2.5 text-13px text-ink-subtle font-sans hover:text-ink transition-colors"
              >
                Ahora no
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Popover Apariencia (2026-09-10): cuelga del sol/luna del header y
          reusa TemaSelector en modo compacto, así el catálogo y los handlers
          son los mismos de Ajustes. Toda la persistencia vive en ThemeContext. */}
      {/* Novedades a voluntad: el mismo detalle de la card, completo, sin
          tocar el reconocimiento (abrirlo no marca nada como visto). */}
      <Modal
        open={novedadesOpen}
        onClose={() => setNovedadesOpen(false)}
        variant="alert"
        title="Novedades de MiPAE"
        confirmLabel="Cerrar"
        onConfirm={() => setNovedadesOpen(false)}
      >
        <div className="max-h-[60vh] overflow-y-auto pr-1">
          {/* La pantalla de la invitación del 25 sigue a mano aquí después de
              cerrar el aviso del inicio. Sin venta: en la app instalada la
              pantalla no muestra precio ni suscripción. */}
          {session && profile?.perfil_completado && (
            <button
              type="button"
              onClick={() => { setNovedadesOpen(false); abrirLoNuevo("menu"); }}
              className="mb-3 inline-flex min-h-[44px] items-center text-small font-semibold text-accent font-sans underline"
            >
              Lo nuevo de MiPAE en tu experiencia
            </button>
          )}
          {/* La vuelta de la hoja del 25 habla de una prueba: solo a quien la puede
              activar o ya la está usando (mismo criterio que la hoja). */}
          <NovedadesDetalle novedades={novedadesVigentes().filter((n) => n.id !== "lo_nuevo_25_prueba" || ["disponible", "en_curso"].includes(pruebaPara(profile).estado))} />
        </div>
      </Modal>
      {aparienciaOpen && (
        <div className="no-print fixed inset-0 z-40" onClick={() => setAparienciaOpen(false)} aria-hidden="true">
          <div
            className={`absolute right-3 top-16 w-[min(22rem,calc(100vw-1.5rem))]${SHELL_ESCRITORIO_ENABLED ? " lg:right-[max(0.75rem,calc((100vw-1240px)/2+0.75rem))]" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div role="dialog" aria-label="Apariencia" className="bg-paper border border-edge rounded-tk-md shadow-tk-modal overflow-hidden max-h-[calc(100dvh-5rem)] overflow-y-auto">
              <div className="flex items-center justify-between px-4 pt-3 pb-2">
                <span className="text-11px font-semibold uppercase tracking-[0.08em] text-ink-subtle font-sans">Apariencia</span>
                <IconButton
                  variant="muted"
                  size="sm"
                  icon={<X size={16} strokeWidth={1.6} />}
                  ariaLabel="Cerrar apariencia"
                  onClick={() => setAparienciaOpen(false)}
                />
              </div>
              <div className="px-4 pb-3">
                <TemaSelector compacto />
              </div>
              {session && profile?.perfil_completado && (
                <>
                  <div className="h-px bg-edge" />
                  <button
                    type="button"
                    onClick={() => { setAparienciaOpen(false); setAppState("ajustes"); }}
                    className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-surface transition-colors"
                  >
                    <span className="text-small font-semibold text-ink font-sans">Todos los ajustes</span>
                    <ChevronRight size={16} strokeWidth={1.6} className="text-ink-muted" aria-hidden="true" />
                  </button>
                </>
              )}
            </div>
          </div>
        </div>
      )}

      {/* Popover de Bienestar: la pestaña se despliega en Respira + Bitácora. */}
      {bienestarOpen && (showTabBar || SHELL_ESCRITORIO_ENABLED) && (
        <div className="no-print fixed inset-0 z-40" onClick={() => setBienestarOpen(false)} aria-hidden="true">
          {/* En lg el popover cuelga del header (su botón vive ahí), alineado
              con el borde derecho del contenedor de 1240: sin ese max(), en un
              monitor ancho quedaba a cientos de píxeles del botón. */}
          <div
            className={`absolute right-3 max-w-[820px] mx-auto bottom-[calc(3.5rem_+_env(safe-area-inset-bottom)_+_0.5rem)]${SHELL_ESCRITORIO_ENABLED ? " lg:bottom-auto lg:top-16 lg:right-[max(0.75rem,calc((100vw-1240px)/2+0.75rem))]" : ""}`}
            onClick={(e) => e.stopPropagation()}
          >
            <div role="menu" aria-label="Bienestar" className="w-52 bg-paper border border-edge rounded-tk-md shadow-tk-modal overflow-hidden">
              <button
                type="button"
                role="menuitem"
                onClick={() => { setBienestarOpen(false); abrirRespira('generico'); }}
                className="w-full flex items-center gap-2.5 px-3.5 py-3 text-left hover:bg-surface transition-colors"
              >
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-tk-sm bg-surface border border-edge/60 text-module-respira flex-shrink-0">
                  <Wind size={16} strokeWidth={1.7} className="anim-wind" />
                </span>
                <span className="min-w-0">
                  <span className="block text-small font-semibold text-ink font-sans leading-tight">Respira</span>
                  <span className="block text-micro text-ink-muted font-sans leading-tight">Una pausa entre turnos</span>
                </span>
              </button>
              <div className="h-px bg-edge" />
              <button
                type="button"
                role="menuitem"
                onClick={() => { setBienestarOpen(false); (session && profile?.perfil_completado) ? setAppState('bitacora') : handleLogin(); }}
                className="w-full flex items-center gap-2.5 px-3.5 py-3 text-left hover:bg-surface transition-colors"
              >
                <span className="inline-flex items-center justify-center w-8 h-8 rounded-tk-sm bg-surface border border-edge/60 text-module-bitacora flex-shrink-0">
                  <ClipboardList size={16} strokeWidth={1.7} className="anim-clipboard" />
                </span>
                <span className="min-w-0">
                  <span className="block text-small font-semibold text-ink font-sans leading-tight">Bitácora</span>
                  <span className="block text-micro text-ink-muted font-sans leading-tight">Tu registro reflexivo</span>
                </span>
              </button>
            </div>
          </div>
        </div>
      )}

      {showTabBar && !tecladoAbierto && <BottomTabBar items={tabItems} className={SHELL_ESCRITORIO_ENABLED ? "lg:hidden" : ""} />}
      {/* WhatsApp flotante de la web pública: solo el visitante, solo en las
          páginas que presentan MiPAE (no en Contacto, que ya ofrece los
          canales, ni dentro de una herramienta) y nunca encima del menú, el
          buscador o el tour. Él mismo se aparta de lo que tape. */}
      {navPublica && PIE_FLOTANTE[appState] && !menuOpen && !paletteOpen && !showTour && (
        <WhatsAppFlotante key={appState} idPie={PIE_FLOTANTE[appState]} />
      )}

    </div>
  );
}


